<template>
  <div id="booking-tree-grid" class="grid-view">
    <div class="main-content">
      <search-item
        :ref="searchItemConfigModule"
        :config-module="searchItemConfigModule"
        :is-collapse-list="!isFba"
        :grid-options="gridOptions"
        :grid-config-module="isFba ? '10012' : '150002'"
        :is-append-query="true"
        :reset="true"
        lob="AE"
        :custom-search-items="customSearchItems"
        :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
        :search-disabled="searchDisable"
        :record-expand-status="true"
        :input-enter-query="true"
        @click-more="value=>isAdvancedQuery=value"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
        @perConfigChange="value=>{perConfigName=value}"
        @refreshGrid="()=>{gridRefreshId+=1}"
        @defaultSearchItemsChange="value=>{defaultSearchItems=value}"
      >
        <div slot="operations">
          <el-button no="1" :disabled="!selectedJob || total <= 0 || hqDisabledViewDetail || (!isHQ && !validSingleSelect) || hierarchyDisabledViewDetail" type="success" @click="toLook()">{{ $t('common.btn.look') }}</el-button>
          <el-button no="2" :disabled="!(selectedJob && Number(selectedJob.jobState) === 0 && !JobUtils.isBlockJob(selectedJob)) || !validSingleSelect || !hierarchyValidSingleSelect" type="success" @click="toEdit()">{{ $t('common.btn.edit') }}</el-button>
          <el-button
            v-show="$checkPermission(['button_AEBooking_addAEBooking']) && !$checkPermission(['button_Job_importOrderExcel'])"
            no="3"
            :disabled="hqDisabledOperate"
            type="primary"
            style="margin-right: 5px"
            @click="toAdd()"
          >
            {{ $t('common.btn.new') }}
          </el-button>
          <el-dropdown
            v-show="$checkPermission(['button_AEBooking_addAEBooking']) && $checkPermission(['button_Job_importOrderExcel'])"
            no="exportOrderHandle"
            split-button
            type="primary"
            :disabled="hqDisabledOperate"
            style="margin:0 5px"
            @click="exportOrderHandle()"
            @command="p=>{exportOrderCommand=p;exportOrderHandle()}"
          >
            <span v-if="exportOrderCommand === $t('SeaExport.TemplateDownload')">{{ $t('CargoMsg.Cargo_DownImportTemplate') }}</span>
            <span v-else-if="exportOrderCommand !== $t('SeaExport.import')">{{ exportOrderCommand }}</span>
            <el-upload
              v-show="exportOrderCommand === $t('SeaExport.import')"
              :action="actionOrderUrl"
              :headers="headers"
              :show-file-list="false"
              accept=".xls, .xlsx"
              :before-upload="beforeOrderUpload"
              :on-success="uploadOrderSuccess"
              :on-error="handleError"
              :data="{branchId:$store.getters.currentOfficeId, lob:'AE'}"
              style="display: inline-block; margin-left: 5px"
            >
              <span style="color: white">{{ $t('SeaExport.import') }}</span>
            </el-upload>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.Add')">
                {{ $t('SeaExport.Add') }}
              </el-dropdown-item>
              <el-dropdown-item v-if="!isFba" :command="$t('SeaExport.import')">
                <el-upload
                  ref="uploadOrder"
                  :action="actionOrderUrl"
                  :headers="headers"
                  :show-file-list="false"
                  accept=".xls, .xlsx"
                  :before-upload="beforeOrderUpload"
                  :on-success="uploadOrderSuccess"
                  :on-error="handleError"
                  :data="{branchId:$store.getters.currentOfficeId, lob:'AE'}"
                  style="display: inline-block"
                >
                  <el-button slot="trigger" type="text" style="padding-left: 0px;color: #6F6F6F;text-align: left;width: 80px;">{{ $t('SeaExport.import') }}</el-button>
                </el-upload>
              </el-dropdown-item>
              <el-dropdown-item v-if="!isFba" :command="$t('CargoMsg.Cargo_DownImportTemplate')">
                {{ $t('CargoMsg.Cargo_DownImportTemplate') }}
              </el-dropdown-item>
              <!--FBA相关导入-->
              <el-dropdown-item v-if="isFba && $checkPermission(['button_FBAAeBooking_addAirFbaOrder'])" :command="$t('FbaJob.batchImportOrder')">
                <el-upload
                  ref="uploadBatchOrder"
                  :action="URL.seaExport.batchImportFbaJob"
                  :headers="headers"
                  :show-file-list="false"
                  accept=".xls, .xlsx"
                  :before-upload="beforeOrderUpload"
                  :on-success="uploadOrderSuccess"
                  :on-error="handleError"
                  :data="{branchId:$store.getters.currentOfficeId, deptId:$store.getters.currentDeptId, lob: 'FBA_AE'}"
                  style="display: inline-block"
                >
                  <el-button slot="trigger" type="text" style="padding-left: 0px;color: #6F6F6F;text-align: left;width: 80px;">
                    <span>
                      <img src="@/assets/fba-import.png">
                    </span>
                    {{ $t('FbaJob.batchImportOrder') }}
                  </el-button>
                </el-upload>
              </el-dropdown-item>
              <el-dropdown-item v-if="isFba && $checkPermission(['button_FBAAeBooking_addAirFbaOrder'])" :command="$t('FbaJob.downloadBatchImportTemplate')">
                <span>
                  <img src="@/assets/fba-download.png">
                </span>
                {{ $t('FbaJob.downloadBatchImportTemplate') }}
              </el-dropdown-item>
              <el-dropdown-item v-if="isFba && $checkPermission(['button_FBAAeBooking_addAirFbaOrder'])" :command="$t('FbaJob.importSingleOrder')">
                <el-upload
                  ref="uploadSingleOrder"
                  :action="URL.booking.airExport.fbaSingleImport"
                  :headers="headers"
                  :show-file-list="false"
                  accept=".xls, .xlsx"
                  :before-upload="beforeOrderUpload"
                  :on-success="uploadSingleOrderSuccess"
                  :on-error="handleError"
                  :data="{officeId:$store.getters.currentOfficeId, deptId:$store.getters.currentDeptId}"
                  style="display: inline-block"
                >
                  <el-button slot="trigger" type="text" style="padding-left: 0px;color: #6F6F6F;text-align: left;width: 80px;">
                    <span>
                      <img src="@/assets/fba-import.png">
                    </span>{{ $t('FbaJob.importSingleOrder') }}
                  </el-button>
                </el-upload>
              </el-dropdown-item>
              <el-dropdown-item v-if="isFba && $checkPermission(['button_FBAAeBooking_addAirFbaOrder'])" :command="$t('FbaJob.downloadSingleImportTemplate')">
                <span>
                  <img src="@/assets/fba-download.png">
                </span>
                {{ $t('FbaJob.downloadSingleImportTemplate') }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button v-show="$checkPermission(['button_AEBooking_addLCL'])" no="4" type="primary" :disabled="hqDisabledOperate" @click="toAdd({masterFlag: true})">{{ $t('SeaExport.AddHbl') }}</el-button>
          <el-button v-show="$checkPermission(['button_deleteAEJob'])" no="5" type="danger" :disabled="!validMultipleSelect" @click="toDelete()">{{ $t('SeaExport.Delete') }}</el-button>
          <el-button no="6" type="primary" :disabled="!validMultipleSelect" @click="batchUpdateSopStateHandler">{{ $t('SeaExport.EditSopStatus') }}</el-button>
          <el-button v-show="$checkPermission(['button_AEBooking_addAEBooking'])" no="7" type="primary" :disabled="!validMultipleSelect || !hierarchyValidMultipleSelect" @click="toCopy()">{{ $t('SeaExport.Clone') }}</el-button>
          <el-button no="8" type="success" :disabled="!validMultipleSelect" @click="printHandler">{{ $t('SeaExport.PrintBooking') }}</el-button>
          <!-- <el-button v-show="$checkPermission(['button_print_batchPrint'])" no="9" type="primary" :disabled="!btnInfo.batchSelectFlag || !validMultipleSelect" @click="onBatchPrint">{{ $t('SeaExport.BatchPrint') }}</el-button> -->
          <el-dropdown
            v-show="$checkPermission(['button_print_batchPrint'])"
            no="9"
            :disabled="!btnInfo.batchSelectFlag || !validMultipleSelect"
            split-button
            type="primary"
            style="margin: 0 5px;"
            @click="onBatchPrint($t('SeaExport.BatchPrint'))"
            @command="onBatchPrint"
          >
            {{ $t('SeaExport.BatchPrint') }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('queryJob.PrintByBusinessNumber')">{{ $t('queryJob.PrintByBusinessNumber') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button no="10" type="primary" :disabled="!validMultipleSelect" @click="toStatistics()">{{ $t('SeaExport.Statistics') }}</el-button>
          <el-dropdown
            no="11"
            :disabled="!validMultipleSelect"
            style="margin:0 5px;font-size: 12px"
            @command="batchHandle"
          >
            <el-button type="primary" :disabled="!btnInfo.batchSelectFlag || !validMultipleSelect">
              {{ $t('SeaExport.BatchProcessing') }}
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="$checkPermission(['button_AEBooking_BatchShutOut'])" :command="25">{{ $t('SeaExport.BatchShutOut') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_BatchPerCommit'])" :command="1">{{ $t('SeaExport.BatchPreSubmission') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_BatchCommit'])" :command="2">{{ $t('SeaExport.BatchCommit') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_BatchManagerSubmission'])" :command="3">{{ $t('SeaExport.BatchManagerSubmission') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_ReturnToOperater'])" :command="4">{{ $t('SeaExport.BatchReturnPreSubmission') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_Retract'])" :command="5">{{ $t('SeaExport.BatchReturnSubmit') }}</el-dropdown-item>
              <el-dropdown-item
                :disabled="!$checkPermission(['button_Charge_BatchUnlockReceivable'])"
                :command="12"
              >{{
                $t('SeaExport.BatchUnlockReceivableExpenses')
              }}
              </el-dropdown-item>
              <el-dropdown-item
                :disabled="!$checkPermission(['button_Charge_BatchUnlockPayable'])"
                :command="13"
              >{{
                $t('SeaExport.BatchUnlockPayableFees')
              }}
              </el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_Charge_BatchLockReceivable'])" :command="6">{{ $t('SeaExport.BatchLockingReceivableExpenses') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_Charge_BatchLockPayable'])" :command="7">{{ $t('SeaExport.BatchLockingPayableFees') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_FBAAeBooking_fbaBatchUpdateDestinationMsg']) && isFba" :command="8">{{ $t('AirExport.BulkEditingDestinationPortInformation') }}</el-dropdown-item>
              <el-dropdown-item
                v-if="$checkPermission(['button_AEBooking_BatchUpdateCustomJobType'])"
                :disabled="!$checkPermission(['button_AEBooking_BatchUpdateCustomJobType'])"
                :command="9"
              >{{ $t('SeaExport.BatchUpdateCustomJobType') }}
              </el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_AEBooking_BatchUpdateJobInfo'])" :command="17">{{ $t('SeaExport.BatchModifyBusiness') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_jobSopTab_BatchReplaceTemplate'])" :command="18">{{ $t('SeaExport.ReplaceSOPTemplatesInBatches') }}</el-dropdown-item>
              <el-dropdown-item v-if="useOrderCenterMode&&!isRegionalCommission" :command="19">{{ $t('queryJob.BatchInitiateCollaboration') }}</el-dropdown-item>
              <el-dropdown-item v-if="openMutualTrustConfig && !isFba" :command="20">{{ $t('SeaExport.BatchPushCharges') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_BatchFillGpExplain'])" :command="21">{{ $t('SeaExport.BatchFillGpExplain') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_JobBooking_BatchLockJob'])" :command="22">{{ $t('CargoMsg.Cargo_BatchServiceLocking') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_JobBooking_BatchUnlockJob'])" :command="23">{{ $t('CargoMsg.Cargo_UnlockServicesInBatches') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_JobBooking_BatchChangeBranch'])" :command="24">{{ $t('SeaExport.BatchChangeCompany') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_AEBooking_BatchPurchasePriceLock'])" :command="26">{{ $t('CargoMsg.Cargo_BatchPurchasePriceLock') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_AEBooking_BatchPurchasePriceUnLock'])" :command="27">{{ $t('CargoMsg.Cargo_BatchPurchasePriceUnLock') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_AEBooking_BatchSellingPriceUnLock'])" :command="28">{{ $t('CargoMsg.Cargo_BatchSellingPriceUnLock') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_AEBooking_BatchSellingPriceLock'])" :command="29">{{ $t('CargoMsg.Cargo_BatchSellingPriceLock') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_AEBooking_sendJdy']) && sendToPlatform" :command="30">{{ $t('SeaExport.batchSendJdy') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_AEBooking_unlockJdy']) && sendToPlatform" :command="31">{{ $t('SeaExport.batchUnlockGoodsDetails') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_AEBooking_BatchExportToImport'])" command="BatchExportToImport">{{ $t('queryJob.BatchExportToImport') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_ReturnReview'])" :command="32">{{ $t('CargoMsg.Cargo_BatchReturnPreApproval') }}</el-dropdown-item>
              <!-- 指令操作按钮 -->
              <template v-for="(item, index) in instructioinBtns">
                <el-dropdown-item
                  :key="'instruction' + index"
                  :disabled="!item.allowOperate"
                  :command="'instruction,' + item.tenantInstructionUuid"
                >
                  {{ $selectByLang(item.chineseName, item.englishName, item.japaneseName) }}
                </el-dropdown-item>
              </template>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown
            v-show="$checkPermission(['tab_Charge_chargeView'])"
            no="12"
            class="el-dropdown-spacing"
            split-button
            type="primary"
            :disabled="!validMultipleSelect"
            @click="chargeHandle"
            @command="p=>{chargeCommand=p;chargeHandle()}"
          >
            {{ chargeCommand }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.AddCharges')">{{ $t('SeaExport.AddCharges') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.EditCharges')">{{ $t('SeaExport.EditCharges') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.DeleteCharges')">{{ $t('SeaExport.DeleteCharges') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.ChargeImport')">{{ $t('SeaExport.ChargeImport') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown v-if="!($checkPermission(['role_hideAllExports']) && !$store.getters.isAdmin)" no="13" :disabled="!validMultipleSelect" split-button type="primary" class="el-dropdown-spacing" @click="exportHandle()" @command="p=>{exportCommand=p;exportHandle()}">
            {{ exportCommand }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.ExportToExcel')">{{ $t('SeaExport.ExportToExcel') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.OverseasAgentEDI')">{{ $t('SeaExport.OverseasAgentEDI') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.ExportWithSOPToExcel')">{{ $t('SeaExport.ExportWithSOPToExcel') }}</el-dropdown-item>
              <el-dropdown-item
                :disabled="!$checkPermission(['button_JobBooking_BatchExportCustoms'])"
                :command="$t('CargoMsg.Cargo_ExportCustomsDeclaration')"
              >{{ $t('CargoMsg.Cargo_ExportCustomsDeclaration') }}
              </el-dropdown-item>
              <el-dropdown-item
                :disabled="!$checkPermission(['button_JobBooking_BatchExport9610'])"
                :command="$t('SeaExport.Export9610File')"
              >{{ $t('SeaExport.Export9610File') }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- 导入装板信息 -->
          <el-dropdown v-if="$checkPermission(['button_AEBooking_importUnitLoadInfo'])" no="14" :disabled="hqDisabledOperate" class="el-dropdown-spacing" @command="unitLoadHandle">
            <el-button type="primary" :disabled="hqDisabledOperate">
              {{ $t('AirExport.ImportBoardInstallInfo') }}
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('AirExport.ImportBoardInstallInfo')">
                <el-upload
                  ref="uploadBoardInstallInfo"
                  :action="importUnitLoadInfoUrl"
                  :headers="headers"
                  :show-file-list="false"
                  accept=".xlsx"
                  :before-upload="beforeUnitLoad"
                  :on-success="uploadUnitLoadSuccess"
                  :on-error="handleError"
                  :data="{ branchId: $store.getters.currentOfficeId }"
                  style="display: inline-block"
                >
                  <el-button slot="trigger" type="text" style="padding-left: 0px;color: #6F6F6F;text-align: left;width: 80px;" @click="onImportBoardClick">{{ $t('AirExport.ImportBoardInstallInfo') }}</el-button>
                </el-upload>
              </el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.TemplateDownload')">{{ $t('SeaExport.TemplateDownload') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- LTS同步-->
          <el-dropdown
            v-show="toExoSystemYGSH && $checkPermission(['button_Charge_ltsSync'])"
            :disabled="!validMultipleSelect"
            style="margin:0 5px;font-size: 12px"
            @command="batchLtsSyncHandle"
          >
            <el-button type="primary" :disabled="!btnInfo.batchSelectFlag">
              {{ $t('CargoMsg.Cargo_SynchronousCloudPlatform') }}
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="1">{{ $t('SeaExport.receivable') }}</el-dropdown-item>
              <el-dropdown-item :command="2">{{ $t('SeaExport.payable') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </search-item>
      <div class="section grid-wrapper">
        <!-- 空运订舱 150002-->
        <cargo-ag-grid-wrapper
          v-if="!isFba"
          config-module="150002"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-options="gridOptions"
          :side-bar="{ toolPanels: ['columns', 'filter'], visible: false }"
          :column-defs="finalColumnDefs"
          :sum-column-defs="sumColumnDefs"
          :row-data="rowData"
          :grid-params.sync="gridParams"
          :check-main-record="false"
          :deselect-main-record="false"
          :show-selected-color="false"
          style="width: 100%;"
          :show-row-groups="dataListDragGroup"
          :darg-group-show-column-def="dargGroupShowColumnDef"
          @gridReady="onGridReady"
          @columnRowGroupChanged="() => { this.$refs[searchItemConfigModule].clickCollapseList() }"
        />
        <!-- 空运头程 10012-->
        <cargo-ag-grid
          v-if="isFba"
          config-module="10012"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-options="gridOptions"
          :side-bar="{ toolPanels: ['columns', 'filter'], visible: false }"
          :column-defs="fbaColumnDefs"
          :row-data="rowData"
          :grid-params.sync="gridParams"
          :check-main-record="false"
          :deselect-main-record="false"
          :show-selected-color="false"
          style="width: 100%;"
          @gridReady="onGridReady"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          v-show="!appendQuery"
          :total="total"
          :config-module="isFba ? '10012' : '150002'"
          :page-count="pageCount"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          :selected-row-count="isFba ? 0 : selectedRowCount"
          @pagination="()=>{if(total>0){toQueryByPage()}}"
        />
        <div v-show="appendQuery" class="pagination-container">
          <el-pagination
            style="text-align: left;"
            :total="total"
            layout="total"
          />
        </div>
      </div>
    </div>
    <!-- 状态修改弹窗 -->
    <state-dialog
      v-if="stateDialog.visible"
      :visible.sync="stateDialog.visible"
      :rows="stateDialog.rows"
      :tracking-list="stateDialog.trackingList"
      @callback="toQuery()"
    />
    <!-- 批量退关弹窗 -->
    <el-dialog
      v-if="shutOutDialog.visible"
      v-el-drag-dialog
      no="21"
      :visible.sync="shutOutDialog.visible"
      :title="$t('Message.Warning')"
      width="400px"
      :close-on-click-modal="false"
    >
      <div style="display: flex;flex-direction: column;padding-left:30px">
        <span style="line-height: 40px;">{{ $t('Message.PleaseConfirmTheShutOut') }}</span>
        <span style="line-height: 18px;">{{ shutOutDialog.shutOutTip1 }}</span>
        <span style="line-height: 18px;">{{ shutOutDialog.shutOutTip2 }}</span>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button no="22" type="primary" @click="hasChargeShutoutHandler()">{{ $t('Message.HasChargeToShutOut') }}</el-button>
        <el-button no="23" :style="{ display: shutOutDialog.shutOutButtonShow2 }" type="primary" @click="noHasChargeShutoutHandler()">{{ $t('Message.NoChargeToShutOut') }}</el-button>
        <el-button no="24" @click="shutOutDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 批量转船弹窗 -->
    <el-dialog
      v-if="transshipDialog.visible"
      v-el-drag-dialog
      no="25"
      :visible.sync="transshipDialog.visible"
      :title="$t('SeaExport.BatchVessel')"
      width="360px"
      :close-on-click-modal="false"
    >
      <el-form label-width="85px" label-position="left">
        <el-form-item :label="$t('Payment.vessel')">
          <cargo-advance-select
            v-show="!transshipDialog.isDBFlag"
            no="26"
            style="width:195px;"
            filterable
            :select-type="selectTypeNames.basic_data_Vessel"
            :default-value="transshipDialog.txtVessel"
            :callback-params="{key:'txtVessel'}"
            @parentCallBack="onVesselSelectionChange"
          />
          <el-input v-show="transshipDialog.isDBFlag" v-model="transshipDialog.txtVessel_1" no="27" style="width:195px;" />
        </el-form-item>
        <el-form-item :label="$t('Payment.voyage')">
          <el-select v-show="!transshipDialog.isDBFlag" v-model="transshipDialog.txtVoyage" no="28" style="width:195px;">
            <el-option
              v-for="(item) in transshipDialog.voyages"
              :key="item.voyageId"
              :label="item.voyageNo"
              :value="item.voyageNo"
            />
          </el-select>
          <el-input v-show="transshipDialog.isDBFlag" v-model="transshipDialog.txtVoyage_1" no="29" style="width:195px;" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ShippingCompany')">
          <cargo-advance-select
            no="30"
            filterable
            style="width:195px;"
            options-width="200px;"
            :method-params="{seaCmp:true}"
            :select-type="selectTypeNames.basic_data_Company"
            :default-value="transshipDialog.txtCarrierId||''"
            @parentCallBack="p=>transshipDialog.txtCarrierId=p.cmpIdx"
          />
        </el-form-item>
        <el-form-item :label="$t('queryJob.dateOfDeparture')">
          <el-date-picker v-model="transshipDialog.dfETD" no="31" type="date" value-format="yyyy-MM-dd" style="width:195px;" />
        </el-form-item>
        <el-form-item :label="$t('queryJob.bookingAgent')">
          <cargo-advance-select
            no="32"
            filterable
            style="width:195px;"
            options-width="200px;"
            :method-params="{bookingAgent:true}"
            :select-type="selectTypeNames.basic_data_Company"
            :default-value="transshipDialog.txtBookingAgent||''"
            @parentCallBack="p=>transshipDialog.txtBookingAgent=p.cmpIdx"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button no="33" type="primary" @click="transShipClickHandler">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="34" @click="transshipDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 批量修改整拼类型弹窗 -->
    <el-dialog
      v-if="fullSpellTypeDialog.visible"
      v-el-drag-dialog
      no="35"
      :visible.sync="fullSpellTypeDialog.visible"
      :title="$t('SeaExport.BatchUpdateType')"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form label-width="120px" label-position="left">
        <el-form-item :label="$t('queryJob.BatchOfWholeSplicingType')" class="custom">
          <el-select v-model="fullSpellTypeDialog.containerLoadType" no="36" style="width:190px">
            <el-option
              v-for="(item,index) in fullSpellTypeDialog.containerLoadTypes"
              :key="index"
              :label="item.chineseName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button no="37" type="primary" @click="fullSpellTypeClickHandler">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="38" @click="fullSpellTypeDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!-- 统计弹窗 -->
    <el-dialog
      v-if="statisticsDialog.visible"
      v-el-drag-dialog
      no="39"
      :visible.sync="statisticsDialog.visible"
      :title="$t('SeaExport.Statistics')"
      :width="$selectByLang('360px', '445px')"
      :close-on-click-modal="false"
    >
      <el-form :label-width="$selectByLang('85px', '170px')" label-position="left">
        <el-form-item :label="$t('SeaExport.Slaves')" class="custom">
          <el-input v-model="statisticsDialog.txtSlaves" no="40" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Master')" class="custom">
          <el-input v-model="statisticsDialog.txtMaster" no="41" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.TotalTickets')" class="custom">
          <el-input v-model="statisticsDialog.txtCount" no="42" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.CommissionedNumberOfPackages')" class="custom">
          <el-input v-model="statisticsDialog.txtQuantityContract" no="50" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.CommissionedGrossWeight')" class="custom">
          <el-input v-model="statisticsDialog.txtWeightContract" no="51" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.CommissionedVolume')" class="custom">
          <el-input v-model="statisticsDialog.txtCubageContract" no="52" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.CommissionedChargedWeight')" class="custom">
          <el-input v-model="statisticsDialog.txtChargeWeightContract" no="53" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ActualQuantity')" class="custom">
          <el-input v-model="statisticsDialog.txtQuantityActual" no="43" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_ActualWeight')" class="custom">
          <el-input v-model="statisticsDialog.txtWeightActual" no="44" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ActualVolume')" class="custom">
          <el-input v-model="statisticsDialog.txtCubageActual" no="45" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('queryJob.actualChargedWeight')" class="custom">
          <el-input v-model="statisticsDialog.txtChargeWeightActual" no="46" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.CustomerCount')" class="custom">
          <el-input v-model="statisticsDialog.txtCustomerCount" no="47" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.SpecifyAgentNumber')" class="custom">
          <el-input v-model="statisticsDialog.txtdesignationAgentNum" no="48" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label-width="0" class="custom">
          <el-checkbox v-model="statisticsDialog.containShutOutJob" @change="handleStatistics(true)">{{ $t('SeaExport.ContainShutOutJob') }}</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button no="49" @click="statisticsDialog.visible = false">{{ $t('Message.Close') }}</el-button>
      </div>
    </el-dialog>
    <!-- 新增费用弹窗 -->
    <add-charge-detail-dialog
      v-if="addChargeDetailDialog.visible"
      :visible.sync="addChargeDetailDialog.visible"
      :selected-jobs="addChargeDetailDialog.selectedJobs"
      :charge-type="addChargeDetailDialog.type"
      :lob="isFba ? 'FBA_AE' : 'AE'"
      :location="location"
      :selected-scheme="addChargeDetailDialog.selectedScheme"
      @toChangeSchema="toChangeSchema"
    />
    <!-- 编辑费用弹窗 -->
    <edit-charge-detail-dialog
      v-if="editChargeDetailDialog.visible"
      :visible.sync="editChargeDetailDialog.visible"
      :selected-jobs="editChargeDetailDialog.selectedJobs"
      :charge-type="editChargeDetailDialog.chargeType"
      :lob="isFba ? 'FBA_AE' : 'AE'"
    />
    <!-- 删除费用弹窗 -->
    <delete-charge-detail-dialog
      v-if="deleteChargeDetailDialog.visible"
      :visible.sync="deleteChargeDetailDialog.visible"
      :selected-jobs="deleteChargeDetailDialog.selectedJobs"
      :charge-type="deleteChargeDetailDialog.chargeType"
      :lob="isFba ? 'FBA_SE' : 'SE'"
    />
    <!-- 费用导入弹窗 -->
    <charge-scheme-batch-dialog
      v-if="chargeSchemeBatchDialog.visible"
      :visible.sync="chargeSchemeBatchDialog.visible"
      :selected-jobs="chargeSchemeBatchDialog.selectedJobs"
      :job="chargeSchemeBatchDialog.job"
      :need-check-range="chargeSchemeBatchDialog.needCheckRange"
      :lob="chargeSchemeBatchDialog.lob"
      :is-sea="chargeSchemeBatchDialog.isSea"
      :original-condition="chargeSchemeBatchDialog.originalCondition"
      :charge-scheme-is-approved="chargeSchemeBatchDialog.chargeSchemeIsApproved"
      :location="location"
      :charge-type="chargeSchemeBatchDialog.chargeType"
      :source="chargeSchemeBatchDialog.source"
      @selectedSchemeHandler="handleSelectedScheme"
    />
    <!-- 多条业务 配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      ref="batchCheckingWindow"
      :visible.sync="batchCheckingWindow.visible"
      :allow-partial-check-pass="batchCheckingWindow.allowPartialCheckPass"
      :lob="lob"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
    />
    <!-- 单条业务 配置规则验证弹窗-->
    <checking-window
      v-if="checkingWindow.visible"
      :visible.sync="checkingWindow.visible"
      :lob="lob"
      :job="job"
      :check-node="checkingWindow.checkNode"
      :call-back="checkingWindow.callBack"
      :call-back2="checkingWindow.callBack2"
    />
    <!-- 订舱打印-->
    <booking-print-window :jobs="bookingPrintWindow.jobs" :visible.sync="bookingPrintWindow.visible" @print="sendSiteOpPrint" @sendSiteOpCallBack="sendSiteOpCallBack" />
    <!-- 批量修改目的港信息 -->
    <el-dialog
      v-if="podInfo.visible"
      v-el-drag-dialog
      :visible.sync="podInfo.visible"
      :title="$t('AirExport.BulkEditingDestinationPortInformation')"
      width="700px"
      :close-on-click-modal="false"
    >
      <div style="display: flex; flex: 1;">
        <el-form label-width="120px" label-position="left" style="padding-right: 20px">
          <el-row>
            <el-col :span="12">
              <el-form-item :title="$t('AirExport.OverseasWarehouseNonAmazonWarehouse')" :label="$t('SeaExport.EstimatedDeliveryToWarehouseTime')">
                <el-date-picker
                  v-model="podInfo.estimatedDeliveryToWarehouseTime"
                  no="45"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :title="$t('AirExport.OverseasWarehouseNonAmazonWarehouse')" :label="$t('SeaExport.ActualDeliveryToWarehouseTime')">
                <el-date-picker
                  v-model="podInfo.deliveryTime"
                  no="46"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('SeaExport.EstimatedDeliveryToCustomersWarehouseTime')">
                <el-date-picker
                  v-model="podInfo.destPortDeliveryTime"
                  no="47"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('SeaExport.ActualDeliveryToCustomersWarehouseTime')">
                <el-date-picker
                  v-model="podInfo.deliveryCompletionDate"
                  no="48"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('AirExport.EstimatedDeliveryTime')">
                <el-date-picker
                  v-model="podInfo.estDeliveryTime"
                  no="49"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('AirExport.ActualDeliveryTime')">
                <el-date-picker
                  v-model="podInfo.actDeliveryTime"
                  no="50"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="confirmBatchModifyPodInfo()">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="podInfo.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- Lts批量同步费用 -->
    <lts-batch-sync
      ref="ltsBatchSyncCharge"
      :visible.sync="ltsWindow.visible"
      :keys="ltsWindow.keys"
    />
    <!-- 批量提交、批量同意、批量拒绝 错误弹窗-->
    <batch-submit-or-approve-dialog
      :visible.sync="batchSubmitOrApproveDialog.visible"
      :row-data="batchSubmitOrApproveDialog.rowData"
      :is-submit="true"
    />
    <!-- 批量修改业务弹窗 -->
    <batch-modify-business-dialog
      :visible.sync="batchModifyBusinessDialog.visible"
      :job-keys="batchModifyBusinessDialog.jobKeys"
      :job-list="batchModifyBusinessDialog.jobList"
      :lob="batchModifyBusinessDialog.lob"
      @callback="batchModifyBusinessCallback"
    />
    <!-- 批量修改业务SOP模板弹窗 -->
    <change-sop-template-dialog
      :visible.sync="changeSopTemplateDialog.visible"
      :lob="lob"
      :job-list="changeSopTemplateDialog.jobList"
      @reload="reload"
    />
    <!-- 批量协作弹窗 -->
    <batch-cooperation-dialog :visible.sync="batchCooperationDialog.visible" :job-list="batchCooperationDialog.jobList" :order-center-branch="orderCenterBranch" />
    <!-- 下载导入模板弹窗 -->
    <download-import-template-dialog
      :visible.sync="downloadImportTemplateDialog.visible"
      :lob="downloadImportTemplateDialog.lob"
    />
    <!-- 业务申请审批流 实质是：job-apply-dialog-->
    <job-work-flow-apply-dialog
      v-if="workFlowApplyDialog.visible"
      :visible.sync="workFlowApplyDialog.visible"
      :title="$t('CargoMsg.Cargo_Approving')"
      :process-info="workFlowApplyDialog.documentProcess"
      :records="workFlowApplyDialog.approvalCommentsRecords"
      type="approve"
      :doc-id="workFlowApplyDialog.documentProcess.docId"
      :document-config-id="workFlowApplyDialog.documentProcess.documentConfigId"
      @close="workFlowApplyDialog.visible=false"
      @closeAndRefresh="()=> {
        workFlowApplyDialog.visible = false
        toQueryByPage()
      }"
    />
    <!-- 导入装板信息 -->
    <el-dialog
      v-if="unitLoadResult.visible"
      :title="$t('Message.Prompt')"
      :visible.sync="unitLoadResult.visible"
      :close-on-click-modal="false"
      width="460px"
    >
      <div v-if="unitLoadResult.isSuccess" style="display: flex;align-items: center;">
        <img :src="trueIcon" style="width: 25px;height: 25px;margin: 0 10px;">
        <div style="margin-left: 5px;">
          <div style="font-size: 16px;margin-bottom: 10px;">{{ $t('CargoMsg.Cargo_ImportingData') }}</div>
          <div style="color:red">{{ $t('AirExport.AsyncUploadLogView') }}</div>
        </div>
      </div>
      <div v-else style="display: flex;align-items: center;">
        <img :src="falseIcon" style="width: 25px;height: 25px;margin: 0 10px;">
        <p style="margin-left: 5px;">{{ $t('AirExport.PleaseImportCorrectTemplate') }}（<a href="#" style="color:blue" @click="downloadImportContainerTemplate">{{ $t('AirExport.ClickDownloadTemplate') }}</a>）</p>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="unitLoadResult.visible=false">{{ $t('Message.Confirm2') }}</el-button>
      </span>
    </el-dialog>
    <!-- GP说明-->
    <add-gp-explain-dialog
      v-if="gpExplain.visible"
      :type="gpExplain.type"
      :visible.sync="gpExplain.visible"
      :job-uuids="gpExplain.jobUuids"
    />
    <!-- 批量更换分公司弹窗-->
    <batch-modify-branch-dialog
      v-if="modifyBranchDialog.visible"
      :visible.sync="modifyBranchDialog.visible"
      :job-keys="modifyBranchDialog.jobKeys"
      @reload="reload"
    />
    <!-- 批量修改自定义业务类型弹窗 -->
    <el-dialog
      v-if="customJobTypeDialog.visible"
      v-el-drag-dialog
      :visible.sync="customJobTypeDialog.visible"
      :title="$t('SeaExport.BatchUpdateCustomJobType')"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form label-width="120px" label-position="left">
        <el-form-item :label="$t('SeaExport.CustomJobType')+':'">
          <cargo-advance-select
            :select-type="selectTypeNames.basic_data_CutomJobType"
            filterable
            :method-params="{type: SystemConstants.AE.code, fba:isFba ,active: true}"
            :default-value="customJobTypeDialog.customJobType"
            @parentCallBack="p=>{customJobTypeDialog.customJobType=p.value}"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="customJobTypeClickHandler">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="customJobTypeDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 应收应付类型选择弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="chargeTypeDialog.visible"
      :title="$t('CargoMsg.Cargo_AddCostType')"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div style="margin: 30px 30px;">
        <el-radio-group v-model="chargeTypeDialog.type" size="small">
          <el-radio :label="1">{{ $t('CargoMsg.Cargo_Receivable') }}</el-radio>
          <el-radio :label="2">{{ $t('CargoMsg.Cargo_Dues') }}</el-radio>
          <el-radio :label="0">{{ $t('CargoMsg.Cargo_ARAP') }}</el-radio>
        </el-radio-group>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="onChargeTypeDialogConfirm">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="chargeTypeDialog.visible = false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <job-return-review-dialog
      v-show="returnReviewDialog.visible"
      :visible.sync="returnReviewDialog.visible"
      lob="AE"
      :selected-jobs="returnReviewDialog.selectedJobs"
      srouce="list"
      @confirm="toQuery"
    />
    <!-- 批量出口转进口 -->
    <batch-export-to-import-window ref="batchExportToImportWindow" />
    <!-- 同租户交叉委托窗口 -->
    <tenant-entrust-window ref="tenantEntrustWindow" @instructionCallback="onInstructionCallback" />
  </div>
</template>

<script>

import CargoGridShowBigContent from '@/components/Cargo/grid/cargoGridShowBigContent'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import addChargeDetailDialog from '@/views/cargo/v0/SeaExport/components/booking/addChargeDetailDialog'
import chargeSchemeBatchDialog from '@/views/cargo/v0/SeaExport/components/booking/chargeSchemeBatchDialog'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { deepClone } from '@/utils'
import { DocumentManage, stopBubble, stringToBool } from '@/utils/commonUtil'
import hblIcon from '@/assets/h_resize.png'
import jobDetailIcon from '@/assets/job-detail.png'
import mblIcon from '@/assets/m_resize.png'
import * as NumberUtils from '@/utils/NumberUtils'
import { ensureExecuteSuccess } from '@/utils/commonUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import URL from '@/api/urlTranslator'
import {
  batchDeleteJob,
  checkChargeStateVerify,
  batchPreCommit,
  batchCommit,
  getVoyagesByVesselId,
  batchTransship,
  checkJobHasContainer,
  updateJobContainerLoadType,
  statisticsJobs,
  batchCheckRemoveCharge,
  batchRemoveCharge,
  splitMaster,
  getTrackingListByLob,
  getTrackingDetailByTrackingUuid,
  canBatchShutout,
  batchShutout,
  isContractExpiredForbidCreateJob,
  getJobSopStates,
  commit,
  getChargeIsInvoice,
  saveJobInfo, calculateProfit, printProfit
} from '@/api/seaExport/seaExportJob'

import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import * as TrackingConstants from '@/class/cargo/model/parameters/TrackingConstants'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { cacheName, cache } from '@/utils/cacheManager'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as BookingTerm from '@/class/cargo/model/parameters/BookingTerm'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import { getFilterCacheList, getObjectByCache, operateBranchIsOptional } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow'
import CheckingWindow from '@/components/Cargo/Job/CheckingManager/CheckingWindow'
import { exportExcel } from '@/utils/tableDataExportUtils'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import {
  advancedQuery,
  queryLastModifyBookingByDay, updateBatchPriceLockFunc, updatebatchPriceLockFunc
} from '@/api/AirExport/airExportJob'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import { PrintUtils } from '@/utils/PrintUtils'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import { getDocumentType } from '@/api/documentType'
import { StimulSoftUtil } from '@/class/cargo/model/utils/StimulSoftUtil'
import { PrintTemplateManager } from '@/class/cargo/model/utils/PrintTemplateManager'
import * as ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { sendSapMessageByJob } from '@/api/clearing/charge'
import StrUtils from '@/utils/StrUtils'
import { Company } from '@/class/model/mdm/Company'
import { getCustomerTypeList } from '@/api/basicData/customerType'
import {
  batchManagerCommit,
  batchModifyChargeLockStatus, batchModifyPodInfo,
  batchReturnSubmit,
  getJobByUuid,
  validateChargeLockStatus,
  syncChargeConfirmBatch,
  export9610FileUrl, updateJobCustomJobType, validateJobForDelete
} from '@/api/booking/job'
import { getToken } from '@/utils/auth'

import bookingPrintWindow from './tabs/components/bookingPrintWindow'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import * as DocumentConstants from '@/class/cargo/model/parameters/DocumentConstants'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import DateUtils from '@/utils/dateUtils'
import { SopUtil } from '@/class/cargo/model/utils/SopUtil'
import LtsBatchSync from '@/components/Cargo/Job/ltsBatchSync.vue'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { getCacheListByKey } from '@/utils/basicDataCache'
import editChargeDetailDialog from '@/views/cargo/v0/SeaExport/components/booking/editChargeDetailDialog.vue'
import { recordSelectedStatus } from '@/utils/agGrid'
import { SalesUtil } from '@/class/cargo/model/utils/SalesUtil'
import StateDialog from '@/components/Cargo/Job/StateDialog'
import WorkflowConstants, {
  APPLICATION_DIMENSION_BILL_PAYMENT, APPLICATION_DIMENSION_JOB_CHARGE,
  Job_CHARGE
} from '@/class/cargo/model/parameters/WorkflowConstants'
import batchSubmitOrApproveDialog from '@/components/Cargo/Common/Wrokflow/batchSubmitOrApproveDialog'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import DeleteChargeDetailDialog from '@/views/cargo/v0/SeaExport/components/booking/deleteChargeDetailDialog.vue'
import BatchModifyBusinessDialog from '@/views/cargo/v0/SeaExport/components/booking/batchModifyBusinessDialog.vue'
import { IMPERIAL_1, LOG_AE_AIR_BOOKING, YES } from '@/class/cargo/model/parameters/SystemConstants'
import ChangeSopTemplateDialog from '@/components/Cargo/Job/booking/tabs/changeSopTemplateDialog'
import BatchCooperationDialog from '@/components/Cargo/Job/BatchCooperationDialog'
import DownloadImportTemplateDialog
  from '@/views/cargo/v0/SystemMaintenance/components/orderTemplateConfig/downloadImportTemplateDialog'
import JobWorkFlowApplyDialog from '@/components/Cargo/Common/Wrokflow/jobApplyDialog'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import lodash from 'lodash'
import BookingTreeGridMixin from '@/mixin/BookingTreeGridMixin'
import trueIcon from '@/assets/true-x32.png'
import falseIcon from '@/assets/false-x32.png'
import AddGpExplainDialog from '@/components/Cargo/Job/addGpExplainDialog.vue'
import jc from 'json-cycle'
import { exportCustomsInfoFunc } from '@/api/seaExport/customsInfo'
import convertResToBlob from '@/utils/convertResToBlob'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper'
import BatchModifyBranchDialog from '@/components/Cargo/Job/batchModifyBranchDialog.vue'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import BatchExportToImportWindow from '@/views/cargo/v0/AirExport/components/AeBooking/BatchExportToImportWindow'
import jobReturnReviewDialog from '@/components/Cargo/Job/jobReturnReviewDialog.vue'
import { getInstructions } from '@/api/sysManage/uiCustom'
import TenantEntrustWindow from '@/components/Cargo/Job/tenantEntrustWindow/index'

export default {
  name: 'BookingTreeGrid',
  components: {
    jobReturnReviewDialog,
    ChangeSopTemplateDialog,
    BatchModifyBusinessDialog,
    DeleteChargeDetailDialog,
    CargoAdvanceSelect,
    bookingPrintWindow,
    LtsBatchSync,
    CargoGridShowBigContent,
    searchItem,
    cargoTemplateSelectorDialog,
    addChargeDetailDialog,
    chargeSchemeBatchDialog,
    editChargeDetailDialog,
    BatchCheckingWindow,
    CheckingWindow,
    StateDialog,
    batchSubmitOrApproveDialog,
    BatchCooperationDialog,
    DownloadImportTemplateDialog,
    JobWorkFlowApplyDialog,
    AddGpExplainDialog,
    cargoAgGridWrapper,
    BatchModifyBranchDialog,
    BatchExportToImportWindow,
    TenantEntrustWindow
  },
  mixins: [BookingTreeGridMixin],
  props: {
    context: {
      type: Object,
      required: true
    },
    isQuery: {
      type: Boolean,
      default: false
    },
    isFba: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      appendQuery: false, // 追加查询
      loading: null,
      URL,
      sessionId: getToken(),
      SystemConstants,
      trueIcon,
      falseIcon,
      manageAuditStatus: 0,
      commonInfo: {
        operateNameCode: -1, // 操作code
        isPreCommit: false, // 预提交
        isPrintCommit: false, // 打印利润分析表是否提交业务
        allSubmitFcl: false, // 主票提交时是否提交全部拼票业务
        reqInputCharge: false, // 是否必录费用
        checkEstimate: false, // 预估是否验证过
        isCopySellingCharge: false, // 复制应付费用
        needConfirmDuplicateWarehouseNo: false, // 是否要验证进仓编号重复
        synchronousShipperCodeAndConsigneeCodeAndNotifyCode: false, // 提单收发通代码是否同步至基本页签收发通代码
        isPrint: true,
        isPrintOpr: false, // 是否打印操作（由于打印和提交中最后调用的有相同的方法，因此用改参数区分开来）
        detailTitleShowModel: 0, // 标题显示模式
        printEvent: null,
        showMessage: true,
        returnSend: false
      },
      toExoSystemYGSH: false, // 阳光速航
      salesCanSeeBookingAgent: false,
      ltsWindow: {
        visible: false,
        keys: [],
        anyBool: false
      },
      btnInfo: {
        enableBtnSplit: false, // 批量拆分主票
        batchSelectFlag: false, // 批量操作
        label: {
          shutOutLabel: this.$t('SeaExport.ShutOut'),
          btnEntrustment: this.$t('SeaExport.Consignation'), // 内部委托按钮
          btnProfit: this.$t('SeaExport.PrintFclProfit'),
          btnShutout: this.$t('SeaExport.ShutOut')
        },
        enabled: {
          btnProfit: true
        },
        visible: {
          sendBackBookingButton: false, // 发送订舱数据
          printFclProfit: false, // 整箱利润打印
          printLclProfit: false, // 拼箱利润打印
          cancelReturn: false, // 退回操作
          printReturn: false, // 撤回
          printReturnOperate: false,
          btnSubmit: false,
          btnManagerSubmit: false,
          btnPreSubmit: false,
          btnManagerAuditSubmit: false // 审核
        },
        privilege: {
          btnEntrustment: null, // 委托按钮是否禁用
          btnShutout: false, // 退关按钮是否可用
          consignationEnable: false, // 内部委托按钮是否可用
          consignationCrossEnable: false, // 跨分公司委托是否可用
          crossMoreSign: false,
          button_SEBooking_cancelShutout: this.$checkPermission(['button_SEBooking_cancelShutout']),
          button_JobBooking_Submit: this.$checkPermission(['button_JobBooking_Submit']),
          button_JobBooking_PreSubmit: this.$checkPermission(['button_JobBooking_PreSubmit']),
          button_JobBooking_ManagerSubmit: this.$checkPermission(['button_JobBooking_ManagerSubmit']),
          button_JobBooking_ManagerAuditSubmit: this.$checkPermission(['button_JobBooking_ManagerAuditSubmit']),
          button_JobBooking_PrintProfit: this.$checkPermission(['button_JobBooking_PrintProfit']),
          button_SEBooking_cancelProfit: this.$checkPermission(['button_SEBooking_cancelProfit']),
          button_JobBooking_Retract: this.$checkPermission(['button_JobBooking_Retract']),
          button_JobBooking_ReturnToOperater: this.$checkPermission(['button_JobBooking_ReturnToOperater'])
        }
      },
      customJobTypeDialog: {
        visible: false,
        jobKeys: [],
        jobList: [],
        customJobType: ''
      },
      currentRow: {},
      searchDisable: false,
      selectTypeNames: TYPE_NAMES,
      isAdvancedQuery: false, // 是否为高级查询
      isQuickQuery: false, // 是否为近期快捷查询
      ticketsMustBeVoted: false, // 当整拼类型 为自拼箱时  判断开关是否开启 拒绝提交
      useCheckRule: false, // 是否启用验证规则
      allowPartialCheckPass: false, // CARGO-1677，批量提交业务时，部分业务不符合校验规则导致全部业务都无法提交
      checkApChargeVerify: false, // 业务预提交时是否验证应付费用已全部审核
      editVessel: '', // //订舱性质
      filter: {
        pageNum: 1,
        pageSize: 20,
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      filterJson: {},
      total: 0,
      pageCount: 0,
      JobUtils,
      selectedJob: null,
      perConfigName: '',
      gridRefreshId: 0,
      arSettlementUnitOptional: false,
      sendToPlatform: false,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.BusinessNo'),
          colId: 'jobNo',
          field: 'jobNo',
          width: 240,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: params => {
              const currentJob = params.data
              if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
                return false
              }
              return true
            },
            innerRenderer: params => {
              const currentJob = params.data
              if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
                const icon = Number(currentJob.dataType) === 5 ? hblIcon : mblIcon
                return `<span><img src="${icon}" height="16" width="16" style="vertical-align: sub;margin-right:3px;" />${params.value}</span>`
              }
              // const methodPath = this.documentManage.getPath('showBusinessInfo')
              return `<span>${params.value}</span>`
            }
          }
        },
        onRowDataChanged: event => {
          this.onGridSelectionChanged(event)
          if (!this.isFba) {
            this.$refs[this.searchItemConfigModule].clickCollapseList()
          }
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onGridCellFocused(event)
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.onGridRowSelected(event)
          if (event.node.isSelected()) {
            this.onRowClicked(event)
          }
        },
        onSelectionChanged: event => {
          this.onGridSelectionChanged(event)
        },
        onCellDoubleClicked: event => {
          if (!event.data) {
            return
          }
          if (this.hierarchyViewList && !this.hierarchyViewDetail) {
            if (!this.matchOwnerBranch(event.data)) {
              return
            }
          }
          if (this.hqViewAllList) {
            const curOfficeId = this.$store.getters.currentOfficeId
            const data = event.data
            if (curOfficeId === 1) {
              if (!this.hqViewAllDetail) {
                return
              }
            } else {
              let needCheck = true
              if (!this.isZy && this.hierarchyViewDetail) {
                if (this.childOfficeIds.includes(data.opOffice) || this.childOfficeIds.includes(data.salesOffice)) {
                  needCheck = false
                }
              }
              if (needCheck) {
                if (data.opOffice !== curOfficeId && data.salesOffice !== curOfficeId && !this.mactchCooperateBranch(data.cooperatebranch, this.$store.getters.currentOffice)) {
                  return
                }
              }
            }
          }
          this.toLook(event.data)
        }, onRowClicked: this.onRowClicked,
        getRowStyle: (params) => {
          if (!params.data) {
            return {}
          }
          const row = params.data
          const { colorSettings, colorType } = this
          if (colorType) {
            return JobUtils.financeColor(row)
          } else if (row.hasOwnProperty('dataType') && (Number(row.dataType) === 1 || Number(row.dataType) === 2)) {
            if (Object.prototype.hasOwnProperty.call(row, 'blocked') &&
              Object.prototype.hasOwnProperty.call(row, 'specialApproval') &&
              JobUtils.isBlockJob(row)) {
              return { 'background': colorSettings.find(item => item.colorKey === 'isBlocked').colorValue }
            } else {
              const jobState = String(row.jobState) || ''
              for (const stateColor of colorSettings) {
                if (jobState === stateColor.colorKey) {
                  return { 'background': stateColor.colorValue }
                }
              }
            }
          }
          return {}
        },
        defaultColDef: {
          resizable: true
        },
        // onSortChanged: (event) => {
        //   // this.$logger.log('onSortChanged-event', event)
        //   if (this.rowDataBeforeSort && this.rowDataBeforeSort.length !== this.rowData.length) {
        //     this.rowDataBeforeSort = this.rowData
        //   }
        //   if (!event.api.getSortModel().length) {
        //     this.rowData = this.rowDataBeforeSort
        //     this.rowDataBeforeSort = []
        //   } else {
        //     this.rowData = event.api.getModel().rowsToDisplay.map(item => item.data)
        //   }
        // },
        context: {
          componentParent: this
        }
      },
      selectedRowCount: 0,
      dargGroupShowColumnDef: {
        headerName: this.$t('SeaExport.BusinessNo'),
        colId: 'jobNo',
        field: 'jobNo',
        width: 240,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        wrapText: false,
        checkboxSelection: params => {
          const currentJob = params.data
          if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
            return false
          }
          return true
        },
        cellRenderer: params => {
          const currentJob = params.data
          if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
            const icon = Number(currentJob.dataType) === 5 ? hblIcon : mblIcon
            return `<span><img src="${icon}" height="16" width="16" style="vertical-align: sub;margin-right:3px;" />${params.value}</span>`
          }
          return `<span>${params.value}</span>`
        },
        excelRenderer: params => params.value
      },
      columnDefs: [
        { headerName: 'MAWB', field: 'mbl', width: 180, colId: 'mbl',
          cellRenderer: (params) => {
            return ColumnUtils.mawbNoLabelFun(params.value, this.airMblDisplayStyle)
          },
          enableRowGroup: true
        },
        { headerName: 'HAWB', field: 'hawb', width: 180, colId: 'hawb', enableRowGroup: true },
        { headerName: this.$t('SeaExport.WarehouseNo'), field: 'warehouseNo', width: 180, colId: 'warehouseNo', enableRowGroup: true },
        { headerName: this.$t('SeaExport.FirstLegNo'), field: 'relatedJob2', width: 180, colId: 'relatedJob2', enableRowGroup: true },
        { headerName: this.$t('SeaExport.ConsignationRelationNumber'), field: 'trustFromJob', width: 180, colId: 'trustFromJob', enableRowGroup: true },
        { headerName: this.$t('SeaExport.BusinessCommissionedRelationNumber'), field: 'relatedJob', width: 180, colId: 'relatedJob', enableRowGroup: true },
        { headerName: this.$t('SeaExport.ItemNo'), field: 'poNo', width: 180, colId: 'poNo', enableRowGroup: true },
        { headerName: this.$t('SeaExport.CustomerLevel'), field: 'customerTypeId', width: 180, colId: 'customerTypeId',
          cellRenderer: (params) => {
            return ColumnUtils.companyCustomerTypeLabelFunc(Number(params.value))
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.ContractStatus'), field: 'contractStatus', width: 180, colId: 'contractStatus', enableRowGroup: true },
        { headerName: this.$t('CargoMsg.Cargo_RiskReason'), field: 'riskReason', width: 150, colId: 'riskReason' },
        { headerName: this.$t('SeaExport.SalesOfGoods'), field: 'cargoSalesId', width: 180, colId: 'cargoSalesId', hide: true,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateCargoSalesId), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.PortOfDestinationServices'),
          field: 'portOfDestinationServices',
          colId: 'portOfDestinationServices',
          enableRowGroup: true,
          valueGetter: (params) => {
            if (params.data) {
              return ColumnUtils.loadingPortOfDestinationServicesLabelFunction(params.data)
            }
            return
          },
          filterValueGetter: (params) => {
            return ColumnUtils.loadingPortOfDestinationServicesLabelFunction(params.data)
          },
          filterParams: {},
          hide: true,
          width: 150
        },
        { headerName: this.$t('SeaExport.CustomerReferenceNumber'), field: 'customerRefNo', width: 180, colId: 'customerRefNo', enableRowGroup: true },
        { headerName: this.$t('SeaExport.OperateType'), field: 'operateType', width: 180, colId: 'operateType',
          cellRenderer: (params) => {
            return ColumnUtils.operateTypeLabelFunc(params.data, 'operateType')
          },
          filter: false,
          filterParams: {}
        },
        { headerName: this.$t('SeaExport.OverseaCustomerService'), field: 'overseaOp', width: 180, colId: 'overseaOp',
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateOverseaOp), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.Remarks'), field: 'remarks', width: 180, colId: 'remarks', enableRowGroup: true },
        { headerName: this.$t('SeaExport.ConsignationCompany'), field: 'customerId', width: 180, colId: 'customerId',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_0') : ''
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.Booking'), field: 'customClaim', width: 180, colId: 'customClaim', hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.customClaimLabelFunc(Number(params.value))
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.CustomsDeclarationType'), field: 'customsClaim2', width: 180, colId: 'customsClaim2', hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.customClaim2LabelFunc(Number(params.value))
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.AirlineCompany'), field: 'carrierId', width: 180, colId: 'carrierId',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_6') : ''
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.Flight'), field: 'voyageFlight', width: 180, colId: 'voyageFlight', enableRowGroup: true },
        { headerName: this.$t('SeaExport.LoadingPort'), field: 'loadingPortCode', width: 180, colId: 'loadingPortCode',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'auto_8')
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.PortOfDestination'), field: 'destinationPortCode', width: 180, colId: 'destinationPortCode',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'auto_8')
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.TaxNature'),
          field: 'taxNature',
          colId: 'taxNature',
          cellRenderer: params => {
            return ColumnUtils.taxNatureLabelFunction(params.value)
          },
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CargoTerminalOperation'),
          field: 'cargoTerminalOperation',
          colId: 'cargoTerminalOperation',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_AirportCargoTerminal, 'uuid', params.value, 'warehouseName')
          },
          hide: true,
          enableRowGroup: true,
          width: 120
        },
        { headerName: this.$t('SeaExport.DestinationAgent'), field: 'destinationAgent', width: 180, colId: 'destinationAgent',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_2') : ''
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.NominatedAgent'), field: 'designationAgent', width: 180, colId: 'designationAgent',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_3') : ''
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.PortOfHubSecond'), field: 'secondPortCode', width: 180, colId: 'secondPortCode',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'auto_8') : ''
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.PortOfHubThird'), field: 'thirdPortCode', width: 180, colId: 'thirdPortCode',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'auto_8') : ''
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.BookingProperty'), field: 'bookingTerm', width: 180, colId: 'bookingTerm',
          cellRenderer: (params) => {
            return ColumnUtils.bookingTermLabelFunction(params.data, params.value)
          },
          filter: false,
          filterParams: {}
        },
        { headerName: this.$t('SeaExport.BookingAgent'), field: 'bookingAgent', width: 180, colId: 'bookingAgent',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_1') : ''
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.HaulageCompany'), field: 'carryingCmp', width: 180, colId: 'carryingCmp',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_0') : ''
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.CommissionedNumberOfPackages'), field: 'quantityContract', width: 180, colId: 'quantityContract',
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(Number(params.value), 0)
          },
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.CommissionedGrossWeight'), field: 'weightContract', width: 180, colId: 'weightContract',
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(Number(params.value), 3)
          },
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.CommissionedVolume'), field: 'cubageContract', width: 180, colId: 'cubageContract',
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(Number(params.value), 3)
          },
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.CommissionedChargedWeight'), field: 'chargeWeight', width: 180, colId: 'chargeWeight',
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(Number(params.value), 3)
          },
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.ActualQuantity'), field: 'quantityActual', width: 180, colId: 'quantityActual',
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(Number(params.value), 0)
          },
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.ActualWeight'), field: 'weightActual', width: 180, colId: 'weightActual',
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(Number(params.value), 3)
          },
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.ActualVolume'), field: 'cubageActual', width: 180, colId: 'cubageActual',
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(Number(params.value), 3)
          },
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.ActualChargedWeight'), field: 'cWeight', width: 180, colId: 'cWeight',
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(Number(params.value), 3)
          },
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'), field: 'cargoChineseName', width: 180, colId: 'cargoChineseName', enableRowGroup: true },
        { headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'), field: 'cargoEnglishName', width: 180, colId: 'cargoEnglishName', enableRowGroup: true },
        { headerName: this.$t('SeaExport.BangPic'), field: '', coldId: 'bangPic', width: 180, enableRowGroup: true },
        { headerName: this.$t('SeaExport.PrintingPlatePhotos'), field: '', coldId: 'printingPlatePhotos', width: 180, enableRowGroup: true },
        { headerName: this.$t('SeaExport.SolicitationType'), field: 'cargoSource', width: 180, colId: 'cargoSource',
          cellRenderer: (params) => {
            return ColumnUtils.cargoSourceLabelFunction(params.value, 3)
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.DateOfDeparture2'), field: 'etd', width: 180, colId: 'etd',
          cellRenderer: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.ActualDateOfDeparture2'), field: 'atd', width: 180, colId: 'atd',
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          enableRowGroup: true
        },
        { headerName: this.$t('Warehouse.TemperatureRequirement'), field: 'temperatureRequirement', width: 180, colId: 'temperatureRequirement', enableRowGroup: true, hide: true },
        { headerName: this.$t('SeaExport.ActualDateOfArrival2'), field: 'ata', width: 180, colId: 'ata',
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.DateOfArrival2'), field: 'eta', width: 180, colId: 'eta',
          cellRenderer: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.DateOfCreation'), field: 'dateCreated', width: 180, colId: 'dateCreated',
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.CargoType'),
          field: 'cargoType',
          colId: 'cargoType',
          width: 180,
          hide: true,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.cargoTypeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.MasterBLFreightTerm'),
          field: 'paymentTermMBL',
          colId: 'paymentTermMBL',
          width: 180,
          hide: true,
          enableRowGroup: true,
          valueGetter: (params) => {
            if (params.data) {
              return ColumnUtils.paymentTermLabelFunc(params.data.paymentTermMBL)
            }
            return ''
          }
        }, {
          headerName: this.$t('SeaExport.HBLFreightClause'),
          field: 'paymentTermHBL',
          colId: 'paymentTermHBL',
          width: 180,
          hide: true,
          enableRowGroup: true,
          valueGetter: (params) => {
            if (params.data) {
              return ColumnUtils.paymentTermLabelFunc(params.data.paymentTermHBL)
            }
            return ''
          }
        }, { headerName: this.$t('SeaExport.StatusOfCustomsDeclaration'), field: 'declareCustomsState', width: 180, colId: 'declareCustomsState',
          cellRenderer: (params) => {
            return ColumnUtils.customsStateLabFun(params.value)
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.ProtocolType'), field: 'protocolType', width: 180, colId: 'protocolType',
          cellRenderer: (params) => {
            return ColumnUtils.protocolTypeLabFunc(params.value)
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.Operation'), field: 'op', width: 180, colId: 'op',
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateOpId), 'auto_op')
            }
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op') : ''
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.Sales'), field: 'sales', width: 180, colId: 'sales',
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateSales), 'auto_sales')
            }
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_sales') : ''
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.Accrued'), field: 'provisioned', width: 180, colId: 'provisioned', hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.AirlinePerson2'), field: 'planner', width: 180, colId: 'planner',
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperatePlanner), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.CustomerService'), field: 'csr', width: 180, colId: 'csr',
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateCsrId), 'auto_csr')
            }
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_csr') : ''
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.Documents'), field: 'dc', width: 180, colId: 'dc',
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateDcId), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.FieldOperation'), field: 'siteOp', width: 180, colId: 'siteOp',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.OverseaOperation'), field: 'overseaOp', width: 180, colId: 'overseaOp', hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.ShutOut'), field: 'shutOut', width: 180, colId: 'shutOut',
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ShutOutDate'),
          field: 'shutOutDate',
          colId: 'shutOutDate',
          enableRowGroup: true,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150
        },
        { headerName: this.$t('SeaExport.BusinessCreator'), field: 'createdBy', width: 180, colId: 'createdBy',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.Status'), field: 'jobState', width: 180, colId: 'jobState',
          cellRenderer: (params) => {
            return ColumnUtils.getJobStateForBlock(params.data)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.getJobStateForBlock(params.data)
          }
        },
        { headerName: this.$t('SeaExport.PreAuditPerson'), field: 'preVerifier', width: 180, colId: 'preVerifier', hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.PreAuditTime'), field: 'preVerifyDate', width: 180, colId: 'preVerifyDate', hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.OtherWarehouseNotes'), field: 'otherWarehouseNotes', width: 180, hide: true, colId: 'otherWarehouseNotes', enableRowGroup: true },
        { headerName: this.$t('SeaExport.CustomJobType'), field: 'customJobType', width: 180, colId: 'customJobType',
          valueGetter: (params) => {
            return ColumnUtils.resolveCutomJobTypeLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.data.customJobType, 'name', SystemConstants.AE.code, this.isFba)
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.SOPStatus'), field: 'sopState', width: 180, tooltipValueGetter: (params) => params.value, colId: 'sopState', enableRowGroup: true },
        { headerName: this.$t('SeaExport.UserDefinedField1'), field: 'userDefinedField1', width: 180, hide: true, colId: 'userDefinedField1', enableRowGroup: true },
        { headerName: this.$t('SeaExport.UserDefinedField2'), field: 'userDefinedField2', width: 180, hide: true, colId: 'userDefinedField2', enableRowGroup: true },
        { headerName: this.$t('SeaExport.UserDefinedField3'), field: 'userDefinedField3', width: 180, hide: true, colId: 'userDefinedField3', enableRowGroup: true },
        { headerName: this.$t('SeaExport.UserDefinedField4'), field: 'userDefinedField4', width: 180, hide: true, colId: 'userDefinedField4', enableRowGroup: true },
        { headerName: this.$t('SeaExport.OperationDate'), field: 'customsDate', width: 180, colId: 'customsDate', hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.ManageAuditStatus'), field: 'manageAuditStatus', width: 180, colId: 'manageAuditStatus', hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.manageAuditStatusLabelFunction(params.value)
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.DocCutOffDate'), field: 'fileCutoff', width: 180, colId: 'fileCutoff',
          cellRenderer: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.HBLShipper'), field: 'hblShipperLine1', width: 180, colId: 'hblShipperLine1', enableRowGroup: true },
        { headerName: this.$t('SeaExport.HBLConsignee'), field: 'hblConsigneeLine1', width: 180, colId: 'hblConsigneeLine1', enableRowGroup: true },
        { headerName: this.$t('SeaExport.HBLNotifier'), field: 'hblNotifyLine1', width: 180, colId: 'hblNotifyLine1', enableRowGroup: true },
        { headerName: this.$t('SeaExport.TradeTerms2'), field: 'incoTerm', width: 180, hide: true, colId: 'incoTerm', enableRowGroup: true },
        { headerName: this.$t('SeaExport.PlaceOfDelivery'), field: 'destinationPlace', width: 180, hide: true, colId: 'destinationPlace', enableRowGroup: true },
        {
          headerName: this.$t('SeaExport.ReceivableChargeLockedStatus'), field: 'receivableChargeLockedStatus', colId: 'receivableChargeLockedStatus',
          hide: true, width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.chargeLockedStatusLabelFunc(Number(params.value))
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.PayableChargeLockedStatus'), field: 'payableChargeLockedStatus', colId: 'payableChargeLockedStatus',
          hide: true, width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.chargeLockedStatusLabelFunc(Number(params.value))
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.Consignee'),
          colId: 'consigneeLine1',
          field: 'consigneeLine1',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.Shipper'),
          field: 'shipperLine1',
          colId: 'shipperLine1',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.CustomerContactPerson'),
          field: 'customerContact',
          colId: 'customerContact',
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ContactPhone'),
          field: 'telephone',
          colId: 'telephone',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ContactMobile'),
          field: 'mobile',
          colId: 'mobile',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.AdditionalNotes'),
          field: 'remarks',
          colId: 'remarks',
          width: 150,
          hide: true,
          valueFormatter: (params) => {
            return params.value
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.quotationNum'),
          colId: 'quotationNo',
          field: 'quotationNo',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_userDefinedRole1'),
          field: 'userDefinedRoleId1',
          colId: 'userDefinedRoleId1',
          width: 150,
          valueFormatter: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateUserDefinedRoleId1), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_userDefinedRole2'),
          field: 'userDefinedRoleId2',
          colId: 'userDefinedRoleId2',
          width: 150,
          valueFormatter: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateUserDefinedRoleId2), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole3'),
          field: 'userDefinedRoleId3',
          colId: 'userDefinedRoleId3',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessPushStatus'),
          colId: 'jobPushStatus',
          field: 'jobPushStatus',
          width: 100,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.jobPushStatusLabelFunc(Number(params.value))
          },
          enableRowGroup: true
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole4'),
          field: 'userDefinedRoleId4',
          colId: 'userDefinedRoleId4',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole5'),
          field: 'userDefinedRoleId5',
          colId: 'userDefinedRoleId5',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole6'),
          field: 'userDefinedRoleId6',
          colId: 'userDefinedRoleId6',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole7'),
          field: 'userDefinedRoleId7',
          colId: 'userDefinedRoleId7',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.PreCommitUser'),
          field: 'preCommitUser',
          colId: 'preCommitUser',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          },
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.PreCommitDate'),
          field: 'preCommitDate',
          colId: 'preCommitDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.CommitUser'),
          field: 'commitUser',
          colId: 'commitUser',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          },
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.SubmissionDate'),
          field: 'submissionDate',
          colId: 'submissionDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.FcAuditUser'),
          field: 'fcAuditUser',
          colId: 'fcAuditUser',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          },
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.FcAuditDate'),
          field: 'fcAuditDate',
          colId: 'fcAuditDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.LockJobUser'),
          field: 'lockJobUser',
          colId: 'lockJobUser',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          },
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.LockJobDate'),
          field: 'lockJobDate',
          colId: 'lockJobDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_SalesBranchCompany'),
          field: 'salesOffice',
          colId: 'salesOffice',
          hide: true,
          width: 100,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.data.cooperateSalesOffice), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperationOffice'),
          field: 'opOffice',
          colId: 'opOffice',
          hide: true,
          width: 100,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.data.cooperateOpCompany), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_SalesDepartment'),
          field: 'salesDept',
          colId: 'salesDept',
          hide: true,
          width: 100,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.data.cooperateSalesDepartment), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperationDepartment'),
          field: 'opDepartment',
          colId: 'opDepartment',
          hide: true,
          width: 100,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.data.cooperateOpDepartment), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.CategoryOfGoods'),
          field: 'cargoCode',
          colId: 'cargoCode',
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoInformation, 'code', params.value, 'chineseName') : ''
          },
          hide: true,
          width: 200,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.DelegatedAssociatedBusinessStatus'),
          field: 'trustJobState',
          colId: 'trustJobState',
          hide: true,
          valueFormatter: params => {
            let value = params.value
            if (typeof value === 'string') {
              value = Number(value)
              if (isNaN(value)) {
                return ''
              }
            }
            return typeof value === 'number' ? ColumnUtils.getJobStateCN(value) : ''
          },
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.TransactionRelatedBusinessStatus'),
          field: 'relatedJobState',
          colId: 'relatedJobState',
          hide: true,
          valueFormatter: params => {
            let value = params.value
            if (typeof value === 'string') {
              value = Number(value)
              if (isNaN(value)) {
                return ''
              }
            }
            return typeof value === 'number' ? ColumnUtils.getJobStateCN(value) : ''
          },
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('queryJob.receivablesWriteOfStatus'),
          colId: 'verifyStateReceivable',
          field: 'verifyStateReceivable',
          width: 150,
          hide: true,
          enableRowGroup: true
        }, {
          headerName: this.$t('queryJob.payablesWriteOfStatus'),
          colId: 'verifyStatePayable',
          field: 'verifyStatePayable',
          width: 150,
          hide: true,
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_ReceivableChargeInput'),
          field: 'receivableChargeInput',
          colId: 'receivableChargeInput',
          width: 150,
          hide: true,
          filter: false,
          filterParams: {},
          valueFormatter: params => {
            return ColumnUtils.chargeInputLabelFunction(params.value)
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_CostChargeInput'),
          field: 'costChargeInput',
          colId: 'costChargeInput',
          width: 150,
          hide: true,
          filter: false,
          filterParams: {},
          valueFormatter: params => {
            return ColumnUtils.chargeInputLabelFunction(params.value)
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('Invoice.invoice_receivablesInvoicingStatus'),
          colId: 'receivableInvoiceState',
          field: 'receivableInvoiceState',
          width: 150,
          hide: true,
          valueFormatter: params => {
            return ColumnUtils.receivableInvoiceStateLabelFunction(Number(params.value))
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.MasterBusinessNo'),
          colId: 'masterJobNo',
          field: 'masterJobNo',
          width: 150,
          hide: true,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.Warehouse'),
          field: 'warehouseCmp',
          colId: 'warehouseCmp',
          valueFormatter: params => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_10') : ''
          },
          width: 200,
          hide: true,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.TradeMethod'),
          field: 'tradeTerm',
          colId: 'tradeTerm',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_TradeTerm, 'code', params.value, 'name')
          },
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ProjectName'),
          field: 'projectName',
          colId: 'projectName',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ProjectBatch'),
          field: 'projectBatch',
          colId: 'projectBatch',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.RelatedPreCommitUser'),
          field: 'relatedPreCommitUser',
          colId: 'relatedPreCommitUser',
          hide: true,
          cellRenderer: params => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          },
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.RelatedPreCommitDate'),
          field: 'relatedPreCommitDate',
          colId: 'relatedPreCommitDate',
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('queryJob.CommissionedDensity'),
          field: 'densityContract',
          hide: true,
          width: 100,
          cellRenderer: params => {
            return params.value ? ColumnUtils.number3ColumnLabelFunc(Number(params.value)) : ''
          },
          enableRowGroup: true,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('queryJob.ActualDensity'),
          field: 'densityActual',
          hide: true,
          width: 100,
          cellRenderer: params => {
            return params.value ? ColumnUtils.number3ColumnLabelFunc(Number(params.value)) : ''
          },
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SopTemplateName'),
          field: 'trackingTemplateUuid',
          width: 180,
          colId: 'trackingTemplateUuid',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_TrackingTemplate, 'uuid', params.value, 'templateName')
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_CooperateBranchId'),
          colId: 'cooperatebranch',
          field: 'cooperatebranch',
          width: 160, minWidth: 160,
          hide: !this.useOrderCenterMode
        }, {
          headerName: this.$t('CargoMsg.Cargo_CooperateBusinessType'),
          colId: 'cooperateBusinessType',
          field: 'cooperateBusinessType',
          width: 200, minWidth: 200,
          hide: !this.useOrderCenterMode
        }, { headerName: this.$t('CargoMsg.Cargo_JobProfitShare'), colId: 'jobProfitShare', field: 'jobProfitShare', width: 130, minWidth: 130,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          hide: true
        }, {
          headerName: this.$t('Warehouse.WarehouseInState'),
          colId: 'warehouseStatus',
          field: 'warehouseStatus',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_WarehouseInState$WAREHOUSE_STATE, 'code', Number(params.value), 'chineseName')
          },
          hide: true,
          enableRowGroup: true
        },
        { headerName: this.$t('CargoMsg.Cargo_BusinessExpirationDate'), field: 'specialApprovalDate', width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.BookingDate'),
          field: 'bookingDate',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          hide: true,
          width: 180,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ActualEntryTime'),
          field: 'actualEntryTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          hide: true,
          width: 180,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ActualLoadingTime'),
          field: 'actualLoadingTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          hide: true,
          width: 180,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EstimatedDepartureTime'),
          field: 'estimatedDepartureTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          hide: true,
          width: 180,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ActualDepartureTime'),
          field: 'actualDepartureTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          hide: true,
          width: 180,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EstimatedArrivalTime'),
          field: 'estimatedArrivalTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          hide: true,
          width: 180,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ActualArrivalTime'),
          field: 'actualArrivalTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          hide: true,
          width: 180,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ActualBillingTime'),
          field: 'actualReceivingTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          hide: true,
          width: 180,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ActualUnloadingTime'),
          field: 'actualUnloadingTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          hide: true,
          width: 180,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ActualArrivalNotificationTime'),
          field: 'actualArrivalNotificationTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          hide: true,
          width: 180,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ActualPickupTime'),
          field: 'actualPickupTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          hide: true,
          width: 180,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EstimatedTransitArrivalTime'),
          field: 'estimatedTransferArrivalTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          hide: true,
          width: 180,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TransitArrivalTime'),
          field: 'transferArrivalTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          hide: true,
          width: 180,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EstimatedTransitDepartureTime'),
          field: 'estimatedTransferDepartureTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          hide: true,
          width: 180,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TransitDepartureTime'),
          field: 'transferDepartureTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          hide: true,
          width: 180,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.OrderChannels'),
          field: 'salesChannel',
          hide: true,
          width: 180,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.ChannelNo'),
          field: 'channelNo',
          hide: true,
          width: 180,
          enableRowGroup: true
        },
        {
          headerName: this.$t('Message.Customer_Service'),
          colId: 'csrDepartment',
          field: 'csrDepartment',
          width: 180,
          hide: true,
          valueFormatter: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.data.cooperateCsrDepartment), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('Message.Documentation_Department'),
          colId: 'dcDepartment',
          field: 'dcDepartment',
          width: 180,
          hide: true,
          valueFormatter: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.data.cooperateDcDepartment), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.AirlineDepartment'),
          colId: 'plannerDepartment',
          field: 'plannerDepartment',
          width: 140,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.Airline'),
          field: 'regionName',
          colId: 'regionName',
          hide: true,
          cellRenderer: (params) => {
            if (params.value && !this.isZh) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Region, 'name', params.value, 'nameEnglish')
            }
            return params.value || ''
          },
          width: 150,
          enableRowGroup: true
        }, { headerName: this.$t('Message.Countries_Regions_Destination'),
          field: 'destinationPortCountry',
          colId: 'destinationPortCountry',
          width: 200,
          valueFormatter: (params) => {
            const countryCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.data.destinationPortCode, 'countryCode')
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Country, 'code', countryCode, 'chineseName')
          }
        },
        { headerName: this.$t('AirExport.MawbChargeWeight'), field: 'mawbCWeight', width: 180, colId: 'mawbCWeight', hide: true,
          // 确保显示和拖拽分组的显示值没有问题
          valueGetter: (params) => {
            if (params.data && !params.data.masterFlag && params.data.operateType === AirExportConstants.CONSOLE.code) {
              return '0.000'
            }
            return ColumnUtils.numberColumnLabelFunc(params.data.mawbCWeight, 3)
          },
          // 用于筛选的值（确保筛选面板显示 3 位小数）
          filterParams: {},
          filterValueGetter: (params) => {
            if (params.data && !params.data.masterFlag && params.data.operateType === AirExportConstants.CONSOLE.code) {
              return '0.000'
            }
            return ColumnUtils.numberColumnLabelFunc(params.data.mawbCWeight, 3)
          },
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        { headerName: this.$t('AirExport.BookingChargeWeight'), field: 'chargeWeightBooking', width: 180, colId: 'chargeWeightBooking', hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(Number(params.value), 3)
          },
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        {
          headerName: this.$t('SeaExport.SoNo'),
          field: 'jobSoNo',
          hide: true,
          valueFormatter: (params) => {
            return params.value ? params.value.replace(/\n/g, ',') : ''
          },
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.BookingNo'),
          field: 'bookingNo',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_VerifyStateReceivableDomestic'),
          colId: 'verifyStateReceivableDomestic',
          field: 'verifyStateReceivableDomestic',
          width: 140,
          hide: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_VerifyStateReceivableOversea'),
          colId: 'verifyStateReceivableOversea',
          field: 'verifyStateReceivableOversea',
          width: 140,
          hide: true
        }, {
          headerName: this.$t('SeaExport.DispatchVehiclesAtDestinationDoorAddress'),
          colId: 'doorAddr',
          field: 'doorAddr',
          width: 150,
          hide: true,
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_PurchasePriceLockedStatus'),
          colId: 'purchasePriceLock',
          field: 'purchasePriceLock',
          width: 140,
          hide: true,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.LockTypeLabel(stringToBool(params.value))
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_SellingPriceLockedStatus'),
          colId: 'sellingPriceLock',
          field: 'sellingPriceLock',
          width: 140,
          hide: true,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.LockTypeLabel(stringToBool(params.value))
          }
        }, { headerName: this.$t('SeaExport.PortOfLoadingAgent'), field: 'loadingAgentId', width: 180, colId: 'loadingAgentId',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_0') : ''
          },
          hide: true,
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.BusinessLockedStatus'), field: 'businessLock', width: 100, colId: 'businessLock',
          cellRenderer: (params) => {
            return ColumnUtils.booleanLockedStatusLabelFunc(stringToBool(params.value))
          },
          enableRowGroup: true,
          hide: true
        },
        { headerName: this.$t('CargoMsg.Cargo_SettlementType'), field: 'settlementType', width: 100, hide: true, enableRowGroup: true
        },
        { headerName: this.$t('CargoMsg.Cargo_AccountPeriod'), field: 'dateLimited', width: 100, hide: true, enableRowGroup: true
        },
        { headerName: this.$t('CargoMsg.Cargo_IsExtended'), field: 'creditInfoDateExceeded', width: 100, hide: true, enableRowGroup: true,
          cellRenderer: params => {
            if (params.value === '') return ''
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          filterParams: {},
          filterValueGetter: params => ColumnUtils.booleanLabelFunction(params.value)
        },
        { headerName: this.$t('CargoMsg.Cargo_ExcessiveOrNot'), field: 'creditInfoAmountExceeded', width: 100, hide: true, enableRowGroup: true,
          cellRenderer: params => {
            if (params.value === '') return ''
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          filterParams: {},
          filterValueGetter: params => ColumnUtils.booleanLabelFunction(params.value)
        },
        {
          headerName: this.$t('SeaExport.AdvancePayment'),
          field: 'advancePayment',
          colId: 'advancePayment',
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          hide: true,
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.CustomsDutyAmount'),
          field: 'customsDutyAmount',
          colId: 'customsDutyAmount',
          enableRowGroup: true,
          hide: true,
          width: 150,
          cellRenderer: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('SeaExport.VatAmount'),
          field: 'vatAmount',
          colId: 'vatAmount',
          enableRowGroup: true,
          hide: true,
          width: 150,
          cellRenderer: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('SeaExport.PaymentTime'),
          field: 'paymentTime',
          colId: 'paymentTime',
          enableRowGroup: true,
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_actGoodsDeliveryTime'),
          field: 'actualShippingTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          hide: true,
          width: 180,
          enableRowGroup: true
        },
        {
          headerName: this.$t('Invoice.invoice_payablesInvoicingStatus'),
          colId: 'payableInvoiceState',
          field: 'payableInvoiceState',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.receivableInvoiceStateLabelFunction(params.value)
          },
          filterParams: {},
          filterValueGetter: params => ColumnUtils.receivableInvoiceStateLabelFunction(params.data.payableInvoiceState),
          hide: true,
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.PreWarehouseNumberOfPackages'), field: 'quantityActual', width: 180, colId: 'quantityActual',
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(Number(params.value), 0)
          },
          hide: true,
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.PreWarehouseGrossWeight'), field: 'weightActual', width: 180, colId: 'weightActual',
          valueGetter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(Number(params.data.weightActual), 3)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(Number(params.data.weightActual), 3)
          },
          hide: true,
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.PreWarehouseVolume'), field: 'cubageActual', width: 180, colId: 'cubageActual',
          valueGetter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(Number(params.data.cubageActual), 3)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(Number(params.data.cubageActual), 3)
          },
          hide: true,
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.PreWarehouseChargeableWeight'), field: 'cWeight', width: 180, colId: 'cWeight',
          valueGetter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(Number(params.data.cWeight), 3)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(Number(params.data.cWeight), 3)
          },
          hide: true,
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.CargoTerminalNumberOfPackages'), field: 'quantityStation', width: 180, colId: 'quantityStation',
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(Number(params.value), 0)
          },
          hide: true,
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.CargoTerminalGrossWeight'), field: 'weightStation', width: 180, colId: 'weightStation',
          valueGetter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(Number(params.data.weightStation), 3)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(Number(params.data.weightStation), 3)
          },
          hide: true,
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.CargoTerminalVolume'), field: 'cubageStation', width: 180, colId: 'cubageStation',
          valueGetter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(Number(params.data.cubageStation), 3)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(Number(params.data.cubageStation), 3)
          },
          hide: true,
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.CargoTerminalChargeableWeight'), field: 'chargeWeightStation', width: 180, colId: 'chargeWeightStation',
          valueGetter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(Number(params.data.chargeWeightStation), 3)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(Number(params.data.chargeWeightStation), 3)
          },
          hide: true,
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.DocumentationNumberOfPackages'), field: 'mawbQuantity', width: 180, colId: 'mawbQuantity',
          valueGetter: (params) => {
            if (params.data && !params.data.masterFlag && params.data.operateType === AirExportConstants.CONSOLE.code) {
              return '0'
            }
            return ColumnUtils.numberColumnLabelFunc(Number(params.data.mawbQuantity), 0)
          },
          // 用于筛选的值（确保筛选面板显示 3 位小数）
          filterParams: {},
          filterValueGetter: (params) => {
            if (params.data && !params.data.masterFlag && params.data.operateType === AirExportConstants.CONSOLE.code) {
              return '0'
            }
            return ColumnUtils.numberColumnLabelFunc(Number(params.data.mawbQuantity), 0)
          },
          hide: true,
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.DocumentationGrossWeight'), field: 'mawbWeight', width: 180, colId: 'mawbWeight',
          valueGetter: (params) => {
            if (params.data && !params.data.masterFlag && params.data.operateType === AirExportConstants.CONSOLE.code) {
              return '0.000'
            }
            return ColumnUtils.numberColumnLabelFunc(params.data.mawbWeight, 3)
          },
          // 用于筛选的值（确保筛选面板显示 3 位小数）
          filterParams: {},
          filterValueGetter: (params) => {
            if (params.data && !params.data.masterFlag && params.data.operateType === AirExportConstants.CONSOLE.code) {
              return '0.000'
            }
            return ColumnUtils.numberColumnLabelFunc(params.data.mawbWeight, 3)
          },
          hide: true,
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.DocumentationVolume'), field: 'mawbCubage', width: 180, colId: 'mawbCubage',
          valueGetter: (params) => {
            if (params.data && !params.data.masterFlag && params.data.operateType === AirExportConstants.CONSOLE.code) {
              return '0.000'
            }
            return ColumnUtils.numberColumnLabelFunc(params.data.mawbCubage, 3)
          },
          // 用于筛选的值（确保筛选面板显示 3 位小数）
          filterParams: {},
          filterValueGetter: (params) => {
            if (params.data && !params.data.masterFlag && params.data.operateType === AirExportConstants.CONSOLE.code) {
              return '0.000'
            }
            return ColumnUtils.numberColumnLabelFunc(params.data.mawbCubage, 3)
          },
          hide: true,
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.SignedDocumentNumberOfPackages'), field: 'quantitySigning', width: 180, colId: 'quantitySigning',
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(Number(params.value), 0)
          },
          hide: true,
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.SignedDocumentGrossWeight'), field: 'weightSigning', width: 180, colId: 'weightSigning',
          valueGetter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.data.weightSigning, 3)
          },
          // 用于筛选的值（确保筛选面板显示 3 位小数）
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.data.weightSigning, 3)
          },
          hide: true,
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.SignedDocumentVolume'), field: 'cubageSigning', width: 180, colId: 'cubageSigning',
          valueGetter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.data.cubageSigning, 3)
          },
          // 用于筛选的值（确保筛选面板显示 3 位小数）
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.data.cubageSigning, 3)
          },
          hide: true,
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.SignedDocumentChargeableWeight'), field: 'chargeWeightSigning', width: 180, colId: 'chargeWeightSigning',
          valueGetter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.data.chargeWeightSigning, 3)
          },
          // 用于筛选的值（确保筛选面板显示 3 位小数）
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.data.chargeWeightSigning, 3)
          },
          hide: true,
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ReceivableFeeLockTime2'),
          colId: 'receivableChargeLockedDate',
          field: 'receivableChargeLockedDate',
          width: 200,
          hide: true,
          cellRenderer: (params) => {
            return DateUtils.formatStandardDateTime(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PayableFeeLockTime2'),
          colId: 'payableChargeLockedDate',
          field: 'payableChargeLockedDate',
          width: 200,
          hide: true,
          cellRenderer: (params) => {
            return DateUtils.formatStandardDateTime(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PayableFeeLockPerson'),
          colId: 'payableChargeLockedPerson',
          field: 'payableChargeLockedPerson',
          width: 150,
          hide: true,
          enableRowGroup: true,
          valueGetter: (params) => {
            return ColumnUtils.getPayableChargeLockedPerson(params.data)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_InterestAmountCurrency'),
          colId: 'interestAmountCurrency',
          field: 'interestAmountCurrency',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CheckRuleResult'),
          colId: 'checkRuleResult',
          field: 'checkRuleResult',
          width: 100,
          hide: true,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.CheckRuleResultLabelFun(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ArrivalMethod'),
          colId: 'loadingTerm',
          field: 'loadingTerm',
          valueFormatter: params => {
            return ColumnUtils.LoadingTermLabFun(params.value)
          },
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_JdySendStatus'),
          colId: 'jdySendStatus',
          field: 'jdySendStatus',
          width: 100,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.jdySendStatusLabelFunc(Number(params.value))
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_JdySendTime'),
          colId: 'jdySendTime',
          field: 'jdySendTime',
          width: 200,
          hide: true,
          cellRenderer: (params) => {
            return DateUtils.formatStandardDateTime(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DetailsLockedStatus'),
          colId: 'detailsLockedStatus',
          field: 'detailsLockedStatus',
          width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.LockTypeLabel(Number(params.value))
          },
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.ExportControlledProducts'),
          field: 'exportControlledProduct',
          colId: 'exportControlledProduct',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_ExportControlledProduct, 'code', params.value, 'chineseName') : ''
          },
          width: 120
        },
        {
          headerName: this.$t('SeaExport.SellingPrice'),
          colId: 'selling',
          field: 'selling',
          width: 100,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.BuyingPrice'),
          colId: 'buying',
          field: 'buying',
          width: 100,
          hide: true,
          enableRowGroup: true
        }
      ],
      sumColumnDefs: [
        {
          field: 'quantityContract',
          getValue: data => data.quantityContract,
          format: value => ColumnUtils.numberColumnLabelFunc(Number(value), 0)
        },
        {
          field: 'weightContract',
          getValue: data => data.weightContract,
          format: value => ColumnUtils.numberColumnLabelFunc(Number(value), 3)
        },
        {
          field: 'cubageContract',
          getValue: data => data.cubageContract,
          format: value => ColumnUtils.numberColumnLabelFunc(Number(value), 3)
        },
        {
          field: 'chargeWeight',
          getValue: data => data.chargeWeight,
          format: value => ColumnUtils.numberColumnLabelFunc(Number(value), 3)
        },
        {
          field: 'quantityActual',
          getValue: data => data.quantityActual,
          format: value => ColumnUtils.numberColumnLabelFunc(Number(value), 0)
        },
        {
          field: 'weightActual',
          getValue: data => data.weightActual,
          format: value => ColumnUtils.numberColumnLabelFunc(Number(value), 3)
        },
        {
          field: 'cubageActual',
          getValue: data => data.cubageActual,
          format: value => ColumnUtils.numberColumnLabelFunc(Number(value), 3)
        },
        {
          field: 'cWeight',
          getValue: data => data.cWeight,
          format: value => ColumnUtils.numberColumnLabelFunc(Number(value), 3)
        },
        {
          field: 'chargeWeightBooking',
          getValue: data => data.chargeWeightBooking,
          format: value => ColumnUtils.numberColumnLabelFunc(Number(value), 3)
        },
        // 货站
        {
          field: 'quantityStation',
          getValue: data => data.quantityStation,
          format: value => ColumnUtils.numberColumnLabelFunc(Number(value), 0)
        },
        {
          field: 'weightStation',
          getValue: data => data.weightStation,
          format: value => ColumnUtils.numberColumnLabelFunc(Number(value), 3)
        },
        {
          field: 'cubageStation',
          getValue: data => data.cubageStation,
          format: value => ColumnUtils.numberColumnLabelFunc(Number(value), 3)
        },
        {
          field: 'chargeWeightStation',
          getValue: data => data.chargeWeightStation,
          format: value => ColumnUtils.numberColumnLabelFunc(Number(value), 3)
        },
        // 制单
        {
          field: 'mawbQuantity',
          getValue: data => data.mawbQuantity,
          format: value => ColumnUtils.numberColumnLabelFunc(Number(value), 0)
        },
        {
          field: 'mawbWeight',
          getValue: data => data.mawbWeight,
          format: value => ColumnUtils.numberColumnLabelFunc(Number(value), 3)
        },
        {
          field: 'mawbCubage',
          getValue: data => data.mawbCubage,
          format: value => ColumnUtils.numberColumnLabelFunc(Number(value), 3)
        },
        {
          field: 'mawbCWeight',
          getValue: data => data.mawbCWeight,
          format: value => ColumnUtils.numberColumnLabelFunc(Number(value), 3)
        },
        // 签单
        {
          field: 'quantitySigning',
          getValue: data => data.quantitySigning,
          format: value => ColumnUtils.numberColumnLabelFunc(Number(value), 0)
        },
        {
          field: 'weightSigning',
          getValue: data => data.weightSigning,
          format: value => ColumnUtils.numberColumnLabelFunc(Number(value), 3)
        },
        {
          field: 'cubageSigning',
          getValue: data => data.cubageSigning,
          format: value => ColumnUtils.numberColumnLabelFunc(Number(value), 3)
        },
        {
          field: 'chargeWeightSigning',
          getValue: data => data.chargeWeightSigning,
          format: value => ColumnUtils.numberColumnLabelFunc(Number(value), 3)
        }
      ],
      fbaColumns: [
        { headerName: 'Shipment ID', field: 'shipmentId', width: 180, colId: 'shipmentId' },
        { headerName: this.$t('Warehouse.CommissionNo'), field: 'commissionNo', width: 180, colId: 'commissionNo' },
        { headerName: this.$t('FbaJob.AmazonWarehouseCode'), field: 'warehouseCode', width: 180, colId: 'warehouseCode' },
        { headerName: this.$t('Warehouse.ServiceChannel'), field: 'serviceChannel', width: 180, colId: 'serviceChannel' },
        { headerName: 'Reference Id', field: 'referenceId', width: 180, colId: 'referenceId' },
        {
          headerName: this.$t('Warehouse.PoOriginalOrderNo'),
          field: 'poNumber',
          width: 180,
          colId: 'poNumber',
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ValueAddedServices'),
          field: 'valueAddedServices',
          width: 180,
          colId: 'valueAddedServices'
        },
        {
          headerName: this.$t('Warehouse.RemoteWarehouse'),
          field: 'remoteWarehouse',
          width: 180,
          colId: 'remoteWarehouse',
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('Warehouse.EstEnteringAmazonWarehouse'),
          field: 'preAmazonWhTime',
          width: 180,
          colId: 'preAmazonWhTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Warehouse.ChargingMethod'), field: 'chargingMethod', width: 180, colId: 'chargingMethod',
          valueFormatter: (params) => {
            if (!params.value) return
            return Number(params.value) ? 'CBM' : 'KG'
          }
        },
        {
          headerName: this.$t('Warehouse.WeighTime'), field: 'weighTime', width: 180, colId: 'weighTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Warehouse.ChecklistTime'), field: 'checklistTime', width: 180, colId: 'checklistTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Warehouse.ReturnGoodsTime'),
          field: 'returnGoodsTime',
          width: 180,
          colId: 'returnGoodsTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Warehouse.ReturnReason'), field: 'returnReason', width: 180, colId: 'returnReason' },
        {
          headerName: this.$t('Warehouse.ChecklistResult'),
          field: 'checklistStatus',
          width: 180,
          colId: 'checklistStatus',
          valueFormatter: (params) => {
            return ColumnUtils.checklistResultLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SpecialGoods.StuffingTime'), field: 'packingTime', width: 180, colId: 'packingTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('FbaJob.OperationStatusOfForeignWarehouse'),
          field: 'outWarehouseStatus',
          width: 180,
          colId: 'outWarehouseStatus',
          valueFormatter: (params) => {
            return ColumnUtils.outWarehouseStatusLabelFunc(params.value)
          }
        }
      ],
      columnAdds: [
        {
          headerName: this.$t('CargoMsg.Cargo_EstimatedWarehousingTime'),
          field: 'estimatedWarehousingTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          hide: true,
          width: 180,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EstimatedDeliveryTime'),
          field: 'estimatedDeliveryTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          hide: true,
          width: 180,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ActualWarehousingTime'),
          field: 'warehouseInDate',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          hide: true,
          width: 180,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ActualDeliveryTime'),
          field: 'warehouseOutDate',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          hide: true,
          width: 180,
          enableRowGroup: true
        }, { headerName: this.$t('SeaExport.CustomsBroker'), field: 'customsBroker', width: 180, colId: 'customsBroker',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_9') : ''
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.Marks'),
          field: 'mark',
          colId: 'mark',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.CustomerOffice'),
          field: 'csrOffice',
          colId: 'csrOffice',
          hide: true,
          width: 100,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.data.cooperateCsrCompany), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.DocumentOffice'),
          field: 'dcOffice',
          colId: 'dcOffice',
          hide: true,
          width: 100,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.data.cooperateDcCompany), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.OperationRequirements'),
          field: 'operationContent',
          colId: 'operationContent',
          hide: true,
          width: 180,
          cellRenderer: (params) => {
            return params.value.replace(/[\n]/g, ',')
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.specialOperationCode'),
          field: 'specialOperationCode',
          colId: 'specialOperationCode',
          hide: true,
          width: 180
        }
      ],
      imperialColumnAdds: [
        { headerName: this.$t('SeaExport.CommissionedGrossWeight') + '(LB)', field: 'weightContractImperial', width: 180, colId: 'weightContractImperial',
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(Number(params.value), 3)
          },
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.CommissionedVolume') + '(CFT)', field: 'cubAgeContractImperial', width: 180, colId: 'cubAgeContractImperial',
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(Number(params.value), 3)
          },
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.ActualWeight') + '(LB)', field: 'weightActualImperial', width: 180, colId: 'weightActualImperial',
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(Number(params.value), 3)
          },
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        { headerName: this.$t('SeaExport.ActualVolume') + '(CFT)', field: 'cubAgeActualImperial', width: 180, colId: 'cubAgeActualImperial',
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(Number(params.value), 3)
          },
          enableRowGroup: true,
          summaryMode: 'sum'
        }
      ],
      rowData: [],
      gridApi: null,
      exportCommand: this.$t('SeaExport.ExportToExcel'),
      chargeCommand: this.$t('SeaExport.AddCharges'),
      documentManage: new DocumentManage(),
      stateDialog: {
        visible: false,
        rows: [],
        trackingList: []
      },
      shutOutDialog: {
        visible: false,
        shutOutTip1: '',
        shutOutTip2: '',
        shutOutButtonShow2: '',
        jobKeys: '',
        hasCharge: false
      },
      transshipDialog: {
        visible: false,
        jobKeys: [],
        selectedJobs: [],
        isDBFlag: true,
        txtVessel: '',
        txtVessel_1: '',
        txtVoyage: '',
        txtVoyage_1: '',
        txtCarrierId: '',
        dfETD: '',
        txtBookingAgent: '',
        voyages: '',
        transship: {}
      },
      fullSpellTypeDialog: {
        visible: false,
        jobKeys: [],
        jobList: [],
        containerLoadType: '',
        containerLoadTypes: ContainerLoadType.CONTAINERLOAD_TYPES_ALL_LCL
      },
      templateSelectorDialog: {
        visible: false,
        ctx: new AirExportJob(),
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      statisticsDialog: {
        visible: false,
        txtSlaves: 0,
        txtMaster: 0,
        txtCount: 0,
        txtCustomerCount: 0,
        txtQuantityActual: 0,
        txtWeightActual: 0.000,
        txtCubageActual: 0.000,
        txtQuantityContract: 0,
        txtWeightContract: 0.000,
        txtCubageContract: 0.000,
        txtChargeWeightActual: 0.000,
        txtChargeWeightContract: 0.000,
        txtdesignationAgentNum: 0,
        containShutOutJob: false
      },
      addChargeDetailDialog: {
        visible: false,
        type: 0,
        selectedScheme: [],
        selectedJobs: []
      },
      chargeTypeDialog: {
        visible: false,
        selectedJobs: [],
        type: 0
      },
      returnReviewDialog: {
        visible: false,
        selectedJobs: []
      },
      role: {
        addReceivableChargeRole: this.$checkPermission(['button_Charge_payAddCharge']),
        addPayableChargeRole: this.$checkPermission(['button_Charge_costAddCharge'])
      },
      editChargeDetailDialog: {
        visible: false,
        selectedJobs: []
      },
      deleteChargeDetailDialog: {
        visible: false,
        selectedJobs: []
      },
      chargeSchemeBatchDialog: {
        visible: false,
        selectedJobs: [],
        originalCondition: {},
        needCheckRange: true,
        isSea: false,
        lob: 'AE',
        source: 'jobList',
        chargeType: null,
        chargeSchemeIsApproved: false // 费用方案需是否审核后才能使用【费用方案页签使用】
      },
      lob: 'AE',
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        allowPartialCheckPass: false,
        checkNode: 0,
        callBack: null,
        callBack2: null
      },
      checkingWindow: {
        visible: false,
        checkNode: 0,
        callBack: null,
        callBack2: null
      },
      bookingPrintWindow: {
        visible: false,
        jobs: []
      },
      office: null,
      headers: {
        sessionId: this.$store.getters.token,
        ContentType: 'multipart/form-data'
      },
      exportOrderCommand: this.$t('SeaExport.Add'),
      podInfo: { // 批量修改目的港信息
        visible: false,
        keys: [],
        estimatedDeliveryToWarehouseTime: '',
        deliveryTime: '',
        destPortDeliveryTime: '',
        deliveryCompletionDate: '',
        estDeliveryTime: '',
        actDeliveryTime: ''
      },
      customSearchItems: [],
      batchSubmitOrApproveDialog: {
        visible: false,
        rowData: []
      },
      paramsBpm: [],
      opOffice: null,
      batchModifyBusinessDialog: {
        visible: false,
        jobList: [],
        jobKeys: [],
        lob: ''
      },
      changeSopTemplateDialog: {
        visible: false,
        jobList: []
      },
      batchCooperationDialog: {
        visible: false,
        jobList: []
      },
      downloadImportTemplateDialog: {
        visible: false,
        lob: 'AE'
      },
      workFlowApplyDialog: {
        visible: false
      },
      isBpmEnabled: false,
      selectedRows: [],
      defaultSearchItems: [],
      unitLoadResult: {
        visible: false,
        isSuccess: false
      },
      gpExplain: {
        type: 'list',
        visible: false,
        jobUuids: []
      },
      isZY: false,
      dataListDragGroup: false, // 是否支持数据列表拖拽分组特性
      modifyBranchDialog: { // 批量修改目的港信息
        visible: false,
        jobKeys: []
      },
      instructioinBtns: [] // 指令按钮列表
    }
  },
  computed: {
    searchItemConfigModule() {
      return this.isFba ? '10012' : '900'
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    finalColumnDefs() {
      let result = []
      for (const columnDef of this.columnDefs) {
        if (!this.bookingAgentVisible && columnDef.field === 'bookingAgent') {
          continue
        }
        result.push(columnDef)
      }
      result.push(...this.columnAdds)
      if (this.$store.state.uiCustom.enable && !this.isFba) {
        result = UICustomUtil.handleColumnDefs(UICustomConstants.AIR_BOOKING_MODULE, this.$store.getters.currentOfficeId, result)
      }
      return result
    },
    job() {
      return this.selectedJob
    },
    colorSettings() {
      return this.$store.state.settings.colorSettings
    },
    colorType() {
      return Number(this.$store.state.settings.colorType) === 1
    },
    actionOrderUrl() {
      return URL.sys.importOrderTemplate
    },
    importUnitLoadInfoUrl() {
      return URL.booking.airExport.importUnitLoadInfo
    },
    fbaColumnDefs() {
      return [...this.columnDefs, ...this.fbaColumns]
    },
    useOrderCenterMode() { // 是否开启接单中心模式
      return cache.config ? Number(cache.config.get('useOrderCenterMode')) === 1 : false
    },
    orderCenterBranch() { // 是否接单分公司
      return cache.config ? Number(cache.config.get('orderCenterBranch')) === 1 : false
    },
    bookingAgentVisible() {
      return SalesUtil.salesCanBookingAgent(this.salesCanSeeBookingAgent)
    },
    openMutualTrustConfig() {
      return cache.config ? Number(cache.config.get('openMutualTrustConfig')) === 2 : false
    },
    airMblDisplayStyle() {
      return cache.config ? Number(cache.config.get('AirMblDisplayStyle')) === 1 : false
    },
    location() {
      if (!this.isFba) {
        return LOG_AE_AIR_BOOKING.code
      }
      return ''
    },
    isHQ() {
      return this.$store.getters.currentOfficeId === 1
    },
    conditonDisplayAllBranchData() {
      return this.$store.getters.currentOfficeId === 1 && this.hqViewAllList
    },
    hqDisabledOperate() {
      return this.$store.getters.currentOfficeId === 1 && this.hqViewAllList
    },
    hqDisabledViewDetail() {
      return this.$store.getters.currentOfficeId === 1 && this.hqViewAllList && !this.hqViewAllDetail
    },
    validSingleSelect() {
      if (this.hqViewAllList) {
        if (this.$store.getters.currentOfficeId === 1) {
          return false
        }
        if (!this.isZy && this.hierarchyViewDetail && this.selectedJob) {
          if (this.childOfficeIds.includes(this.selectedJob.opOffice) || this.childOfficeIds.includes(this.selectedJob.salesOffice)) {
            return true
          }
        }
        if (this.selectedJob && this.selectedJob.opOffice !== this.$store.getters.currentOfficeId && this.selectedJob.salesOffice !== this.$store.getters.currentOfficeId && !this.mactchCooperateBranch(this.selectedJob.cooperatebranch, this.$store.getters.currentOffice)) {
          return false
        }
      }
      return true
    },
    validMultipleSelect() {
      if (this.hqViewAllList) {
        if (this.$store.getters.currentOfficeId === 1) {
          return false
        }
        for (const row of this.selectedRows) {
          if (!this.isZy && this.hierarchyViewDetail && row) {
            if (this.childOfficeIds.includes(row.opOffice) || this.childOfficeIds.includes(row.salesOffice)) {
              return true
            }
          }
          if (row.opOffice !== this.$store.getters.currentOfficeId && row.salesOffice !== this.$store.getters.currentOfficeId && !this.mactchCooperateBranch(row.cooperatebranch, this.$store.getters.currentOffice)) {
            return false
          }
        }
      }
      return true
    }
  },
  watch: {
    colorSettings: {
      handler() {
        this.gridOptions.api.redrawRows()
      },
      deep: true
    },
    async conditonDisplayAllBranchData() {
      this.customSearchItems = await this.getCustomSearchItems()
    },
    '$store.getters.currentOfficeId': {
      async handler() {
        this.customSearchItems = await this.getCustomSearchItems()
        this.loadInstructionButtons()
      }
    }
  },
  async created() {
    await cache.load(cacheName.OFFICE, cacheName.CONFIG)
    this.office = cache.office
    await this.preloadBasicData()
    await this.initColumnDefs()
    this.arSettlementUnitOptional = parseInt(cache.config.get('ArSettlementUnitOptional')) === 1
    if (cache.config.get('sendToPlatform')) {
      this.sendToPlatform = cache.config.get('sendToPlatform').toString().includes('jdy')
    }
    this.loadInstructionButtons()
    if (this.isQuery) return
    if (!this.$route.params.jobNo) {
      this.queryLastModifyBookingByDay()
    }
    this.customSearchItems = await this.getCustomSearchItems()
  },
  beforeMount() {
    const context = this
    this.documentManage.set('showBusinessInfo', function() {
      context.showBusinessInfo()
    })
    this.documentManage.set('showWorkFlowApplyDialog', function(documentProcessId) {
      WorkflowUtil.showWorkFlowApplyDialog(context, context.workFlowApplyDialog, 'workFlowApplyDialog', documentProcessId)
    })
  },
  mounted() {
    if (this.$route.params.job) {
      setTimeout(job => {
        this.$emit('add', job)
      }, 100, this.$route.params.job)
      delete this.$route.params.job
    }
  },
  activated() {
    if (this.$route.params.job) {
      this.$emit('add', this.$route.params.job)
      delete this.$route.params.job
    }
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    async initColumnDefs() {
      // CARGO-31277 SOPSOP节点显示列增加
      const sopColumns = await SopUtil.getSopColumns('AE')
      this.columnDefs = [...this.columnDefs, ...sopColumns]
      await JobUtils.enrichTotalRevenueColumnDefs(this.columnDefs, this)
      if (this.isBpmEnabled) {
        this.columnDefs.push({
          headerName: this.$t('CargoMsg.Cargo_ApprovalSerialNumber'),
          field: 'documentProcessNo',
          colId: 'documentProcessNo',
          width: 200,
          hide: true,
          excelRenderer: (params) => {
            if (params.value) {
              return params.value
            }
            return ''
          },
          cellRenderer: (params) => {
            if (params.value) {
              const methodPath = this.documentManage.getPath('showWorkFlowApplyDialog')
              return `<a onclick="${methodPath}(${params.data.documentProcessId})" style="color:blue">` + params.value + '</a>'
            }
            return ''
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return params.data.documentProcessNo ? params.data.documentProcessNo : ''
          }
        })
      }
      if (this.isZY) {
        this.columnDefs.push(
          {
            headerName: this.$t('CargoMsg.AllowSaleProduct'),
            field: 'saleProductCode',
            colId: 'saleProductCode',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_AllowSaleProduct, 'productCode', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.FullOrInside'),
            field: 'fullOrInside',
            colId: 'fullOrInside',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.fullOrInsideLabelFun(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ContainSensitiveWord'),
            colId: 'hasSensitiveWord',
            field: 'hasSensitiveWord',
            width: 130,
            minWidth: 130,
            hide: true,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_SystemConstants$HAS_SENSIVITE_WORD, 'code', params.value, 'chineseName')
            }
          }
        )
      }
      // 英制单位开启时 ，设置英制显示列
      await JobUtils.initImperialSetting().then(r => {
        if (r) {
          this.columnDefs.push(...this.imperialColumnAdds)
        }
      })
    },
    // 加载指令按钮
    async loadInstructionButtons() {
      const res = await getInstructions({
        module: UICustomConstants.AIR_BOOKING_MODULE,
        branchId: this.$store.getters.currentOfficeId,
        useHqSet: true
      })
      this.instructioinBtns = res.data
    },
    validSelectJob(obj) {
      if (this.hqViewAllList) {
        if (this.$store.getters.currentOfficeId === 1) {
          return false
        }
        if (obj && obj.opOffice !== this.$store.getters.currentOfficeId && obj.salesOffice !== this.$store.getters.currentOfficeId && !this.mactchCooperateBranch(obj.cooperatebranch, this.$store.getters.currentOffice)) {
          return false
        }
      }
      return true
    },
    hierarchyValidSingleSelectJob(obj) {
      if (this.hierarchyViewList && obj) {
        return this.matchOwnerBranch(obj)
      }
      return true
    },
    printHandler() {
      const rows = this.gridApi.getSelectedRows()
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(rows)
      }
      let passThrough = true
      for (const job of rows) {
        if (job.blocked) {
          passThrough = false
          break
        }
      }
      if (!passThrough) {
        this.$message.warning(this.$t('queryJob.TheSelectedRecordMustSame'))
        return
      }
      if (this.bookingPrintValidate()) {
        this.bookingPrintWindow.jobs = rows
        this.bookingPrintWindow.visible = true
      }
    },
    // 是否是同一个航空公司
    bookingPrintValidate() {
      if (!this.hasSame('carrierId')) {
        this.$message.warning(this.$t('queryJob.TheSelectedRecordsMustSame'))
        return false
      }
      if (!this.hasSame('ETD')) {
        this.$message.warning(this.$t('queryJob.TheSelectedRecordMustSame'))
        return false
      }
      return true
    },
    hasSame(property) {
      let tmp = null
      let b = true
      const rows = this.gridApi.getSelectedRows()
      for (const job of rows) {
        if (tmp == null) { tmp = job[property] }
        if (tmp !== job[property]) {
          b = false
          break
        }
      }
      return b
    },
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    async onGridCellFocused(event) {
      // 等待gridApi被赋值
      this.$nextTick(async() => {
        // 等待gridApi被赋值
        await ensureExecuteSuccess(() => this.gridApi)
        this.selectedJob = null
        this.manageAuditStatus = 0
        if (this.gridApi && event.column) {
          this.gridApi.forEachNode(node => {
            if (node.data && node.rowIndex === event.rowIndex) {
              this.selectedJob = node.data
              this.manageAuditStatus = this.selectedJob.manageAuditStatus
            }
          })
          // this.$logger.log('===onGridCellFocused====', this.selectedJob.jobNo + '_' + this.selectedJob.jobState)
        }
      })
    },
    // 选中 勾选框触发[获取选中行]
    onGridRowSelected(event) {
      if (event.node.isSelected() && event.data) {
        this.selectedJob = event.data
      }
      this.$logger.log('===onGridRowSelected====', this.selectedJob.jobNo + '_' + this.selectedJob.jobState)
    },
    onGridReady(p) {
      // console.log('gridReady', p)
      this.gridApi = p.api
    },
    // 选中或取消勾选触发事件
    onRowClicked(event) {
      if (!event.data) {
        return
      }
      this.selectedJob = event.data
      this.updateJobState()
      this.$nextTick(async() => {
        // 等待gridApi被赋值
        await ensureExecuteSuccess(() => this.gridApi)
        this.updateControlsState()
      })
    },
    // 批量操作按钮权限控制
    updateControlsState() {
      // console.log('grid', this.gridApi)
      const rows = this.gridApi.getSelectedRows()
      this.btnInfo.batchSelectFlag = rows.length > 0
      this.btnInfo.enableBtnSplit = false
      for (const item of rows) {
        if (item.lclMasterUuid) {
          this.btnInfo.enableBtnSplit = true
          break
        }
      }
    },
    updateJobState() {
      const job = this.selectedJob
      if (job != null) {
        this.btnInfo.label.btnShutout = this.$t('SeaExport' + (job.jobState === 3 ? 'CancelShutOut' : 'ShutOut'))

        if (job && !job.masterFlag && (job.containerLoadType !== ContainerLoadType.LCL_CARGO_TYPE.code)) {
          // btnProfit.label ="整箱利润打印";
          this.btnInfo.label.btnProfit = this.$t('SeaExport.PrintFclProfit')
        } else {
          // btnProfit.label =this.$t('SeaExport.PrintLclProfit');
          this.btnInfo.label.btnProfit = this.$t('SeaExport.PrintLclProfit')
        }

        if (job && job.jobState !== 3) {
          this.btnInfo.enabled.btnProfit = this.btnInfo.privilege.button_JobBooking_Submit || this.btnInfo.privilege.button_JobBooking_PrintProfit
        } else {
          this.btnInfo.enabled.btnProfit = false
        }

        this.btnInfo.visible.btnManagerAuditSubmit = this.btnInfo.privilege.button_JobBooking_ManagerAuditSubmit && job.manageAuditStatus === 1 && (job.jobState === SystemConstants.OPERATING || job.jobState === SystemConstants.PRE_COMMIT)
        this.btnInfo.visible.printReturn = job.jobState === SystemConstants.COMMITED && this.btnInfo.privilege.button_JobBooking_Retract
        this.btnInfo.visible.printReturnOperate = job.jobState === SystemConstants.PRE_COMMIT && this.btnInfo.privilege.button_JobBooking_ReturnToOperater
        this.btnInfo.visible.btnSubmit = (job.jobState === SystemConstants.OPERATING || job.jobState === SystemConstants.PRE_COMMIT) && this.btnInfo.privilege.button_JobBooking_Submit && (job.manageAuditStatus === 0 || job.manageAuditStatus === 3)
        this.btnInfo.visible.btnManagerSubmit = (job.jobState === SystemConstants.OPERATING || job.jobState === SystemConstants.PRE_COMMIT) && this.btnInfo.privilege.button_JobBooking_ManagerSubmit
        this.btnInfo.visible.btnPreSubmit = job.jobState === SystemConstants.OPERATING && this.btnInfo.privilege.button_JobBooking_PreSubmit && (job.manageAuditStatus === 0 || job.manageAuditStatus === 3)
      }
    },
    // 初始化配置参数
    async preloadBasicData() {
      await cache.load(cacheName.CONFIG)
      this.ticketsMustBeVoted = Number(cache.config.get('TicketsMustBeVoted')) === 1
      this.useCheckRule = Number(cache.config.get('useCheckRule')) === 1
      this.allowPartialCheckPass = Number(cache.config.get('allowPartialCheckPass')) === 1
      this.checkApChargeVerify = Number(cache.config.get('PreCommitJobCheckApChargeStateVerify')) === 1
      this.editVessel = Number(cache.config.get('EditVesselVoyageMode'))
      this.toExoSystemYGSH = String(cache.config.get('ToExoSystem')) === 'YGSH' // 阳光速航
      this.chargeSchemeBatchDialog.chargeSchemeIsApproved = Number(cache.config.get('ChargeSchemeIsApproved')) === 1 // 费用方案需是否审核后才能使用【费用方案页签使用】
      this.salesCanSeeBookingAgent = Number(cache.config.get('SalesCanSeeBookingAgent')) === 1
      this.isBpmEnabled = await WorkflowUtil.isBpmEnabled({
        documentConfigId: Job_CHARGE.code,
        officeId: this.$store.getters.currentOfficeId
      })
      this.isZY = String(cache.config.get('ToExoSystem')) === 'zy'
      this.dataListDragGroup = Number(cache.config.get('DataListDragGroup')) === 1
    },
    // 查询[简单查询/高级查询]
    toQuery(saveJobNos, removedJobNos) {
      if (saveJobNos && saveJobNos.length > 0 || removedJobNos && removedJobNos.length > 0) {
        this.toBackQuery(saveJobNos, removedJobNos)
        return
      }
      this.filter.pageNum = 1
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery(this.filter.snapshotConditions)
      } else {
        this.toSimpleQuery()
      }
    },
    // 分页查询
    toQueryByPage() {
      if (this.isQuickQuery) {
        this.queryLastModifyBookingByDay()
      } else if (this.isAdvancedQuery) {
        this.toAdvancedQuery(this.filter.snapshotConditions)
      } else {
        this.toSimpleQuery()
      }
    },
    // 查询最近几天的业务
    queryLastModifyBookingByDay() {
      this.loading = getLoading()
      this.filterJson = {}
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.filterJson.createdBy = this.$store.getters.userId
      this.filterJson.fba = this.isFba // 是否fba业务
      this.isQuickQuery = true
      const conditions = []
      // const condition = new AdvancedSearchOption(null, 'job.OP_OFFICE', this.$store.getters.currentOfficeId, OperatorConstants.OPERATOR_EQUAL.code)
      // conditions.push(condition.formatObj2Json())
      const jobStates = [SystemConstants.STATE_VERIFYING.code, SystemConstants.STATE_REJECT.code]
      const condition2 = new AdvancedSearchOption(null, 'job.JOB_STATE', jobStates, AdvancedSearchConsts.OPERATOR_NOT_IN.code)
      conditions.push(condition2.formatObj2Json())
      this.filterJson.conditions = conditions
      if (this.isBpmEnabled) {
        this.filterJson.requires = ['bpm']
      }
      queryLastModifyBookingByDay(this.filterJson).then(res => this.handleQueryData(res))
    },
    // 高级查询
    toAdvancedQuery(data) {
      this.filterJson = {}
      this.isQuickQuery = false
      this.loading = getLoading()
      if (typeof data !== 'undefined') {
        this.filter.snapshotConditions = data
        // 高级查询条件组装
        this.filterJson.conditions = this.addConditionsBeforeQuery(data)
        // 获取追加查询条件
        this.appendQuery = JobUtils.appendQueryCondition(this.filterJson.conditions)
      }
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.filterJson.fba = this.isFba // 是否fba业务
      this.filterJson.appendQuery = this.appendQuery
      if (this.isBpmEnabled) {
        this.filterJson.requires = ['bpm']
      }
      advancedQuery(this.filterJson).then(res => this.handleQueryData(res)).catch(() => {
        this.loading.close()
      })
    },
    // 查询之前的条件组装
    addConditionsBeforeQuery(data) {
      if (typeof data === 'undefined') return
      // 操作分公司
      // const officeId = this.$store.getters.currentOfficeId
      // if (officeId && officeId > 0) {
      //   data.push(new AdvancedSearchOption(null, 'job.OP_OFFICE', officeId, AdvancedSearchConsts.OPERATOR_EQUAL.code).formatObj2Json())
      // }
      // 业务状态
      if (!AdvancedSearchOption.hasField('job.JOB_STATE', data)) {
        const jobStates = [SystemConstants.STATE_VERIFYING.code, SystemConstants.STATE_REJECT.code]
        const option = new AdvancedSearchOption(null, 'job.JOB_STATE', jobStates, AdvancedSearchConsts.OPERATOR_NOT_IN.code)
        data.push(option.formatObj2Json())
      }
      // 业务状态追踪
      const trackingOption = AdvancedSearchOption.removeOption('job.tracking', data)
      if (trackingOption && trackingOption.value) {
        const tracking = trackingOption.value['tracking']
        const trackingDetails = trackingOption.value['trackingDetails']
        const detailCodes = []
        for (const detail of trackingDetails) {
          detailCodes.push(detail.code)
        }
        data.push(new AdvancedSearchOption(null, 'trackingInfo.CODE', tracking.code, AdvancedSearchConsts.OPERATOR_EQUAL.code).formatObj2Json())
        data.push(new AdvancedSearchOption(null, 'trackingInfo.SUB_CODE', detailCodes, AdvancedSearchConsts.OPERATOR_IN.code))
      }

      // 目的港服务查询参数组装
      const portOption = AdvancedSearchOption.getOption('job.portOfDestinationServices', data)
      if (portOption != null) {
        const codes = portOption.value
        const services = []
        for (const code of codes) {
          const service = CommonState.getStateByCode(SeaExportConstants.DESTINATION_TYPES, code)
          if (service != null) services.push(service)
        }
        const destinationTypes = this.convertDestinationTypesToQuery(services)
        for (const type in destinationTypes) {
          data.push(new AdvancedSearchOption(null, destinationTypes[type], 1).formatObj2Json())
        }
      }
      if (AdvancedSearchOption.hasField('job.portOfDestinationServices', data)) {
        AdvancedSearchOption.removeOption('job.portOfDestinationServices', data)
      }

      return data
    },
    // 本地服务条件处理
    convertStuffyTypeToQuery(items) {
      const result = []
      for (const stuffyType of items) {
        if (stuffyType.code === 'IS') {
          result.push('job.WAREHOUSING')
        } else if (stuffyType.code === 'DD') {
          result.push('job.LAND_TRANSPORTATION')
        } else if (stuffyType.code === 'SD') {
          result.push('job.SELF_DELIVER')
        } else if (stuffyType.code === 'CT') {
          result.push('seaJob.CUSTOMS')
        } else if (stuffyType.code === 'HT') {
          result.push('seaJob.HEATING')
        } else if (stuffyType.code === 'CIT') {
          result.push('seaJob.COMERCIAL_INSPECTATION')
        } else if (stuffyType.code === 'AMS') {
          result.push('seaJob.AMS')
        } else if (stuffyType.code === 'ISBOOKING') {
          result.push('job.BOOKING')
        }
      }
      return result
    },
    // 目的港服务条件处理
    convertDestinationTypesToQuery(items) {
      const result = []
      for (const type of items) {
        if (type.code === '1') {
          result.push('job.DEST_PORT_CUSTOMS_CLEARANCE')
        } else if (type.code === '2') {
          result.push('job.DISCHARGING_PORT_DOOR')
        } else if (type.code === '3') {
          result.push('job.US_CUSTOMS_CLEARANCE')
        }
      }
      return result
    },
    // 简单查询
    toSimpleQuery(keyword, useAdmin = false) {
      this.appendQuery = false // 关闭追加查询
      this.isQuickQuery = false
      this.loading = getLoading()
      if (typeof keyword !== 'undefined') {
        this.filter.jobNo = keyword.trim()
        this.filter.useAdmin = useAdmin
        this.filter.pageNum = 1
      }
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.filterJson = {}
      this.filterJson.conditions = []
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.filterJson.jobNo = this.filter.jobNo
      this.filterJson.useAdmin = this.filter.useAdmin
      this.filterJson.fba = this.isFba // 是否fba业务
      const conditions = []
      // const condition = new AdvancedSearchOption(null, 'job.OP_OFFICE', this.$store.getters.currentOfficeId, OperatorConstants.OPERATOR_EQUAL.code)
      // conditions.push(condition.formatObj2Json())
      const jobStates = [SystemConstants.STATE_VERIFYING.code, SystemConstants.STATE_REJECT.code]
      const condition2 = new AdvancedSearchOption(null, 'job.JOB_STATE', jobStates, AdvancedSearchConsts.OPERATOR_NOT_IN.code)
      conditions.push(condition2.formatObj2Json())
      this.filterJson.conditions = conditions
      if (this.isBpmEnabled) {
        this.filterJson.requires = ['bpm']
      }
      return advancedQuery(this.filterJson).then(res => this.handleQueryData(res)).catch(() => {
        this.loading.close()
      })
    },
    // 返回查询
    toBackQuery(jobs, removedJobs) {
      setTimeout(() => {
        this.backHandleQueryData(jobs, removedJobs)
      })
    },
    backHandleQueryData(results, removedJobs) {
      let hasNew = false // 是否有新增数据
      for (const item of results) {
        const index = this.rowData.findIndex(p => p.uuid === item.uuid)
        if (index >= 0) {
          this.rowData[index] = item
        } else {
          this.rowData.push(item)
          hasNew = true
        }
      }
      for (let i = this.rowData.length - 1; i >= 0; --i) {
        if (removedJobs.findIndex(p => p.uuid === this.rowData[i].uuid) >= 0) {
          this.rowData.splice(i, 1)
        }
      }
      if (hasNew || removedJobs.length > 0) {
        /* 记录勾选项 */
        const rows = this.gridApi.getSelectedRows()
        if (rows.length > 0) {
          const keys = Array.from(rows, p => p.uuid)
          setTimeout(() => {
            const masterSelectedSet = new Set()
            const nodes = this.gridApi.rowModel.rowsToDisplay
            for (const node of nodes) {
              if (!node.data) {
                continue
              }
              if (keys.includes(node.data.uuid)) {
                node.setSelected(true)
                if (node.data.masterFlag) {
                  masterSelectedSet.add(node.data.uuid)
                }
              } else {
                if (node.data.lclMasterUuid && masterSelectedSet.has(node.data.lclMasterUuid)) {
                  setTimeout(() => {
                    node.setSelected(false)
                  })
                }
              }
            }
          }, 100)
        }
      } else {
        const nodes = this.gridApi.rowModel.rowsToDisplay
        for (const item of results) {
          const node = nodes.find(p => p.data && p.data.uuid === item.uuid)
          node.setData(item)
        }
        // this.gridApi.resetRowHeights()
      }
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      const selectedStatus = recordSelectedStatus(this.gridOptions.api, 'uuid')
      let results = res.data.list
      // 对返回结果进行排序放在后端 getJobsBySort 方法
      if (this.appendQuery) { // 追加查询数据去重
        results = JobUtils.appendQueryRepeat(this.rowData, results, this.appendQuery)
        this.total = results.length
      } else {
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.total = Number(res.data.total)
        this.pageCount = res.data.pages
      }
      this.rowData = results
      if (this.gridApi) {
        this.gridApi.clearFocusedCell()
      }
      this.selectedRowCount = 0
      // 动态添加SOP显示列[根据SOP显示列字段进行拆分]
      this.handleSopField(this.rowData)
      this.loading.close()
      selectedStatus.revert()
    },
    // 动态添加SOP显示列[根据SOP显示列字段进行拆分]
    handleSopField(rowData) {
      for (let i = 0; i < rowData.length; i++) {
        const seaJob = rowData[i] // 当前行
        const currentJobSopState = seaJob.sopState // 当前行的SOP数据
        if (!currentJobSopState) continue
        const tracks = currentJobSopState.split(',')
        // console.log('==========tracks===========', tracks)
        // 循环每个节点Sop数据，动态添加显示列
        for (let j = 0; j < tracks.length; j++) {
          const currentTrack = tracks[j]
          if (!currentTrack) continue
          const columnName = currentTrack.split('(')[0]
          const oldColumnValue = currentTrack.split('(')[1].split(')')[0]
          const columnValue = !oldColumnValue ? '' : oldColumnValue
          //
          const columnField = '_sop_' + columnName
          rowData[i][columnField] = columnValue
        }
      }
    },
    // 查看
    async toLook(row) {
      const action = row && Number(cache.config.get('JobDirectEditingStatus')) === 1 && row.jobState === 0 && !JobUtils.isBlockJob(row) && (await SecurityUtil.canEdit(new AirExportJob(row))) ? 'edit' : 'look'
      if (!row) {
        row = this.selectedJob || this.readSelectedRows()[0]
      }
      this.$emit(action, row)
    },
    // 获取选中行 dataType 区分拆并单数据 业务数据，1 主票 2 小票 3 MBL 4 MBL2 5 HBL2
    readSelectedRows() {
      const allRows = this.gridApi.getSelectedRows()
      const rows = []
      for (const row of allRows) {
        if (row.hasOwnProperty('dataType') && (Number(row.dataType) === 1 || Number(row.dataType) === 2)) {
          rows.push(row)
        }
      }
      if (rows.length === 0) {
        throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
      }
      return rows
    },
    // 编辑
    async toEdit() {
      const row = this.selectedJob || this.readSelectedRows()[0]
      if (row == null) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      if (row.jobState !== 0) {
        this.$message.info(this.$t('Message.ThisJobIsNotWorkingCanNotBeEdited'))
        return
      }
      if (!await SecurityUtil.canEdit(new AirExportJob(row))) {
        this.$message.info(this.$t('Message.NoPermissionToEditTheJob'))
        return
      }
      this.$emit('edit', row)
    },
    // 新增
    toAdd(row) {
      this.$emit('add', row || {})
    },
    // 拆分主票
    toSplit() {
      const rows = this.readSelectedRows()
      const jobKeys = [] // 已加入主票的小票uuids
      for (const item of rows) {
        if (item.lob === 'SE' && item.lclMasterUuid) {
          jobKeys.push(item.uuid)
        }
      }
      if (jobKeys.length === 0) {
        this.$message.warning(this.$t('Message.NoBusinessCanBeSplit'))
        return
      }

      const params = {
        jobKeys: jobKeys,
        splitPattern: 0 // 拆分模式 0.选择小票拆分 1.按装箱信息拆分
      }
      splitMaster(params).then(res => {
        const newSplitJob = res.data
        this.$logger.log('=====newSplitJob=====', newSplitJob)
        this.$logger.log('=====newSplitJob.seaEQ=====', newSplitJob.seaEQ)
        this.$logger.log('=====newSplitJob.lclSlaves=====', newSplitJob.lclSlaves)
        if (!newSplitJob || !newSplitJob.seaEQ || newSplitJob.seaEQ.length === 0) {
          this.$message.warning(this.$t('Message.SplittingErrorContainerInformationIsEmpty'))
          return
        }
        this.$emit('split', newSplitJob)
      })
    },
    // 复制
    toCopy() {
      const jobList = this.readSelectedRows()
      if (!jobList || jobList.length <= 0) {
        this.$message.info(this.$t('Message.SelectJob'))
        return
      }
      if (jobList.length > 1) {
        this.$message.info(this.$t('Message.SelectOneJob'))
        return
      }
      const usefulJob = jobList[0]
      if (usefulJob.masterFlag) {
        this.$emit('copy', usefulJob)
        return
      }
      if (usefulJob.customerId) {
        isContractExpiredForbidCreateJob(usefulJob.customerId).then(res => {
          if (res.data) {
            this.$message.info(this.$t('Message.ContractExpireCannotCreated'))
          } else {
            this.$emit('copy', usefulJob)
          }
        })
      }
    },
    onImportSucceeded(message) {
      if (message) {
        this.$message.info(this.$t('Message.Page') + message + this.$t('queryJob.ThatSOk'), this.$t('Message.ImportSuccessful1'))
      }
    },
    // 删除
    toDelete() {
      const rows = this.readSelectedRows()
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(rows)
      }
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (item.jobState > 0) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('queryJob.NotInPositiveOperation'))
          return
        }
      }
      const jobKeys = []
      for (const row of rows) {
        jobKeys.push(row.uuid)
      }
      validateJobForDelete({ keys: jobKeys }).then(res => this.handlerDelete(res))
    },
    // 删除验证结果
    handlerDelete(res) {
      const delMap = res.data
      if (!delMap.canDelete) {
        if (delMap.hasDelete) {
          this.$message.warning(this.$t('CargoMsg.HasDeletedForDeleteJob'))
        }
        if (delMap.existsSlaveJob) {
          this.$message.warning(this.$t('CargoMsg.HasSlaveJobForDeleteJob', [delMap.jobNo]))
        }
        if (delMap.existsCharge) {
          this.$message.warning(this.$t('CargoMsg.HasChargeForDeleteJob', [delMap.jobNo]))
        }
        if (delMap.existsMergeJob) {
          this.$message.warning(this.$t('CargoMsg.HasMergeForDeleteJob', [delMap.jobNo]))
        }
        return
      }

      const rows = this.readSelectedRows()
      const jobKeys = Array.from(rows, p => p.uuid)
      this.$confirm(this.$t('Message.SureDeleteThese') + jobKeys.length + this.$t('Message.OrdersOfBusiness'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        batchDeleteJob({ jobKeys, opLob: 'AE', location: this.location }).then(res => this.handlerDeleteResult(res))
      }).catch(() => {
      })
    },
    // 删除成功处理
    handlerDeleteResult(res) {
      const result = res.data
      if (result > 0) {
        this.$message.success(this.$t('Message.DeleteSuccessfully'))
        this.selectedJob = null
        const rows = this.readSelectedRows()
        for (const row of rows) {
          const index = this.rowData.indexOf(row)
          this.rowData.splice(index, 1)
        }
        this.gridApi.refreshCells({ force: true })
      }
    },
    // 导出公共
    exportHandle() {
      const rows = this.readSelectedRows()
      if (!rows || rows.length === 0) {
        this.$message.info('CargoMsg.Cargo_NoDataSelected')
        return
      }
      const timestamp = new Date().getTime()
      console.log('====开始时间======', timestamp)
      switch (this.exportCommand) {
        case this.$t('SeaExport.ExportToExcel'):
          this.toExportToExcel()
          break
        case this.$t('SeaExport.OverseasAgentEDI'):
          this.toOverseasAgentEDI()
          break
        case this.$t('SeaExport.ExportWithSOPToExcel'):
          this.toExportWithSOPToExcel()
          break
        case this.$t('CargoMsg.Cargo_ExportCustomsDeclaration'):
          this.toExportCustomsList()
          break
        case this.$t('SeaExport.Export9610File'):
          this.toExport9610File()
          break
      }
    },
    async toExport9610File() {
      // 获取选中行
      let rows = null
      try {
        rows = this.readSelectedRows()
      } catch (e) {
        this.$alert(this.$t('common.tips.hasOneAtleast'), {
          confirmButtonText: this.$t('common.btn.close')
        })
        return
      }
      const newRows = jc.decycle(rows)
      if (!newRows || newRows.length <= 0) return
      let sendJobKey = newRows[0].uuid
      if (newRows.length > 1) {
        const masterJobs = newRows.filter(job => job.masterFlag)
        // 勾选多笔且不存在主票的情况下 或 勾选存在多笔主票的情况下 返回
        if (masterJobs.length <= 0 || masterJobs.length > 1) {
          this.$alert(this.$t('SeaExport.OnlyCheckOneData'), {
            confirmButtonText: this.$t('common.btn.close')
          })
          return
        }
        // 若存在一个主票 且其他票不属于该主票 则返回
        sendJobKey = masterJobs[0].uuid
        for (const job of newRows) {
          if (job.uuid !== sendJobKey && job.lclMasterUuid !== sendJobKey) {
            this.$alert(this.$t('SeaExport.OnlyCheckOneData'), {
              confirmButtonText: this.$t('common.btn.close')
            })
            return
          }
        }
      }
      this.loading = getLoading()
      await export9610FileUrl(sendJobKey).then((res) => {
        if (res.ok && res.data) {
          // 组装URL
          const url = `${URL.common.findByFileId}` + '/' + res.data + '?sessionId=' + encodeURIComponent(this.$store.getters.token)
          window.open(url)
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    async toExportCustomsList() {
      // 获取选中行
      let rows = null
      try {
        rows = this.readSelectedRows()
      } catch (e) {
        this.$alert(this.$t('common.tips.hasOneAtleast'), {
          confirmButtonText: this.$t('common.btn.close')
        })
        return
      }
      const newRows = jc.decycle(rows)
      if (!newRows || newRows.length <= 0) return
      if (newRows.length > 1000) {
        this.$alert(this.$t('SeaExport.checkLines'), {
          confirmButtonText: this.$t('common.btn.close')
        })
        return
      }
      const uuids = newRows.map(item => {
        return item.uuid
      })
      this.loading = getLoading()
      await exportCustomsInfoFunc(uuids).then((res) => {
        convertResToBlob(res)
      }).catch(() => {
        this.loading.close()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 导出Excel
    toExportToExcel() {
      // 获取显示列
      const allDisplayedColumns = this.gridOptions.columnApi.getAllDisplayedColumns()
      // 获取选中行
      const rows = this.readSelectedRows()
      const newRows = deepClone(rows)
      this.toExport(newRows, allDisplayedColumns)
    },
    // 导出Excel(含SOP明细)
    async toExportWithSOPToExcel() {
      // 获取显示列
      const allDisplayedColumns = this.gridOptions.columnApi.getAllDisplayedColumns()
      // 获取选中行
      const rows = this.readSelectedRows()
      // copy一个新的
      const newRows = deepClone(rows)
      if (!newRows || newRows.length <= 0) return
      const jobKeys = Array.from(newRows, p => p.uuid)
      let jobSopStates = {}
      await getJobSopStates(jobKeys).then(res => {
        jobSopStates = res.data
      })

      // 查询海运进口的所有SOP节点
      const sopTemplateMap = await SopUtil.getSopTemplateMap(newRows)
      const headerNameMap = new Map()
      const sopColumns = []
      // 循环每条业务数据
      for (let i = 0; i < newRows.length; i++) {
        const seaJob = newRows[i] // 当前行
        if (!sopTemplateMap.hasOwnProperty(seaJob.trackingTemplateUuid)) {
          continue
        }
        const trackMap = sopTemplateMap[seaJob.trackingTemplateUuid]
        const newSopState = (jobSopStates && Object.prototype.hasOwnProperty.call(jobSopStates, seaJob.uuid)) ? jobSopStates[seaJob.uuid] : ''
        const currentJobSopState = !newSopState ? seaJob.sopState : newSopState // 当前行的SOP数据

        if (!currentJobSopState) continue
        const tracks = currentJobSopState.split(',')
        // 循环每个节点Sop数据，动态添加显示列
        for (let j = 0; j < tracks.length; j++) {
          const currentTrack = tracks[j]
          if (!currentTrack) continue
          const columnName = currentTrack.split('(')[0]
          if (trackMap.hasOwnProperty(columnName)) {
            const track = trackMap[columnName]
            if (track && (Number(track.nodeType) === Number(TrackingConstants.NOTE_TYPE_E.code) || Number(track.nodeType) === Number(TrackingConstants.NOTE_TYPE_SUPPLEMENT.code))) {
              continue
            }
          }
          const oldColumnValue = currentTrack.split('(')[1].split(')')[0]
          const columnValue = !oldColumnValue ? this.$t('Message.NotStart') : oldColumnValue
          //
          if (!headerNameMap.has(columnName)) {
            headerNameMap.set(columnName, columnValue)
            sopColumns.push({ headerName: columnName, field: columnName, columnType: 'SOP' })
          }
          newRows[i][columnName] = columnName + ' ' + columnValue
        }
      }
      // 获取所有列
      const allColumns = [...allDisplayedColumns, ...sopColumns]
      this.toExport(newRows, allColumns)
    },
    // 海外代理EDI
    toOverseasAgentEDI() {
      // 获取选中行
      const rows = this.readSelectedRows()
      const jobKeys = Array.from(rows, p => p.uuid)
      // 组装URL
      const url = `${URL.booking.airExport.exportExcelForAeAgencyEdi}` + '?fileName=AEOverSeaAgencyList.xls&anyStr=' + encodeURIComponent(jobKeys.join(',')) + '&branchId=' + this.$store.getters.currentOfficeId + '&sessionId=' + encodeURIComponent(this.$store.getters.token)
      window.open(url)
    },
    toExport(rows, columns) {
      const fileName = 'AirExportBookingList'
      exportExcel(fileName, rows, columns)
    },
    // 导入装板信息
    unitLoadHandle(command) {
      switch (command) {
        case this.$t('AirExport.ImportBoardInstallInfo'):
          console.log('todo ImportBoardInstallInfo')
          // this.$refs.uploadBoardInstallInfo.submit()
          break
        case this.$t('SeaExport.TemplateDownload'):
          ExportUtils.downloadTemplateFile('ImportContainerTemplate.xlsx', 'booking')
          break
      }
    },
    onImportBoardClick(e) {
      if (!this.checkHierarchyMulitple()) {
        e.stopPropagation()
      }
    },
    beforeUnitLoad(file) {
      this.loading = getLoading()
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (fileType !== 'xlsx') {
        this.loading.close()
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsx'))
        return false
      }
      return true
    },
    // 上传成功
    uploadUnitLoadSuccess(res, file, fileList) {
      this.loading.close()
      const { ok, data, errors, message } = res
      if (ok) {
        this.unitLoadResult.isSuccess = data
        this.unitLoadResult.visible = true
      } else {
        let errorMsg = ''
        if (errors && errors.length > 0) {
          if (errors.length === 1) {
            errorMsg = errors[0].message
          } else {
            errorMsg = errors.reduce((a, b) => a.message + ',' + b.message)
          }
        } else {
          errorMsg = message
        }
        this.$message.error({ 'message': errorMsg, 'duration': 15000 })
      }
    },
    downloadImportContainerTemplate() {
      this.unitLoadResult.visible = false
      ExportUtils.downloadTemplateFile('ImportContainerTemplate.xlsx', 'booking')
    },
    // 修改SOP状态
    batchUpdateSopStateHandler() {
      const rows = this.readSelectedRows()
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(rows)
      }
      let lob = null
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (lob !== null && lob !== item.lob) {
          this.$message.warning(this.$t('Message.PleaseSelectTheSameTypeOfJob'))
          return
        }
        lob = item.lob
      }
      getTrackingListByLob(lob).then(res => {
        this.stateDialog.trackingList = res.data
      })
      this.stateDialog.rows = this.readSelectedRows()
      this.stateDialog.visible = true
    },
    // 批量操作
    batchHandle(val) {
      if (val !== 3) {
        if (this.hierarchyViewList) {
          if (val !== 5) {
            const rows = this.readSelectedRows()
            this.checkOwnerBranch(rows)
          }
        }
      }
      switch (val) {
        case 1:
          this.toBatchPreSubmit()
          break
        case 2:
          this.toBatchSubmit()
          break
        case 3:
          this.toBatchManagerSubmission()
          break
        case 4: // 批量撤回预提交
          this.toBatchReturnPreSubmit()
          break
        case 5: // 批量退回提交
          this.toBatchReturnSubmit()
          break
        case 6:
          // 批量锁定应收费用
          this.toBatchModifyChargeLockingStatus(true)
          break
        case 7:
          // 批量锁定应付费用
          this.toBatchModifyChargeLockingStatus(false)
          break
        case 8:
          // 批量修改目的港信息
          this.toBatchModifyPodInfo()
          break
        case 9:
          this.toBatchUpdateCustomType()
          break
        case 12:
          this.toBatchModifyChargeLockStatus(true)
          break
        case 13:
          this.toBatchModifyChargeLockStatus(false)
          break
        case 17:
          this.toBatchModifyBusiness()
          break
        case 18:
          this.toBatchUpdateSopTemplate()
          break
        case 19:
          this.toBatchCooperation()
          break
        case 20:
          this.toBatchSyncChargeConfirm()
          break
        case 21:
          JobUtils.toBatchFillGpExplain(this.readSelectedRows(), this.gpExplain)
          break
        case 22:
          JobUtils.batchLockJobHandler(this, this.readSelectedRows(), true, this.toQuery)
          break
        case 23:
          JobUtils.batchLockJobHandler(this, this.readSelectedRows(), false, this.toQuery)
          break
        case 24:
          this.toBatchModifyBranch()
          break
        case 25:
          this.toShutOut()
          break
        case 26:
          this.toBatchPurchasePriceLock(true)
          break
        case 27:
          this.toBatchPurchasePriceUnlock(true)
          break
        case 28:
          this.toBatchPurchasePriceUnlock(false)
          break
        case 29:
          this.toBatchPurchasePriceLock(false)
          break
        case 30:
          JobUtils.toSendPoItem(this, this.readSelectedRows())
          break
        case 31:
          JobUtils.toUnlockStatus(this, this.readSelectedRows())
          break
        case 32:
          JobUtils.batchReturnReview(this, this.readSelectedRows())
          break
        case 'BatchExportToImport':
          this.toBatchExportToImport()
          break
      }
      if (typeof val === 'string') {
        if (val.startsWith('instruction,')) {
          const tenantInstructionUuid = val.split(',')[1]
          const item = this.instructioinBtns.find(item => item.tenantInstructionUuid === tenantInstructionUuid)
          if (item) {
            if (item.platformInstructionRuleCode === SystemConstants.PLATFORM_INSTRUCTION_CODE_SAME_TENANT_CROSS_DELEGATION.code) {
              this.$refs.tenantEntrustWindow.onShowOfUI(item, this.readSelectedRows())
            }
          }
        }
      }
    },
    onInstructionCallback(data) {
      this.loadInstructionButtons()
      if (data.platformInstructionCode === SystemConstants.PLATFORM_INSTRUCTION_CODE_SAME_TENANT_CROSS_DELEGATION.code) {
        this.toQuery()
      }
    },
    toBatchExportToImport() {
      if (Number(cache.config.get('consignationImportByAE')) !== 1) {
        this.$message.warning(this.$t('queryJob.ExportFunctionIsNotEnabled'))
        return
      }
      if (!this.$store.getters.isGroupCompany) {
        this.$message.warning(this.$t('queryJob.NonSupportImportationThroughEntry'))
        return
      }
      const rows = this.readSelectedRows()
      this.$refs.batchExportToImportWindow.onShow(rows)
    },
    // 批量撤回提交
    async toBatchReturnSubmit() {
      const rows = this.readSelectedRows()
      const jobKeys = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (item.jobState !== Number(SystemConstants.COMMITED)) {
          this.$message.warning(this.$t('SeaExport.BatchReturnSubmitCheck'))
          return
        }
        jobKeys.push(item.uuid)
      }
      if (!await JobUtils.backCheckJobState(jobKeys, SystemConstants.OPERATE_PRINT_RETURN.code)) {
        this.toQuery()
        return
      }
      if (jobKeys.length > 0) {
        this.$confirm(this.$t('Message.IsConfirm') + this.$t('Message.Withdraw') + '?', this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.loading = getLoading4Cxt()
          batchReturnSubmit({ jobUuids: jobKeys, lob: 'AE', location: this.location }).then(res => {
            if (res.data) {
              this.toQuery()
            }
            this.$message.success(this.$t('SeaExport.SuccessWithdraw', [res.data ? res.data.length : 0]))
          }).finally(() => {
            this.loading.close()
          })
        })
      }
    },
    // 批量锁定应收/应付费用
    async toBatchModifyChargeLockingStatus(receivable) {
      const rows = this.readSelectedRows()
      const jobKeys = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (!await SecurityUtil.canEdit(new AirExportJob(item))) {
          this.$message.warning(this.$t('Message.NoPermissionToEditTheJob'))
          return
        }
        if (receivable) {
          if (item.receivableChargeLockedStatus !== 0) {
            this.$message.warning(this.$t('Message.BatchUnlockLockingBillsOfAccountsReceivable'))
            return
          }
        } else {
          if (item.payableChargeLockedStatus !== 0) {
            this.$message.warning(this.$t('Message.BatchUnlockLockingBillsOfAccountsPayable'))
            return
          }
        }
        jobKeys.push(item.uuid)
      }
      if (jobKeys.length > 0) {
        const t = receivable ? this.$t('Message.Receivable') : this.$t('Message.Payable')
        this.$confirm(this.$t('Message.LockingChargeStatus', [t]), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.loading = getLoading()
          batchModifyChargeLockStatus({ uuids: jobKeys, receivable: receivable, lockStatus: 1 }).then(res => {
            this.loading.close()
            if (res.data) {
              this.$message.success(this.$t('Message.SuccessfullylockingedFeesInBatch', [t, res.data]))
              this.toQuery()
            }
          }).finally(() => {
            this.loading.close()
          })
        })
      }
    },
    // 批量撤回预提交
    async toBatchReturnPreSubmit() {
      const rows = this.readSelectedRows()
      const jobKeys = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (item.jobState !== Number(SystemConstants.PRE_COMMIT)) {
          this.$message.warning(this.$t('Message.BatchReturnPreSubmitCheck'))
          return
        }
        jobKeys.push(item.uuid)
      }
      if (!await JobUtils.backCheckJobState(jobKeys, SystemConstants.OPERATE_RETURN_ACTION.code)) {
        this.toQuery()
        return
      }
      if (jobKeys.length > 0) {
        this.$confirm(this.$t('Message.IsConfirm') + this.$t('Message.Return') + '?', this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.loading = getLoading4Cxt()
          batchReturnSubmit({ jobUuids: jobKeys, lob: 'AE', location: this.location }).then(res => {
            if (res.data) this.toQuery()
            this.$message.success(this.$t('Message.AlreadyReturn'))
          }).finally(() => {
            this.loading.close()
          })
        })
      }
    },
    // 退关
    toShutOut() {
      const rows = this.readSelectedRows()
      const jobKeys = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (item.jobState !== Number(SystemConstants.OPERATING)) {
          this.$message.info(this.$t('Message.IsNotOperationStatusCannotBeShutOut'))
          return
        }
        // 财务审核
        if (item.jobState === 2) {
          this.$message.warning(this.$t('Message.HaveBusinessHasBeenSubmittedCannotBeShutOut'))
          return
        }
        // 退关
        if (item.shutOut) {
          this.$message.warning(this.$t('Message.HaveBusinessHasBeenShutOuted'))
          return
        }
        jobKeys.push(item.uuid)
      }
      this.shutOutDialog.jobKeys = jobKeys
      canBatchShutout({ jobKeys }).then(res => this.canBatchShutoutResult(res))
    },
    // 验证退关
    canBatchShutoutResult(res) {
      const result = Number(res.data)
      this.shutOutDialog.shutOutButtonShow2 = ''
      if (result === 0) {
        this.shutOutDialog.shutOutTip1 = this.$t('SeaExport.CustomsClearanceChargeRelatedEdit')
        this.shutOutDialog.shutOutTip2 = this.$t('SeaExport.CustomsClearanceNoChargeNoChange')
      } else if (result === 1) {
        this.shutOutDialog.shutOutTip1 = this.$t('SeaExport.CustomsClearanceChargeRelatedEdit')
        this.shutOutDialog.shutOutTip2 = this.$t('SeaExport.ClearFeeNoChargeCustomsClearance')

        this.shutOutDialog.shutOutButtonShow2 = 'none'
      } else if (result === 2) {
        this.$message.info(this.$t('Message.PleaseRemoveThisTicketFromMblThenShutOutBatch'))
      } else if (result === 3) {
        this.$message.info(this.$t('Message.PleaseRemoveAllTicketsFromMblThenShutOutBatch'))
      }
      if (result === 0 || result === 1) {
        this.shutOutDialog.visible = true
      }
    },
    // 有费用退关
    hasChargeShutoutHandler() {
      this.shutoutHandler(true)
    },
    // 无费用退关
    noHasChargeShutoutHandler() {
      this.shutoutHandler(false)
    },
    // 退关公共
    async shutoutHandler(hasCharge) {
      const rows = this.readSelectedRows()
      const jobKeys = Array.from(rows, p => p.uuid)
      this.shutOutDialog.hasCharge = hasCharge
      batchShutout({ jobKeys, hasCharge, location: this.location }).then(res => this.batchShutoutResult(res))
    },
    // 退关处理结果
    batchShutoutResult(res) {
      const list = res.data
      const len = list == null ? 0 : list.length
      this.$message.success(this.$t('Message.ShutOutSuccessfully') + ': ' + len)
      this.shutOutDialog.visible = false

      if (len === 0) return
      const objJobKey = {}
      const jobKeys = this.shutOutDialog.jobKeys
      for (const jobKey of jobKeys) {
        objJobKey[jobKey] = jobKey
      }

      for (const seaJob of this.rowData) {
        if (objJobKey.hasOwnProperty(seaJob.uuid) && objJobKey[seaJob.uuid] === seaJob.uuid) {
          const hasCharge = this.shutOutDialog.hasCharge
          seaJob.shutOut = true
          if (!hasCharge) {
            seaJob.jobState = SystemConstants.SHUT_OUT
          }
        }
      }
      this.refreshAgGrid()
      this.shutOutDialog.hasCharge = false
      this.shutOutDialog.jobKeys = []
    },
    // 批量预提交
    toBatchPreSubmit() {
      const rows = this.readSelectedRows()
      const jobKeys = []
      for (const j of rows) {
        if (this.isCooperate(j.cooperateStatus)) {
          this.$message.warning('[' + j.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (Number(j.jobState) !== Number(SystemConstants.OPERATING)) {
          this.$message.warning(this.$t('Message.BulkSubmissionOfWrittenPreSubmissionsOnlyList'))
          return
        }
        if (!j.masterFlag && !j.lclMasterUuid && (j.containerLoadType === 'LCL' || j.containerLoadType === 'BC') && this.ticketsMustBeVoted) {
          this.$message.warning(this.$t('Message.TicketsMustBeVoted'))
          return
        }
        jobKeys.push(j.uuid)
      }
      // 检查应付费用是否全部审核
      checkChargeStateVerify(jobKeys).then(res => this.checkChargeStateVerifyResult(res))
    },
    // 检查应付费用是否全部审核
    async checkChargeStateVerifyResult(res) {
      const result = res.data
      if (this.checkApChargeVerify && result === 0) {
        this.$message.warning(this.$t('Message.NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance'))
        return
      }
      const officeId = this.$store.getters.currentOfficeId
      const rows = this.readSelectedRows()
      const jobKeys = Array.from(rows, p => p.uuid)
      if (jobKeys.length > 0) {
        const checkNode = CheckRuleConstants.NODE_PRE_COMMIT.code
        const opOffice = (rows && rows.length > 0) ? rows[0].opOffice : 0
        // const hasCheckRule = await JobUtils.hasCheckRuleCondition(this.useCheckRule, checkNode, opOffice)
        const hasCheckRule = true
        if (this.useCheckRule && hasCheckRule) {
          this.batchCheckingWindow.jobs = rows // 回调中使用
          if (this.allowPartialCheckPass) {
            const callBack = this.batchPreCommitCall || null
            this.checkingManagerJobs(rows, checkNode, callBack, null, true)
          } else {
            const callBack = this.batchPreCommitCall || null
            this.checkingManagerJobs(rows, checkNode, callBack, null, false)
          }
        } else {
          this.$confirm(this.$t('Message.MakeSureToSubmitAListOftheNFinancialAuditPlease1') + jobKeys.length + this.$t('SeaExport.VotesPreSubmission'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning'
          }).then(() => {
            batchPreCommit({ jobKeys: jobKeys, officeId: officeId, location: this.location }).then(res => this.handlerPreCommitResult(res))
          }).catch(() => {
          })
        }
      }
    },
    // 批量预提交回调
    batchPreCommitCall() {
      let jobKeys = []
      if (!this.allowPartialCheckPass) {
        const jobs = this.batchCheckingWindow.jobs
        jobKeys = jobs && jobs.length > 0 ? Array.from(jobs, p => p.uuid) : []
      } else {
        jobKeys = this.$refs.batchCheckingWindow.checkPassKeys
        this.$logger.log('预提交——jobKeys：', jobKeys)
      }
      if (jobKeys && jobKeys.length > 0) {
        const officeId = this.$store.getters.currentOfficeId
        batchPreCommit({ jobKeys: jobKeys, officeId: officeId, location: this.location }).then(res => this.handlerPreCommitResult(res))
      }
    },
    // 批量预提交处理结果
    handlerPreCommitResult(res) {
      const list = res.data
      const len = (list === null || list === '') ? 0 : list.length
      this.$message.success(this.$t('Message.BatchSubmittedPreSuccessfully') + ': ' + len)
      this.toQuery()
    },
    // 批量提交
    async toBatchSubmit() {
      const rows = this.readSelectedRows()
      let jobKeys = []
      let selectedJobs = []
      const allowBatchSubmitJobState = cache.config.get('AllowBatchSubmitJobState')
      const allowBatchSubmitJobStateArr = allowBatchSubmitJobState ? allowBatchSubmitJobState.split(',') : []
      const operateStr = SystemConstants.OPERATING.toString()
      const preCommitStr = SystemConstants.PRE_COMMIT.toString()
      const len = allowBatchSubmitJobStateArr.length
      const paramsBpm = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (len > 1 && allowBatchSubmitJobStateArr.includes(operateStr) && allowBatchSubmitJobStateArr.includes(preCommitStr) && !(Number(item.jobState) === SystemConstants.OPERATING || Number(item.jobState) === SystemConstants.PRE_COMMIT)) {
          this.$message.warning(this.$t('Message.BatchSubmitCheck'))
          return
        }
        if (len === 1 && allowBatchSubmitJobStateArr.includes(operateStr) && !(Number(item.jobState) === SystemConstants.OPERATING)) {
          this.$message.warning(this.$t('SeaExport.BatchSubmitCheckOperate'))
          return
        }
        if (len === 1 && allowBatchSubmitJobStateArr.includes(preCommitStr) && !(Number(item.jobState) === SystemConstants.PRE_COMMIT)) {
          this.$message.warning(this.$t('SeaExport.BatchSubmitCheckPre'))
          return
        }
        jobKeys.push(item.uuid)
        selectedJobs.push(item)
        // 构建bpm请求参数
        const paramBpm = {
          documentConfigId: Job_CHARGE.code,
          docId: item.uuid,
          docNo: item.jobNo,
          actionType: 7000,
          officeId: item.opOffice,
          applicationDimension: APPLICATION_DIMENSION_JOB_CHARGE.code
        }
        paramsBpm.push(paramBpm)
      }

      if (jobKeys.length > 0) {
        // 预付款余额校验
        const checkFailUuids = []
        const continueExec = await JobUtils.checkBalanceBeforeSubmitHandler(jobKeys, checkFailUuids, true)
        if (!continueExec) {
          return
        }
        // 余额不足
        if (checkFailUuids && checkFailUuids.length > 0) {
          const checkKeys = []
          for (const key of jobKeys) {
            if (checkFailUuids.indexOf(key) === -1) {
              checkKeys.push(key)
            }
          }
          if (checkKeys.length > 0) {
            jobKeys = checkKeys
            selectedJobs = []
            for (const item of rows) {
              if (jobKeys.indexOf(item.uuid) !== -1) {
                selectedJobs.push(item)
              }
            }
          } else {
            return
          }
        }
        // 判断是否开启验证规则
        const checkNode = CheckRuleConstants.NODE_COMMIT.code
        if (this.useCheckRule) {
          const hasCheckRule = await JobUtils.hasConfigCheckRuleByJobs(checkNode, jobKeys, selectedJobs[0].lob)
          if (hasCheckRule) {
            this.batchCheckingWindow.jobs = selectedJobs // 回调中使用
            this.paramsBpm = paramsBpm
            this.opOffice = selectedJobs[0].opOffice
            if (this.allowPartialCheckPass) {
              const callBack = this.batchCommitCall || null
              this.checkingManagerJobs(selectedJobs, checkNode, callBack, null, true)
            } else {
              const callBack = this.batchCommitCall || null
              this.checkingManagerJobs(selectedJobs, checkNode, callBack, null, false)
            }
          } else {
            if (await WorkflowUtil.isBpmEnabled({ documentConfigId: Job_CHARGE.code, officeId: selectedJobs[0].opOffice })) {
              WorkflowUtil.jobBatchCommitBpm(this, paramsBpm)
              return
            }
            batchCommit({ jobKeys, officeId: this.$store.getters.currentOfficeId, location: this.location }).then(res => this.handlerCommitResult(res))
          }
        } else {
          this.$confirm(this.$t('Message.MakeSureToSubmitAListOftheNFinancialAuditPlease1') + jobKeys.length + this.$t('SeaExport.VotesSubmission'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning'
          }).then(async() => {
            if (await WorkflowUtil.isBpmEnabled({
              documentConfigId: Job_CHARGE.code,
              officeId: selectedJobs[0].opOffice
            })) {
              WorkflowUtil.jobBatchCommitBpm(this, paramsBpm)
              return
            }
            const officeId = this.$store.getters.currentOfficeId
            batchCommit({ jobKeys: jobKeys, officeId: officeId, location: this.location }).then(res => this.handlerCommitResult(res))
          }).catch(() => {
          })
        }
      }
    },
    // 批量提交回调
    batchCommitCall() {
      let jobKeys = []
      if (!this.allowPartialCheckPass) {
        const jobs = this.batchCheckingWindow.jobs
        jobKeys = jobs && jobs.length > 0 ? Array.from(jobs, p => p.uuid) : []
      } else {
        this.$logger.log('提交——jobKeys：', jobKeys)
        jobKeys = this.$refs.batchCheckingWindow.checkPassKeys
      }
      if (jobKeys && jobKeys.length > 0) {
        const officeId = this.$store.getters.currentOfficeId
        batchCommit({ jobKeys: jobKeys, officeId: officeId, location: this.location }).then(res => this.handlerCommitResult(res))
      }
    },
    // 批量提交处理结果
    handlerCommitResult(res) {
      const list = res.data
      const len = (list === null || list === '') ? 0 : list.length
      this.$message.success(this.$t('Message.BatchSubmittedSuccessfully') + ': ' + len)
      this.toQuery()
    },
    // 根据船名查询航次
    onVesselSelectionChange(obj) {
      this.transshipDialog[obj.key] = obj.value
      this.transshipDialog.txtVoyage = ''
      if (obj.value) {
        getVoyagesByVesselId(obj.vesselId).then(res => {
          this.transshipDialog.voyages = res.data
        })
      } else {
        this.transshipDialog.voyages = []
      }
    },
    // 批量转船
    toBatchTransship() {
      const rows = this.readSelectedRows()
      if (rows.length <= 0) {
        this.$message.info(this.$t('Message.SelectTheData'))
        return
      }
      this.toInitTransshipDialog()
      for (const item of rows) {
        if (Number(item.jobState) === Number(SystemConstants.OPERATING)) {
          this.transshipDialog.jobKeys.push(item.uuid)
          this.transshipDialog.selectedJobs.push(item)
        }
      }

      const jobs = this.transshipDialog.selectedJobs
      if (jobs.length > 0) {
        let flag = true
        // 判断在订舱性质是否在同一条船,是否是同一个航次
        const bookingTerm = jobs[0].bookingTerm
        const voyageFlight = jobs[0].voyageFlight
        const vessel = jobs[0].vessel
        for (const seaJob of jobs) {
          if (seaJob.voyageFlight !== voyageFlight || seaJob.vessel !== vessel) {
            this.$message.info(this.$t('Message.TheSelectedDocumentIsNotTheSameVoyage'))
            flag = false
            return
          }
          if (this.editVessel === 2 && seaJob.bookingTerm !== bookingTerm) {
            this.$message.info(this.$t('Message.TheSelectedDocumentInconsistentNatureOfTheBooking'))
            flag = false
            return
          }
        }
        if (flag) {
          this.transshipDialog.visible = true
          // 如果分公司是上海且订舱性质是自订舱,只能选择，其他都是手输入的。
          if (this.editVessel === 3 || (this.editVessel === 2 && bookingTerm === BookingTerm.OS_BOOKING_TYPE.code)) {
            this.transshipDialog.isDBFlag = false
          } else {
            this.transshipDialog.isDBFlag = true
          }
        }
      } else {
        this.$message.info('选择的数据记录全部为非【正操作】状态')
      }
    },
    // 批量转船点击确定
    transShipClickHandler() {
      const jobs = this.transshipDialog.selectedJobs
      if (jobs != null && jobs.length > 0) {
        const isDBFlag = this.transshipDialog.isDBFlag
        const obj = {}
        obj.jobKeys = this.transshipDialog.jobKeys
        if (!isDBFlag) {
          if (this.transshipDialog.txtVessel !== '') {
            obj.vessel = this.transshipDialog.txtVessel
          }
          if (this.transshipDialog.txtVoyage !== '') {
            obj.voyage = this.transshipDialog.txtVoyage
          }
        } else {
          if (this.transshipDialog.txtVessel_1 !== '') {
            obj.vessel = this.transshipDialog.txtVessel_1
          }
          if (this.transshipDialog.txtVoyage_1 !== '') {
            obj.voyage = this.transshipDialog.txtVoyage_1
          }
        }
        const carrierId = this.transshipDialog.txtCarrierId
        if (carrierId !== '' && carrierId > 0) {
          obj.carrierId = carrierId
        }
        if (this.transshipDialog.dfETD !== '') {
          obj.etd = this.transshipDialog.dfETD
        }
        const bookingAgent = this.transshipDialog.txtBookingAgent
        if (bookingAgent !== '' && bookingAgent > 0) {
          obj.bookingAgent = bookingAgent
        }
        this.transshipDialog.transship = obj
        batchTransship(obj).then(res => this.batchTransshipResult(res))
      }
    },
    // 初始化 批量转船对话框数据
    toInitTransshipDialog() {
      this.transshipDialog.selectedJobs = []
      this.transshipDialog.isDBFlag = true
      this.transshipDialog.txtVessel = ''
      this.transshipDialog.txtVoyage = ''
      this.transshipDialog.txtVessel_1 = ''
      this.transshipDialog.txtVoyage_1 = ''
      this.transshipDialog.txtCarrierId = ''
      this.transshipDialog.dfETD = ''
      this.transshipDialog.txtBookingAgent = ''
      this.transshipDialog.jobKeys = []
      this.transshipDialog.transship = {}
    },
    // 批量转船 处理返回结果
    batchTransshipResult(res) {
      // const list = res.data
      this.$confirm(this.$t('Message.BulkTransshipmentSuccessWhetherYouWantToCloseThePopUpWindow'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'success'
      }).then(() => {
        this.batchTransshipFresh()
        this.transshipDialog.visible = false
      }).catch(() => {
        this.batchTransshipFresh()
      })
    },
    // 批量转船 刷新
    batchTransshipFresh() {
      const objJobKey = {}
      const jobKeys = this.transshipDialog.jobKeys
      for (const jobKey of jobKeys) {
        objJobKey[jobKey] = jobKey
      }

      const transship = this.transshipDialog.transship
      for (const seaJob of this.rowData) {
        if (objJobKey.hasOwnProperty(seaJob.uuid) && objJobKey[seaJob.uuid] === seaJob.uuid) {
          if (transship.hasOwnProperty('vessel')) {
            seaJob.vessel = transship.vessel
          }
          if (transship.hasOwnProperty('voyage')) {
            seaJob.voyageFlight = transship.voyage
          }
          if (transship.hasOwnProperty('carrierId')) {
            seaJob.carrierId = transship.carrierId
          }
          if (transship.hasOwnProperty('etd')) {
            seaJob.etd = transship.etd
          }
          if (transship.hasOwnProperty('bookingAgent')) {
            seaJob.bookingAgent = transship.bookingAgent
          }
        }
      }
      this.gridApi.refreshCells({ force: true })
    },
    // 批量修改整拼类型
    toFullSpellType() {
      const rows = this.readSelectedRows()
      const jobKeys = []
      const jobList = []
      for (const j of rows) {
        if (j.containerLoadType !== ContainerLoadType.LCL_CARGO_TYPE.code && j.containerLoadType !== ContainerLoadType.BC_CARGO_TYPE.code && j.containerLoadType !== ContainerLoadType.BB_CARGO_TYPE.code) {
          this.$message.info(this.$t(j.jobNo + '该票业务整拼类型不是自拼箱、buyer consol、委托拼箱'))
          return
        }
        if (j.jobState !== SystemConstants.STATE_OPERATING.code) {
          this.$message.info(this.$t(j.jobNo + this.$t('SeaExport.RecordNotPositiveOperationStatus')))
          return
        }
        if (j.masterFlag) {
          this.$message.info(this.$t(j.jobNo + this.$t('SeaExport.TheTicketIsMain')))
          return
        }
        if (j.lclMasterUuid !== null && j.lclMasterUuid !== '') {
          this.$message.info(this.$t(j.jobNo + this.$t('SeaExport.TheTicketAssociatedMain')))
          return
        }
        jobKeys.push(j.uuid)
        jobList.push(j)
      }
      this.fullSpellTypeDialog.jobKeys = jobKeys
      this.fullSpellTypeDialog.jobList = jobList
      checkJobHasContainer(jobKeys).then(res => this.checkJobHasContainerResult(res))
    },
    // 验证是否装箱
    checkJobHasContainerResult(res) {
      const jobKey = res.data
      if (jobKey !== '' && jobKey !== null) {
        for (const job of this.fullSpellTypeDialog.jobList) {
          if (job.uuid === jobKey) {
            this.$message.info(this.$t(job.jobNo + this.$t('SeaExport.TheTicketAssociatedContainerInfo')))
            return
          }
        }
        return
      }
      this.fullSpellTypeDialog.visible = true
    },
    // 批量修改整拼类型点击确定
    fullSpellTypeClickHandler() {
      const containerLoadType = this.fullSpellTypeDialog.containerLoadType
      const jobs = this.fullSpellTypeDialog.jobList
      if (jobs != null && jobs.length > 0) {
        for (const job of jobs) {
          if (job.containerLoadType === containerLoadType) {
            this.$message.info(this.$t(job.jobNo + this.$t('SeaExport.ContainerLoadTypeIs') + SeaExportConstants.getTypeName(containerLoadType) + this.$t('SeaExport.NoneModified')))
            return
          }
        }

        const obj = {}
        obj.jobKeys = this.fullSpellTypeDialog.jobKeys
        obj.type = containerLoadType
        updateJobContainerLoadType(obj).then(res => this.updateJobContainerLoadTypeResult(res))
      }
    },
    // 批量修改整拼类型 处理结果
    updateJobContainerLoadTypeResult(res) {
      const r = res.data
      if (r.result === 1) {
        this.updateJobContainerLoadTypeFresh()
        this.$message.success(this.$t(this.$t('SeaExport.ContainerLoadTypeBatchModifySuccess') + r.num))
      } else {
        this.$message.info(this.$t(this.$t('SeaExport.NoDataProcessed')))
      }
      this.fullSpellTypeDialog.visible = false
      this.fullSpellTypeDialog.containerLoadType = ''
      this.fullSpellTypeDialog.jobKeys = []
      this.fullSpellTypeDialog.jobList = []
    },
    // 批量修改整拼类型 刷新数据
    updateJobContainerLoadTypeFresh() {
      const objJobKey = {}
      const jobKeys = this.fullSpellTypeDialog.jobKeys
      for (const jobKey of jobKeys) {
        objJobKey[jobKey] = jobKey
      }

      for (const seaJob of this.rowData) {
        if (objJobKey.hasOwnProperty(seaJob.uuid) && objJobKey[seaJob.uuid] === seaJob.uuid) {
          seaJob.containerLoadType = this.fullSpellTypeDialog.containerLoadType
        }
      }
      this.gridApi.refreshCells({ force: true })
    },
    // 统计
    async toStatistics() {
      this.statisticsClean()
      const loading = getLoading4Cxt(this)
      try {
        await this.handleStatistics(false)
        this.statisticsDialog.visible = true
      } finally {
        loading.close()
      }
    },
    async handleStatistics(isChangeContainShutOutJob = false) {
      let rows = this.gridApi.getSelectedRows().filter(p => p.hasOwnProperty('dataType') && (Number(p.dataType) === 1 || Number(p.dataType) === 2))
      if (rows.length === 0) {
        rows = this.rowData.filter(p => p.hasOwnProperty('dataType') && (Number(p.dataType) === 1 || Number(p.dataType) === 2))
      }
      if (rows.length === 0) {
        throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
      }
      const jobKeys = []
      const designationAgents = []
      const customers = []
      let quantity = 0
      let weight = 0
      let cWeight = 0
      let chargeWeight = 0
      let cubage = 0
      let slavesCount = 0
      let masterCount = 0
      let count = 0
      let quantityContract = 0
      let weightContract = 0
      let cubageContract = 0
      let lob = ''
      // 列表勾选的数据是否都为”已退关“
      let allJobShutOut = true
      for (const job of rows) {
        if (!job.shutOut) {
          allJobShutOut = false
          break
        }
      }
      for (const job of rows) {
        if (job.shutOut) {
          // 弹窗手动修改”是否包含退关“
          if (isChangeContainShutOutJob && !this.statisticsDialog.containShutOutJob) {
            continue
          } else if (!isChangeContainShutOutJob && !allJobShutOut) { // 第一次打开弹窗
            continue
          }
        }
        count++
        if (lob === '') lob = job.lob
        jobKeys.push(job.uuid)
        if (job.masterFlag) {
          masterCount += 1
        } else {
          quantity += job.quantityActual
          weight += isNaN(job.weightActual) ? 0 : job.weightActual
          cubage += isNaN(job.cubageActual) ? 0 : job.cubageActual
          quantityContract += job.quantityContract
          weightContract += isNaN(job.weightContract) ? 0 : job.weightContract
          cubageContract += isNaN(job.cubageContract) ? 0 : job.cubageContract
          cWeight += isNaN(job.cWeight) ? 0 : job.cWeight
          chargeWeight += isNaN(job.chargeWeight) ? 0 : job.chargeWeight
          slavesCount += 1
        }
        if (!customers.includes(job.customerId) && !job.masterFlag) {
          customers.push(job.customerId)
        }
        if (!designationAgents.includes(job.designationAgent) && job.designationAgent !== 0) {
          designationAgents.push(job.designationAgent)
        }
      }
      this.statisticsDialog.txtSlaves = slavesCount.toString()
      this.statisticsDialog.txtMaster = masterCount.toString()
      this.statisticsDialog.txtCount = count.toString()
      this.statisticsDialog.txtQuantityActual = NumberUtils.formatNumber(quantity)
      this.statisticsDialog.txtWeightActual = NumberUtils.formatNumber(weight, 2)
      this.statisticsDialog.txtCubageActual = NumberUtils.formatNumber(cubage, 3)
      this.statisticsDialog.txtQuantityContract = NumberUtils.formatNumber(quantityContract)
      this.statisticsDialog.txtWeightContract = NumberUtils.formatNumber(weightContract, 2)
      this.statisticsDialog.txtCubageContract = NumberUtils.formatNumber(cubageContract, 3)
      this.statisticsDialog.txtChargeWeightActual = NumberUtils.formatNumber(cWeight, 2)
      this.statisticsDialog.txtChargeWeightContract = NumberUtils.formatNumber(chargeWeight, 2)
      this.statisticsDialog.txtCustomerCount = customers.length.toString()
      this.statisticsDialog.txtdesignationAgentNum = designationAgents.length.toString()
      if (!isChangeContainShutOutJob && allJobShutOut) {
        this.statisticsDialog.containShutOutJob = true
      }
      await statisticsJobs({ jobKeys: jobKeys, lob: 'AE', containShutOutJob: this.statisticsDialog.containShutOutJob }).then(res => {
        this.statisticsJobsResult(res)
      })
    },
    // 统计结果
    statisticsJobsResult(res) {
      this.statisticsDialog.txt20 = res.data.b20
      this.statisticsDialog.txt40 = res.data.b40
      this.statisticsDialog.txt40hq = res.data.b40h
      this.statisticsDialog.txt45 = res.data.b45
      this.statisticsDialog.txtTeu = res.data.teu
    },
    // 统计完成 清空对象
    statisticsClean() {
      this.statisticsDialog.txtSlaves = ''
      this.statisticsDialog.txtMaster = ''
      this.statisticsDialog.txtCount = ''
      this.statisticsDialog.txtCustomerCount = ''
      this.statisticsDialog.txt20 = ''
      this.statisticsDialog.txt40 = ''
      this.statisticsDialog.txt40hq = ''
      this.statisticsDialog.txt45 = ''
      this.statisticsDialog.txtTeu = ''
      this.statisticsDialog.txtWeight = ''
      this.statisticsDialog.txtChargeWeight = ''
      this.statisticsDialog.txtCubage = ''
      this.statisticsDialog.txtdesignationAgentNum = ''
      this.statisticsDialog.containShutOutJob = false
    },
    // 批量预提交
    async batchPreCommitHandler() {
      const selectedJobs = this.readSelectedRows()
      const keys = []
      const checkApChargeVerify = parseInt(cache.config.get('PreCommitJobCheckApChargeStateVerify'))
      // AirExportJob
      for (const job of selectedJobs) {
        if (checkApChargeVerify === 1) {
          const isPass = await JobUtils.checkChargeStateVerify(this.job)
          if (!isPass) {
            this.$message.warning(this.$t('Message.NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance'))
            return
          }
        }
        if (job.jobState !== SystemConstants.OPERATING) {
          this.$message.info(this.$t('Message.BulkSubmissionOfWrittenPreSubmissionsOnlyList'))
          return
        }
        keys.push(job.uuid)
      }

      if (keys.length > 0) {
        const self = this
        const officeId = this.$store.getters.currentOfficeId
        // 判断是否开启验证规则
        const checkNode = CheckRuleConstants.NODE_PRE_COMMIT.code
        const useCheckRule = Number(cache.config.get('useCheckRule')) === 1
        const opOffice = (selectedJobs && selectedJobs.length > 0) ? selectedJobs[0].opOffice : 0
        // const hasCheckRule = await JobUtils.hasCheckRuleCondition(useCheckRule, checkNode, opOffice)
        const hasCheckRule = true
        if (useCheckRule && hasCheckRule) {
          this.multiChecking(checkNode, selectedJobs, function() {
            batchPreCommit({ jobKeys: keys, officeId: officeId, location: this.location }).then(res => self.handlerPreCommitResult(res)).catch(e => self.faultHandler)
          })
        } else {
          await this.$confirm(this.$t('Message.MakeSureToSubmitAListOftheNFinancialAuditPlease1') + ' ' + keys.length + this.$t('queryJob.IsTheTicketPreSubmitted'))
          batchPreCommit({ jobKeys: keys, officeId: officeId, location: this.location }).then(res => self.handlerPreCommitResult(res)).catch(e => self.faultHandler)
        }
      }
    },
    /**
     * 批量验证
     */
    multiChecking(checkNode, jobs, callBack) {
      this.batchCheckingWindow.checkNode = checkNode
      this.batchCheckingWindow.jobs = jobs
      this.batchCheckingWindow.callBack = callBack
      this.batchCheckingWindow.visible = true
    },

    // 批量处理费用
    chargeHandle() {
      if (this.hierarchyViewList) {
        const rows = this.readSelectedRows()
        this.checkOwnerBranch(rows)
      }
      switch (this.chargeCommand) {
        case this.$t('SeaExport.AddCharges'):
          this.toAddCharge()
          break
        case this.$t('SeaExport.EditCharges'):
          this.toEditCharge()
          break
        case this.$t('SeaExport.DeleteCharges'):
          this.toDeleteCharge()
          break
        case this.$t('SeaExport.ChargeImport'):
          this.toImportCharge()
          break
      }
    },
    // 新增费用
    async toAddCharge() {
      const selectedJobs = []
      const jobs = this.readSelectedRows()
      for (const obj of jobs) {
        if (obj.jobState === SystemConstants.OPERATING) {
          selectedJobs.push(obj)
        }
      }
      if (selectedJobs.length === 0) {
        this.$message.warning(this.$t('Message.NoSelectedDataOrAreNotOperationalStatus'))
        return
      }
      // 业务锁定状态 费用不可操作
      for (const obj of selectedJobs) {
        if (!(obj && Number(obj.jobState) === 0 && !JobUtils.isBlockJob(obj)) || !this.validSelectJob(obj) || !this.hierarchyValidSingleSelectJob(obj)) {
          this.$message.warning(this.$t('Message.TheSelectedServicesIncludeLockedServices'))
          return
        }
      }

      // if (!await this.validateChargeLocked(jobs)) return
      // this.addChargeDetailDialog.selectedJobs = selectedJobs
      // this.addChargeDetailDialog.visible = true
      this.chargeTypeDialog.type = this.role.addPayableChargeRole ? 2 : 1
      this.chargeTypeDialog.selectedJobs = selectedJobs
      this.chargeTypeDialog.visible = true
    },
    onChargeTypeDialogConfirm() {
      this.chargeTypeDialog.visible = false
      // 应收是否锁定
      const type = this.chargeTypeDialog.type
      const rows = this.chargeTypeDialog.selectedJobs
      if (!rows || rows.length === 0) return
      if (type === 0) {
        const chargeLocked = rows.find(p => p.receivableChargeLockedStatus > 0 && p.payableChargeLockedStatus > 0)
        if (chargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ARAP_Locked'))
          return
        }
        const receivableChargeLocked = rows.find(p => p.receivableChargeLockedStatus > 0)
        if (receivableChargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AR_Locked'))
          return
        }
        const payableChargeLocked = rows.find(p => p.payableChargeLockedStatus > 0)
        if (payableChargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AP_Locked'))
          return
        }
      } else if (type === 1) {
        const receivableChargeLocked = rows.find(p => p.receivableChargeLockedStatus > 0)
        if (receivableChargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AR_Locked'))
          return
        }
      } else if (type === 2) {
        const payableChargeLocked = rows.find(p => p.payableChargeLockedStatus > 0)
        if (payableChargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AP_Locked'))
          return
        }
      }

      if (this.role.addReceivableChargeRole && !this.role.addPayableChargeRole) {
        if (type === 0 || type === 2) {
          this.$message.warning(this.$t('CargoMsg.Cargo_Only_AR'))
          return
        }
      } else if (!this.role.addReceivableChargeRole && this.role.addPayableChargeRole) {
        if (type === 0 || type === 1) {
          this.$message.warning(this.$t('CargoMsg.Cargo_Only_AP'))
          return
        }
      } else if (!this.role.addReceivableChargeRole && !this.role.addPayableChargeRole) {
        this.$message.warning(this.$t('CargoMsg.Cargo_Cannot_Add_Charge'))
        return
      }

      if (!JobUtils.checkJobCustomerIdIfSame(this.arSettlementUnitOptional, type, rows, this)) {
        return
      }
      this.addChargeDetailDialog.selectedJobs = rows
      this.addChargeDetailDialog.type = type
      this.addChargeDetailDialog.selectedScheme = []
      this.addChargeDetailDialog.visible = true
    },
    // 编辑费用
    async toEditCharge() {
      const selectedJobs = []
      const jobs = this.readSelectedRows()
      for (const obj of jobs) {
        if (obj.jobState === SystemConstants.OPERATING) {
          selectedJobs.push(obj)
        }
      }
      if (selectedJobs.length === 0) {
        this.$message.warning(this.$t('Message.NoBusinessOrIsNotOperationalState'))
        return
      }
      // 业务锁定状态 费用不可操作
      for (const obj of selectedJobs) {
        if (!(obj && Number(obj.jobState) === 0 && !JobUtils.isBlockJob(obj)) || !this.validSelectJob(obj) || !this.hierarchyValidSingleSelectJob(obj)) {
          this.$message.warning(this.$t('Message.TheSelectedServicesIncludeLockedServices'))
          return
        }
      }
      if (!await this.validateChargeLocked(jobs)) return
      this.editChargeDetailDialog.chargeType = this.role.addPayableChargeRole ? 2 : 1
      this.editChargeDetailDialog.selectedJobs = selectedJobs
      this.editChargeDetailDialog.visible = true
    },
    // 删除费用 todo 待优化，两个接口可以合并成一个接口
    async toDeleteCharge() {
      const selectedJobs = []
      const jobKeys = []
      const jobs = this.gridApi.getSelectedRows()
      for (const obj of jobs) {
        if (obj.jobState === SystemConstants.OPERATING) {
          jobKeys.push(obj.uuid)
          selectedJobs.push(obj)
        }
      }
      if (jobKeys.length === 0) {
        this.$message.warning(this.$t('Message.NoSelectedDataOrAreNotOperationalStatus'))
        return
      }
      // 业务锁定状态 费用不可操作
      for (const obj of selectedJobs) {
        if (!(obj && Number(obj.jobState) === 0 && !JobUtils.isBlockJob(obj)) || !this.validSelectJob(obj) || !this.hierarchyValidSingleSelectJob(obj)) {
          this.$message.warning(this.$t('Message.TheSelectedServicesIncludeLockedServices'))
          return
        }
      }
      if (!await this.validateChargeLocked(jobs)) return
      this.deleteChargeDetailDialog.chargeType = this.role.addPayableChargeRole ? 2 : 1
      this.deleteChargeDetailDialog.selectedJobs = selectedJobs
      this.deleteChargeDetailDialog.visible = true
    },
    // 删除费用处理结果
    batchCheckRemoveChargeResult(res) {
      const canDeleteChargeKeys = res.data
      if (canDeleteChargeKeys && canDeleteChargeKeys.length > 0) {
        batchRemoveCharge(canDeleteChargeKeys, this.location).then(res => {
          if (res.data > 0) {
            this.$message.success(this.$t('Message.DeleteSuccessfully'))
          } else {
            this.$message.error(this.$t('CargoMsg.Cargo_OperationFailed'))
          }
        })
      } else {
        this.$message.warning(this.$t('Message.NoCostToRemove'))
      }
    },
    // 批量导入费用
    async toImportCharge() {
      const selectedJobs = []
      const jobs = this.readSelectedRows()
      let operateType = -1
      for (const obj of jobs) {
        if (obj.jobState !== SystemConstants.OPERATING) {
          this.$message.warning(this.$t('Message.AllDataMustBeOperating'))
          return
        }
        if (operateType > -1 && obj.operateType !== operateType) {
          this.$message.warning(this.$t('queryJob.PleaseWithTheSameMode'))
          return
        }
        operateType = obj.operateType
        selectedJobs.push(obj)
      }
      if (selectedJobs.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectData'))
        return
      }
      // 业务锁定状态 费用不可操作
      for (const obj of selectedJobs) {
        if (!(obj && Number(obj.jobState) === 0 && !JobUtils.isBlockJob(obj)) || !this.validSelectJob(obj) || !this.hierarchyValidSingleSelectJob(obj)) {
          this.$message.warning(this.$t('Message.TheSelectedServicesIncludeLockedServices'))
          return
        }
      }
      if (selectedJobs.length > 500) {
        this.$message.info(this.$t('Message.TheNumberOfSelectedDataLimited') + 500)
        return
      }
      if (!await this.validateChargeLocked(jobs)) return

      // 将相同的委托单位、订舱代理、承运人、整拼类型、货物类型、起运港、目的港、目的港代理带入到费用方案窗口
      let isSameCustomer = true
      let isSameBookingAgent = true
      let isSameCarrierId = true
      let isSameOperateType = true
      let isSameCargoType = true
      let isSameLoadingPort = true
      let isSameDestinationPort = true
      let isSameDestinationAgent = true
      let isSameVesselLine = true
      operateType = selectedJobs[0].operateType
      const customerId = selectedJobs[0].customerId
      const bookingAgent = selectedJobs[0].bookingAgent
      const carrierId = selectedJobs[0].carrierId
      const cargoType = selectedJobs[0].cargoType
      const loadingPort = selectedJobs[0].loadingPortCode
      const destinationPort = selectedJobs[0].destinationPortCode
      const destinationAgent = selectedJobs[0].destinationAgent
      let vesselLine = ''
      const port = getObjectByCache(basicCacheKeys.basic_data_Airport, 'code', selectedJobs[0].destinationPortCode)
      if (port) {
        vesselLine = port.region
      }
      for (const airExportJob of selectedJobs) {
        if (customerId !== airExportJob.customerId) {
          isSameCustomer = false
        }
        if (bookingAgent !== airExportJob.bookingAgent) {
          isSameBookingAgent = false
        }
        if (carrierId !== airExportJob.carrierId) {
          isSameCarrierId = false
        }
        if (operateType !== airExportJob.operateType) {
          isSameOperateType = false
        }
        if (cargoType !== airExportJob.cargoType) {
          isSameCargoType = false
        }
        if (loadingPort !== airExportJob.loadingPortCode) {
          isSameLoadingPort = false
        }
        if (destinationPort !== airExportJob.destinationPortCode) {
          isSameDestinationPort = false
        }
        if (destinationAgent !== airExportJob.destinationAgent) {
          isSameDestinationAgent = false
        }
        const airPort = getObjectByCache(basicCacheKeys.basic_data_Airport, 'code', airExportJob.destinationPortCode)
        if (airPort && vesselLine !== airPort.region) {
          isSameVesselLine = false
        }
      }
      var sameCondition = {}
      if (isSameCustomer) {
        sameCondition['customerId'] = customerId
      }
      if (isSameBookingAgent) {
        sameCondition['bookingAgent'] = bookingAgent
      }
      if (isSameCarrierId) {
        sameCondition['carrierId'] = carrierId
      }
      if (isSameOperateType) {
        sameCondition['containerLoadType'] = operateType
      }
      if (isSameCargoType) {
        sameCondition['cargoType'] = cargoType
      }
      if (isSameLoadingPort) {
        sameCondition['loadingPort'] = loadingPort
      }
      if (isSameDestinationPort) {
        sameCondition['destinationPort'] = destinationPort
      }
      if (isSameDestinationAgent) {
        sameCondition['destinationAgent'] = destinationAgent
      }
      if (isSameVesselLine) {
        sameCondition['vesselLine'] = vesselLine
      }
      this.chargeSchemeBatchDialog.source = this.addChargeDetailDialog.visible ? 'addCharge' : 'jobList'
      this.chargeSchemeBatchDialog.chargeType = this.addChargeDetailDialog.visible ? this.chargeTypeDialog.type : null
      this.chargeSchemeBatchDialog.selectedJobs = selectedJobs
      this.chargeSchemeBatchDialog.job = this.selectedJob ? this.selectedJob : selectedJobs[0]
      this.chargeSchemeBatchDialog.needCheckRange = !(selectedJobs.length > 1) // 勾选了多票业务就不要用单个业务数据区间过滤费用方案
      this.chargeSchemeBatchDialog.isSea = false
      this.chargeSchemeBatchDialog.lob = 'AE'
      this.chargeSchemeBatchDialog.originalCondition = sameCondition
      this.chargeSchemeBatchDialog.visible = true
    },
    // 列表 业务编号旁边搜索框的打印
    showBusinessInfo(e) {
      stopBubble(e)
      // TemplateSelectorWin.getInstance().showThisWin(data as AbstractEntity, "JOB_DETAIL_OP", {"JOB_UUID":data.key}, FlexGlobals.topLevelApplication as DisplayObject);
      if (!this.selectedJob) return
      this.templateSelectorDialog.ctx = new AirExportJob(this.selectedJob)
      this.templateSelectorDialog.category = 'JOB_DETAIL_OP'
      this.templateSelectorDialog.data = { 'JOB_UUID': this.selectedJob.uuid }
      this.templateSelectorDialog.visible = true
    },
    // 批量打印
    onBatchPrint(command) {
      const rows = this.readSelectedRows()
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(rows)
      }
      const jobKeys = Array.from(rows, p => p.uuid)
      if (jobKeys.length > 0) {
        // TemplateSelectorWin.getInstance().showThisWin(_job, "JOBLIST", {"JOB_UUID":uids,"LOB":_job.lob}, _view);
        this.templateSelectorDialog.ctx = new AirExportJob().fillDefaultValue().getData()
        this.templateSelectorDialog.category = 'AEJOBLIST'
        this.templateSelectorDialog.data = {
          'JOB_UUID': jobKeys,
          'LOB': 'AE',
          jobuuid: jobKeys.join(','),
          'printSource': DocumentConstants.BATCH_PRINT_AE.code
        }
        // 是否按照多个打印
        if (command === this.$t('queryJob.PrintByBusinessNumber')) {
          Object.assign(this.templateSelectorDialog.data, {
            'JOB_UUID': jobKeys[0],
            multiplePrint: true,
            multipleJobUuid: jobKeys
          })
        }
        this.templateSelectorDialog.visible = true
      }
    },
    //  验证规则配置公用
    checkingManagerJobs(jobs, checkNode, callBack, callBack2, allowPartialCheckPass = false) {
      if (jobs && jobs.length > 0) { // 批量验证
        this.batchCheckingWindow.checkNode = checkNode
        this.batchCheckingWindow.jobs = jobs
        this.batchCheckingWindow.allowPartialCheckPass = allowPartialCheckPass
        this.batchCheckingWindow.callBack = callBack
        this.batchCheckingWindow.callBack2 = callBack2
        this.batchCheckingWindow.visible = true
      }
    },
    // 选中父级自动勾选子集，取消选中类似
    treeDataRowSelectedCallBack(p) {
      // return
      if (p.data.root) {
        if (p.node.selected) {
          p.node.childrenAfterGroup.forEach((node) => {
            node.setSelected(p.node.selected)
          })
        } else {
          const isTrue = p.node.childrenAfterGroup.filter(
            (node) => node.selected
          )
          if (isTrue.length === p.node.childrenAfterGroup.length) {
            p.node.childrenAfterGroup.forEach((node) => {
              node.setSelected(p.node.selected)
            })
          }
        }
      } else {
        if (!p.node.selected) {
          if (p.node.parent.selected) {
            p.node.parent.setSelected(false)
          }
        } else {
          const brothers = p.node.parent.childrenAfterGroup
          const selected = brothers.filter((node) => node.selected)
          if (selected.length === brothers.length) {
            p.node.parent.setSelected(true)
          }
        }
      }
    },
    // 预提交
    doSubmitPrint_PreSubmit() {
      this.doSubmitPrintPROFIT(CheckRuleConstants.NODE_PRE_COMMIT.code)
    },
    // 提交
    doSubmitPrint_Submit() {
      this.doSubmitPrintPROFIT(CheckRuleConstants.NODE_COMMIT.code)
    },
    // 主管提交
    doSubmitPrint_ManagerSubmit() {
      this.doSubmitPrintPROFIT(CheckRuleConstants.NODE_MANAGER_COMMIT.code)
    },
    // 主管审核
    async doSubmitAudit_ManagerSubmit() {
      const job = this.job
      const checkApChargeVerify = parseInt(cache.config.get('PreCommitJobCheckApChargeStateVerify'))
      if (checkApChargeVerify === 1) {
        const isPass = await JobUtils.checkChargeStateVerify(this.job)
        if (!isPass) {
          this.$message.warning(this.$t('Message.NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance'))
          return
        }
      }
      // 当整拼类型 为自拼箱时  判断开关是否开启 拒绝提交
      const ticketsMustBeVoted = parseInt(cache.config.get('TicketsMustBeVoted'))
      if (!job.masterFlag && !job.lclMasterUuid && (job.containerLoadType === 'LCL' || job.containerLoadType === 'BC') && ticketsMustBeVoted === 1) {
        this.$message.warning(this.$t('Message.TicketsMustBeVoted'))
        return
      }
      const callBack = this.getDoSubmitAudit_ManagerSubmit || null
      const callBack2 = this.getDoSubmitAudit_ManagerSubmit2 || null
      const checkNode = 10
      this.checkingManager(checkNode, callBack, callBack2)
    },
    // 主管审核【验证规则回调函数】
    getDoSubmitAudit_ManagerSubmit() {
      commit(this.job.uuid, SystemConstants.OPERATE_SUBMISSION.code, false, this.office.officeId, this.location).then(async res => {
        await this.mergeCurrentRow(res)
        this.refresh()
      })
    },
    // 主管审核【验证规则回调函数】
    getDoSubmitAudit_ManagerSubmit2() {
      this.commonInfo.showMessage = false
      this.loadChargesPrintReturnHandler()
    },
    // 主管审核【验证规则回调函数】
    async loadChargesPrintReturnHandler() {
      const charges = await new AirExportJob(this.job).getCharges()
      this.refChargeChargeState(charges)
      this.job.jobState = SystemConstants.OPERATING
      this.job.manageAuditStatus = 0
      this.job.operateNameCode = this.commonInfo.operateNameCode
      this.resetNoNeedSaveData()
      await saveJobInfo(this.job).then(async res => {
        await this.mergeCurrentRow(res)
        this.refresh()
        if (this.commonInfo.showMessage) {
          this.$message.info(this.$t('Message.AlreadyWithdraw'))
        } else {
          this.commonInfo.showMessage = true
        }
      })
    },
    // node 提交 检测的节点【预提交/提交/主管提交】
    async doSubmitPrintPROFIT(node) {
      const job = this.job
      this.commonInfo.allSubmitFcl = Number(cache.config.get('AllSubmitFcl')) === 1
      this.commonInfo.isPreCommit = node === CheckRuleConstants.NODE_PRE_COMMIT.code
      this.commonInfo.needSend = false
      // sap 交单验证结算公司
      this.commonInfo.openSapConfig = Number(cache.config.get('openSapConfig')) === 1
      if (this.commonInfo.openSapConfig) {
        job.charges = await new AirExportJob(this.job).getCharges()
        for (const charge of job.charges) {
          if (charge.settleDepartmentPrefix === '' || charge.settleDepartmentPrefix == null) {
            const n = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', charge.accountId, 'chineseName')
            this.$message.info(n + this.$t('Message.escnm'))
            return
          }
        }
      }
      if (node === CheckRuleConstants.NODE_PRE_COMMIT.code) {
        this.commonInfo.operateNameCode = SystemConstants.OPERATE_PRE_SUBMISSION.code
      } else if (node === CheckRuleConstants.NODE_COMMIT.code) {
        this.commonInfo.needSend = true
        this.commonInfo.operateNameCode = SystemConstants.OPERATE_SUBMISSION.code
      } else if (node === CheckRuleConstants.NODE_MANAGER_COMMIT.code) {
        this.commonInfo.needSend = true
        this.commonInfo.operateNameCode = SystemConstants.OPERATE_MANAGER_SUBMISSION.code
      }

      this.commonInfo.isPrintOpr = false
      const checkApChargeVerify = Number(cache.config.get('PreCommitJobCheckApChargeStateVerify'))
      if (this.commonInfo.isPreCommit && checkApChargeVerify === 1) {
        const isPass = await JobUtils.checkChargeStateVerify(this.job)
        if (!isPass) {
          this.$message.warning(this.$t('Message.NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance'))
          return
        }
      }
      // 当整拼类型 为自拼箱时  判断开关是否开启 拒绝提交
      const ticketsMustBeVoted = Number(cache.config.get('TicketsMustBeVoted'))
      if (!job.masterFlag && !job.lclMasterUuid && (job.containerLoadType === 'LCL' || job.containerLoadType === 'BC') && ticketsMustBeVoted === 1) {
        this.$message.warning(this.$t('Message.TicketsMustBeVoted'))
        return
      }
      // 判断是否开启验证规则
      const useCheckRule = Number(cache.config.get('useCheckRule')) === 1
      // const hasCheckRule = await JobUtils.hasCheckRuleCondition(useCheckRule, node, this.job.opOffice)
      const hasCheckRule = true
      if (useCheckRule && hasCheckRule) {
        const callBack = this.getDoSubmitPrintPROFIT || null
        const callBack2 = this.commitResultHandler || null
        const checkNode = node
        this.checkingManager(checkNode, callBack, callBack2)
      } else {
        if (this.commonInfo.allSubmitFcl) {
          this.doSubmitAllFcl()
        } else {
          this.doSubmitPrint()
        }
      }
    },
    // 提交【验证规则回调函数】
    async getDoSubmitPrintPROFIT() {
      const job = this.job
      const checkChargeInvoice = Number(cache.config.get('CheckReceivableChargePrintInvoice'))
      if (this.commonInfo.isPreCommit || checkChargeInvoice < 1) {
        const self = this
        commit(job.uuid, this.commonInfo.operateNameCode, this.commonInfo.isPreCommit, this.$store.getters.currentOfficeId, this.location).then(res => {
          self.selectedJob = res.data
          self.$message.success(this.$t('Message.CommitSuccessfully'))
          self.commitResultHandler(res)
        })
      } else {
        getChargeIsInvoice(job.uuid).then(res => this.getChargeIsInvoiceResult(res))
      }

      // 列表重新加载
      this.toQuery()
    },
    // 提交【验证规则回调函数】
    async commitResultHandler(res) {
      const job = this.selectedJob
      if (this.commonInfo.openSapConfig && this.commonInfo.needSend) {
        const jobs = []
        jobs.push(this.selectedJob.uuid)
        if (job.masterFlag && job.lclSlaves) {
          for (const j of job.lclSlaves) {
            jobs.push(j.uuid)
          }
        }
        const params = {}
        params.jobKey = jobs
        params.oldSapStatus = ChargeUtils.CHARGE_NULL.code
        params.sapStatus = ChargeUtils.CHARGE_SH.code
        params.needUpdateCharge = true
        const self = this
        sendSapMessageByJob(params).then(res => {
          self.$message.success(self.$t('Message.SapSynchronizationSuccess'))
          self.refreshHandler()
        })
      } else {
        this.refreshHandler()
      }
      // 列表重新加载
      this.toQuery()
    },
    // 提交主票，小票一起提交
    async doSubmitAllFcl() {
      if (this.job.lclMasterUuid) {
        this.$message.warning(this.$t('Message.LCLTicketCannotBeSubmittedSeparatelyPleaseSubmitTheMBL'))
        return
      } else if (this.job.masterFlag) {
        await this.getLclSlavesAndCharges()
        this.loadSubmitAllFclHandler()
      } else {
        this.doSubmitPrint()
      }
    },
    // 根据主票加载小票以及小票费用
    async getLclSlavesAndCharges() {
      await new AirExportJob(this.job).getCharges()
      const lclSlaves = await new AirExportJob(this.job).getLclSlaves()
      if (lclSlaves) {
        for (const lclJob of lclSlaves) {
          if (lclJob.uuid && !lclJob.charges) {
            await new AirExportJob(lclJob).getCharges()
          }
        }
      }
    },
    // 提交主票
    async loadSubmitAllFclHandler() {
      await RateUtil.refreshChargeRatesByJob(this.job)
      this.job.jobState = this.commonInfo.isPreCommit ? SystemConstants.PRE_COMMIT : SystemConstants.COMMITED
      for (const c of this.job.charges) {
        c.chargeState = BillingConstants.CHARGE_STATE_SUBMIT.code
      }
      for (const lclJob of this.job.lclSlaves) {
        lclJob.jobState = this.commonInfo.isPreCommit ? SystemConstants.PRE_COMMIT : SystemConstants.COMMITED
        if (!this.commonInfo.isPreCommit) {
          for (const c of lclJob.charges) {
            c.chargeState = BillingConstants.CHARGE_STATE_SUBMIT.code
          }
        }
      }
      this.job.operateNameCode = this.commonInfo.operateNameCode
      if (this.job.jobState === SystemConstants.PRE_COMMIT) {
        if (!this.job.charges) {
          this.job.charges = await new AirExportJob(this.job).getCharges()
        }
        await saveJobInfo(this.job).then(async res => {
          await this.mergeCurrentRow(res)
          this.$message.success(this.$t('Message.CommitSuccessfully'))
          await this.refresh()
        })
      } else {
        // 保存刷新过的的汇率 by Marco 2014-8-8 (Bad Design)
        this.resetNoNeedSaveData()
        await saveJobInfo(this.job).then(async res => {
          await this.mergeCurrentRow(res)
          this.$message.success(this.$t('Message.CommitSuccessfully'))
          this.commonInfo.isPrint = false
          if (this.btnInfo.visible.printFclProfit) {
            this.checkPrintEnable(this.doPrintFCLPROFIT)
          } else {
            this.checkPrintEnable(this.doPrintLCLPROFIT)
          }
        })
      }
    },
    // 整箱利润打印提交
    doPrintFCLPROFIT() {
      calculateProfit(this.job.uuid, -1, this.commonInfo.isPrintOpr, this.commonInfo.allSubmitFcl, this.commonInfo.isPreCommit, this.office.officeId, '', this.location).then(res => this.previewFCLProfit(res))
    },
    // 拼箱利润打印提交
    doPrintLCLPROFIT() {
      calculateProfit(this.job.uuid, -1, this.commonInfo.isPrintOpr, this.commonInfo.allSubmitFcl, this.commonInfo.isPreCommit, this.office.officeId, '', this.location).then(res => this.previewLCLProfit(res))
    },
    // 拼箱利润打印预处理
    previewLCLProfit(res) {
      this.previewProfit(res, 'LCL')
    },
    // 整箱利润打印预处理
    previewFCLProfit(res) {
      this.previewProfit(res, 'FCL')
    },
    // 预览打印【区分整箱拼箱】
    async previewProfit(res, type) {
      await this.mergeCurrentRow(res)
      // TemplateSelectorWin.getInstance().showThisWin(this.job, "LCLPROFIT", params, this, null, this.doPrintPROFIT, this.doPrintPROFIT_V2)
      // TemplateSelectorWin.getInstance().showThisWin(this.job, "FCLPROFIT", params, this, null, this.doPrintPROFIT, this.doPrintPROFIT_V2)
      this.$nextTick(() => {
        const params = {}
        params.jobuuid = this.job.uuid
        params.showPreview = this.commonInfo.isPrint
        params.JOB_UUID = this.job.uuid
        // 提交之前需要预打印，预打印是不需要弹出提示框的，这里主要是控制PrintTemplateManager.profitSubmitHandler的提示控制
        let category = 'LCLPROFIT'
        if (type === 'FCL') {
          params.isCommitJob = this.commonInfo.isPrint
          category = 'FCLPROFIT'
        }
        params.isPreCommit = this.commonInfo.isPreCommit
        console.log(type + '-previewProfit--params--', params)
        this.templateSelectorDialog.ctx = new AirExportJob(this.job)
        this.templateSelectorDialog.category = category
        this.templateSelectorDialog.data = params
        // 组装打印回调函数
        this.prePrintCallback = null
        this.printedCallback = this.doPrintPROFIT
        this.v2CheckCallback = this.doPrintPROFIT_V2
        this.templateSelectorDialog.visible = true
      })
      this.updateControlsState()
      this.refresh()
    },
    // 打印回调函数
    doPrintPROFIT(event) {
      this.commonInfo.printEvent = event
      this.commonInfo.isPreCommit = event.isPreCommit
      if (PrintUtils.isExecutor(event.action)) {
        if (this.job && this.job.uuid) {
          // 检查是否有收费用未开发票
          if (this.job.jobState === SystemConstants.OPERATING) {
            getChargeIsInvoice(this.job.uuid).then(res => this.getChargeIsInvoiceResult(res))
          } else {
            this.printAlert()
          }
        }
      }
    },
    // 打印回调函数
    doPrintPROFIT_V2(isSure, template, entity, arms) {
      if (isSure && arms) {
        this.commonInfo.isPreCommit = arms.event.isPreCommit
        if (PrintUtils.isExecutor(arms.event.action)) {
          this.printAlert()
        }
      }
    },
    // 确认是否可打印
    checkPrintEnable(callback) {
      if (this.job && !this.job.masterFlag && this.job.sales <= 0 && this.job.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
        const msg = this.commonInfo.isPrint ? this.$message.warning(this.$t('Message.PleaseInputTheSalesInformationAndPrints')) : this.$message.warning(this.$t('Message.PleaseInputTheSalesInformationAndSubmit'))
        this.$message.info(msg)
        return
      }
      const jobNos = this.checkSales()
      if (jobNos.length > 0) {
        const msg1 = this.$t('Message.FollowingTheSingleDidNotEnterTheSalesInformation') + ':\n' + jobNos.join('\n') + '\n' + this.$t('Message.PleaseEnterAndPrint')
        const msg2 = this.$t('Message.FollowingTheSingleDidNotEnterTheSalesInformation') + ':\n' + jobNos.join('\n') + '\n' + this.$t('Message.PleaseEnterAndSubmit')
        this.$message.info(this.commonInfo.isPrint ? msg1 : msg2)
        return
      }
      callback()
    },
    // 验证销售及揽货类型
    async checkSales() {
      const jobNos = []
      if (this.job.masterFlag) {
        const lclSlaves = await new AirExportJob(this.job).getLclSlaves()
        if (!lclSlaves) {
          for (const j of this.job.lclSlaves) {
            if (j.sales <= 0 && j.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
              jobNos.push(j.jobNo)
            }
          }
        }
      }
      return jobNos
    },
    // 正常提交
    async doSubmitPrint() {
      if (this.job.jobState === SystemConstants.PRE_COMMIT) {
        if (this.job.uuid && !this.job.charges) {
          await new AirExportJob(this.job).getCharges()
        }
        await this.loadChargeHandler()
        return
      }
      this.commonInfo.isPrint = false
      if (this.btnInfo.visible.printFclProfit) {
        this.checkPrintEnable(this.doPrintFCLPROFIT)
      } else {
        this.checkPrintEnable(this.doPrintLCLPROFIT)
      }
    },
    // 加载当前业务的费用
    async loadChargeHandler() {
      this.job.jobState = SystemConstants.COMMITED
      for (const c of this.job.charges) {
        if (c.chargeState === BillingConstants.CHARGE_STATE_NORMAL.code) {
          c.chargeState = BillingConstants.CHARGE_STATE_SUBMIT.code
        }
      }
      this.job.operateNameCode = this.commonInfo.operateNameCode
      this.job.submissionDate = DateUtils.formatStandardDateTime(new Date())
      this.job.commitUser = this.$store.getters.userId
      await saveJobInfo(this.job).then(async res => {
        await this.commitResultHandler()
        await this.mergeCurrentRow(res)
        this.$message.success(this.$t('Message.CommitSuccessfully'))
        this.refresh()
      })
    },
    // 打印回调函数
    commitRefuseHandler() {
      this.refresh()
    },
    // 检查是否有收费用未开发票
    async getChargeIsInvoiceResult(res) {
      const flag = res.data
      if (flag) {
        const msg = this.commonInfo.isPrint ? this.$t('Message.ThereAreFeesReceivableNotInvoicedPrint') : this.$t('Message.ThereAreFeesReceivableNotInvoicedSubmit')
        await this.$confirm(msg, this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(async() => {
          await this.printAlert()
        }).catch(() => {
          this.commonInfo.isPrint = true
        })
      } else {
        await this.printAlert()
      }
    },
    // 打印提示
    async printAlert() {
      let msg = this.$t('Message.VerifyThatTheRelatedFileHasBeenUploadedBeforeSubmittingSystemContinue')
      if (this.commonInfo.isPreCommit) {
        msg = this.$t('Message.SubmittedToTheSuperiorAuditVerifyThatTheRelatedFileHasBeenUploadedBeforeSubmittingSystemContinue')
      }
      await this.$confirm(msg, this.$t('common.tips.warning'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.onConfirmedPrintProfit()
      }).catch({})
    },
    // 提交/预提交
    onConfirmedPrintProfit() {
      if (Number(cache.config.get('useCheckRule')) === 1) {
        printProfit(this.job.uuid, this.commonInfo.operateNameCode, this.office.officeId, '', this.location).then(res => this.calculateProfit2ResultHandler(res))
      } else {
        calculateProfit(this.job.uuid, this.commonInfo.operateNameCode, this.commonInfo.isPrintOpr, true, this.commonInfo.isPreCommit, this.office.officeId, '', this.location).then(res => this.calculateProfit2ResultHandler(res))
      }
    },
    // 提交成功
    async calculateProfit2ResultHandler(res) {
      await this.mergeCurrentRow(res)
      if (this.commonInfo.printEvent && !PrintUtils.isPrint(this.commonInfo.printEvent.action)) {
        const template = this.commonInfo.printEvent.template
        const parameter = this.commonInfo.printEvent.parameter
        let documentType = null
        if (template && template.documentTypeUuid || !Object.prototype.hasOwnProperty.call(parameter, 'documentType') || !parameter.documentType) {
          await getDocumentType(template.documentTypeUuid).then(res => {
            documentType = res.data ? res.data : null
          })
        }
        if (StimulSoftUtil.isOpenStiReport(template)) {
          parameter.designMode = this.$checkPermission(['role_template_design']) ? 1 : 0
          parameter.documentType = documentType
          await StimulSoftUtil.stiReportPreview(template, this.job, parameter)
        } else {
          const action = this.commonInfo.printEvent.action || ''
          const format = this.commonInfo.printEvent.format || ''
          const url = await PrintTemplateManager.print(template, documentType, format, parameter, action === PrintUtils.PRINT)
          if (url) {
            await this.loadMailURL(url, parameter)
          }
        }
      }
      this.updateJobState()
      this.refresh()
    },
    // 加载MailURLRequest
    async loadMailURL(url, parameter) {
      let status = -1
      const request = new XMLHttpRequest()
      request.open('GET', url, false) // false 同步，默认异步【此处需要同步，需要拿status判断做后续处理】
      request.onload = function(e) {
        status = e.target.status
      }
      request.onerror = function(e) {
        this.loadError()
      }
      request.send()
      if (Object.prototype.hasOwnProperty.call(parameter, 'showPreview') && parameter.showPreview) {
        this.httpResultEmail(status)
      }
    },
    // Mail异常结果处理
    httpResultEmail(status) {
      // 附件过大
      if (status === 0) {
        this.$message.error('附件内容过大')
      } else if (status === 1) {
        this.$message.error(this.$t('SeaExport.SmtpServerError'))
      } else if (status === 2) {
        this.$message.error(this.$t('SeaExport.NotConnectSmtpServer'))
      } else if (status === 3) {
        this.$message.error(this.$t('SeaExport.NotFindFile'))
      } else if (status === 4) {
        this.$message.error(this.$t('SeaExport.SendFileError'))
      } else if (status === 5) {
        this.$message.error(this.$t('SeaExport.AttachTemplateError'))
      } else if (status === 200) {
        this.$message.success(this.$t('SeaExport.MailSentSuccess'))
      }
    },
    // 验证规则配置公用
    async checkingManager(checkNode, callBack, callBack2) {
      this.$logger.log('this.job', this.job)
      if (!this.job) return
      let checkType = true
      if (this.job.masterFlag) {
        const lclSlaves = await new AirExportJob(this.job).getLclSlaves()
        if (lclSlaves && lclSlaves.length > 0) { // 批量验证
          checkType = false
          this.batchCheckingWindow.checkNode = checkNode
          this.batchCheckingWindow.jobs = [this.job, ... lclSlaves]
          this.batchCheckingWindow.callBack = callBack
          this.batchCheckingWindow.callBack2 = callBack2
          this.batchCheckingWindow.visible = true
        }
      }
      if (checkType) { // 单个验证
        this.checkingWindow.checkNode = checkNode
        this.checkingWindow.callBack = callBack
        this.checkingWindow.callBack2 = callBack2
        this.checkingWindow.visible = true
      }
    },
    // 合并当前job【刷新当前job】
    mergeCurrentRow(res) {
      if (res && res.data) {
        Object.assign(this.selectedJob, res.data)
        this.selectedJob.uuid = res.data.uuid
        this.selectedJob.isCompleteRow = false
        this.isRefresh = true
      }
      // 重新查询list 避免再次操作时 提示未选中
      this.toQuery()
    },
    // 刷新
    refreshHandler() {
      this.selectedJob.isCompleteRow = false
      this.selectedJob.isPrint = true
      this.selectedJob.isPrintOpr = false
      this.refresh()
      this.updateJobState()
    },
    async refresh() {
      if (this.selectedJob) {
        this.selectedJob = await getJobByUuid(this.selectedJob.uuid).then(res => {
          this.showCustomerLevel()
          return res.data
        })
        this.replaceRowDataJobAndRefreshGrid(this.selectedJob)
      }
    },
    resetNoNeedSaveData() {
      if (Object.prototype.hasOwnProperty.call(this.selectedJob, 'containerUsages')) {
        for (const usage of this.selectedJob.containerUsages) {
          delete usage.container
        }
      }
      if (Object.prototype.hasOwnProperty.call(this.selectedJob, 'containers')) {
        for (const container of this.selectedJob.containers) {
          delete container.containerUsages
        }
      }
    },
    // 客户级别,合约状态
    showCustomerLevel() {
      if (this.job.lclMaster) {
        if (this.job.lclMaster.lclSlaves) {
          const lcls = this.job.lclMaster.lclSlaves
          if (lcls.length > 0) {
            for (const ljob of lcls) {
              if (ljob) {
                if (ljob.customerId > 0 || !StrUtils.isEmpty(ljob.contractStatus)) {
                  this.showCustomerLevelHander(ljob.customerId)
                }
              }
            }
          }
        }
      } else {
        this.showCustomerLevelHander(this.job.customerId)
      }
    },
    /**
     * 客户级别
     */
    showCustomerLevelHander(customerId) {
      const company = Company.getCompanyById(customerId)
      if (company != null) {
        // 客户级别
        this.loadCustomerTypeHandler(customerId)
        // 合同状态
        this.loadContractsHandler(customerId)
      }
    },

    // 客户级别
    async loadCustomerTypeHandler(customerId) {
      const company = Company.getCompanyById(customerId)
      if (company && company.customerDetail) {
        const customerType = await getCustomerTypeList({ typeId: company.customerDetail.customerTypeId }).then(res => {
          return res.data.list.length > 0 ? res.data.list[0] : null
        })
        if (customerType != null) {
          if (this.job.lclMaster) {
            const lcls = this.job.lclMaster.lclSlaves
            if (lcls && lcls.length > 0) {
              for (const ljob of lcls) {
                if (customerId === ljob.customerId && ljob.customerTypeId < 0) {
                  ljob.customerTypeId = customerType.typeId
                  break
                }
              }
            }
          } else {
            this.job.customerTypeId = customerType.typeId
          }
        }
      }
    },

    // 合约状态
    loadContractsHandler(customerId) {
      const company = Company.getCompanyById(customerId)
      const contracts = company.contracts

      if (this.job.lclMaster) {
        const lcls = this.job.lclMaster.lclSlaves
        if (lcls && lcls.length > 0) {
          for (const ljob of lcls) {
            if (customerId === ljob.customerId && StrUtils.isEmpty(ljob.contractStatus)) {
              ljob.contractStatus = this.contractsCommon(contracts)
              break
            }
          }
        }
      } else {
        this.job.contractStatus = this.contractsCommon(contracts)
      }
    },

    /**
     * 合约状态(common)
     */
    contractsCommon(contracts) {
      let strStatus = ''
      if (contracts == null || contracts.length === 0) {
        strStatus = this.$t('CargoMsg.Cargo_NotContracted')
      } else {
        const timeFcl = new Date()
        let flagFcl
        for (const contractFcl of contracts) {
          if (timeFcl >= contractFcl.beginDate && timeFcl <= contractFcl.endDate) {
            flagFcl = true
            break
          }
        }
        strStatus = flagFcl ? this.$t('CargoMsg.Cargo_Contracted') : this.$t('CargoMsg.Cargo_ContractExpired')
      }
      return strStatus
    },
    // 撤回
    backReturn() {
      this.$confirm(this.$t('queryJob.AreWantToWithdrawTicket'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        if (this.job.jobState === SystemConstants.COMMITED || this.job.jobState === SystemConstants.PRE_COMMIT) {
          this.commonInfo.operateNameCode = SystemConstants.OPERATE_PRINT_RETURN.code
          if (this.job.jobState === SystemConstants.PRE_COMMIT) {
            this.commonInfo.operateNameCode = SystemConstants.OPERATE_RETURN_ACTION.code
          }
          if (this.commonInfo.operateNameCode === SystemConstants.OPERATE_PRINT_RETURN.code) {
            this.commonInfo.returnSend = true
          }
          this.loadChargesHandler()
        }
      }).catch(() => { })
    },
    async loadChargesHandler() {
      const charges = await new AirExportJob(this.job).getCharges()
      this.refChargeChargeState(charges)
      // 刷新，job获取version
      await this.refresh()
      const job = this.job
      job.jobState = SystemConstants.OPERATING
      job.isShutOut = false
      job.manageAuditStatus = 0
      job.operateNameCode = this.commonInfo.operateNameCode
      this.resetNoNeedSaveData()
      const self = this
      await saveJobInfo(job).then(async res => {
        self.backResultHandler()
        self.replaceRowDataJobAndRefreshGrid(res.data)
        // 重新查询list
        this.toQuery()
      })
    },
    backResultHandler() {
      const submitChargeState = Number(cache.config.get('CommitJobChangedChargeState'))
      if (this.commonInfo.openSapConfig && this.commonInfo.returnSend && submitChargeState) {
        const jobs = []
        jobs.push(this.selectedJob.uuid)
        if (this.job.masterFlag && this.job.lclSlaves) {
          for (const j of this.job.lclSlaves) {
            jobs.push(j.uuid)
          }
        }
        const params = {}
        params.jobKey = jobs
        params.oldSapStatus = ChargeUtils.CHARGE_SH.code
        params.sapStatus = ChargeUtils.CHARGE_NULL.code
        params.needUpdateCharge = true
        const self = this
        sendSapMessageByJob(params).then(res => {
          self.$message.success(self.$t('Message.SapSynchronizationSuccess'))
          self.saveChargeSapEventHandler(res)
          self.refreshHandler()
        })
      } else {
        if (this.commonInfo.showMessage) {
          this.$message.success(this.$t('Message.AlreadyWithdraw'))
        } else {
          this.commonInfo.showMessage = true
        }
        // 更新按钮
        this.updateJobState()
      }
    },
    // sap提交成功
    saveChargeSapEventHandler(res) {
      if (res.data) {
        if (res.data > 0) {
          this.$message.success(this.$t('Message.SapSynchronizationSuccess'))
        } else {
          this.$message.error(this.$t('Message.SapSynchronizationFault'))
        }
      }
      // 更新按钮
      this.updateJobState()
      this.refresh()
    },
    refChargeChargeState(charges) {
      const submitChargeState = parseInt(cache.config.get('CommitJobChangedChargeState'))
      if (submitChargeState === 1 && charges && charges.length > 0) {
        for (const c of charges) {
          if (c.chargeState === BillingConstants.CHARGE_STATE_SUBMIT.code) {
            c.chargeState = BillingConstants.CHARGE_STATE_NORMAL.code
          }
        }
      }
    },
    // 替换rowData中对应的job 并刷新列表
    replaceRowDataJobAndRefreshGrid(job) {
      if (!job) return
      const index = this.rowData.findIndex(row => row.uuid === job.uuid)
      if (index >= 0) {
        const rowNode = this.gridOptions.api.getRowNode(index)
        rowNode.setData(job)
      }
    },
    // 发送现场操作回调函数,打印模板
    sendSiteOpPrint(data) {
      const jobList = []
      if (data && data.length > 0) {
        for (const item of data) {
          jobList.push(item.jobUuid)
        }
      }
      const params = {}
      params.jobuuid = jobList.join(',')
      params.JOB_UUID = jobList
      params.USER_ID = this.$store.getters.userInfo.userId
      this.templateSelectorDialog.category = 'AELIST'
      this.templateSelectorDialog.data = params
      this.prePrintCallback = null
      this.printedCallback = null
      this.v2CheckCallback = null
      this.templateSelectorDialog.visible = true
    },
    // 发送现场操作回调函数，修改列表数据
    sendSiteOpCallBack(jobs) {
      if (jobs) {
        for (const job of this.rowData) {
          for (const item of jobs) {
            if (job.jobUuid === item.uuid) {
              job.version = item.version // version必须+1,否则重复操作会提示数据已被修改
              job.voyageFlight = item.voyageFlight
              job.planner = item.planner
              job.siteOp = item.siteOp
              job.siteOpDepartment = item.siteOpDepartment
              job.weightBooking = item.weightBooking
              job.quantityBooking = item.quantityBooking
              job.cubageBooking = item.cubageBooking
            }
          }
        }
      }
    },
    // 验证费用锁定状态
    async validateChargeLocked(jobs) {
      if (jobs && jobs.length > 0) {
        let pass = true
        const keys = []
        for (const item of jobs) {
          if (item.uuid) {
            keys.push(item.uuid)
          }
        }
        await validateChargeLockStatus(keys).then(res => {
          pass = res.data
        }).catch()
        if (!pass) {
          this.$message.warning(this.$t('SeaExport.ChargeLocked'))
          return false
        }
      }
      return true
    },
    // 批量主管提交
    async toBatchManagerSubmission() {
      const selectedRows = this.readSelectedRows()
      let rows = []
      let jobKeys = []
      for (const j of selectedRows) {
        if (this.isCooperate(j.cooperateStatus)) {
          this.$message.warning('[' + j.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (!this.allowPartialCheckPass) {
          if (!j.masterFlag && !j.lclMasterUuid && (j.containerLoadType === 'LCL' || j.containerLoadType === 'BC') && this.ticketsMustBeVoted) {
            this.$message.warning(this.$t('Message.TicketsMustBeVoted'))
            return
          }
          if (Number(j.jobState) !== Number(SystemConstants.OPERATING) && Number(j.jobState) !== Number(SystemConstants.PRE_COMMIT)) {
            this.$message.warning(this.$t('SeaExport.BatchManagerSubmissionTips'))
            return
          }
        }
        jobKeys.push(j.uuid)
        rows.push(j)
      }

      if (jobKeys.length > 0) {
        // 预付款余额校验
        const checkFailUuids = []
        const continueExec = await JobUtils.checkBalanceBeforeSubmitHandler(jobKeys, checkFailUuids, true)
        if (!continueExec) {
          return
        }
        // 余额不足
        if (checkFailUuids && checkFailUuids.length > 0) {
          const checkKeys = []
          for (const key of jobKeys) {
            if (checkFailUuids.indexOf(key) === -1) {
              checkKeys.push(key)
            }
          }
          if (checkKeys.length > 0) {
            jobKeys = checkKeys
            rows = []
            for (const j of selectedRows) {
              if (jobKeys.indexOf(j.uuid) !== -1) {
                rows.push(j)
              }
            }
          } else {
            return
          }
        }
        // 判断是否开启验证规则
        const checkNode = CheckRuleConstants.NODE_MANAGER_COMMIT.code
        const opOffice = (rows && rows.length > 0) ? rows[0].opOffice : 0
        // const hasCheckRule = await JobUtils.hasCheckRuleCondition(this.useCheckRule, checkNode, opOffice)
        const hasCheckRule = true
        if (this.useCheckRule && hasCheckRule) {
          this.batchCheckingWindow.jobs = rows // 回调中使用
          const callBack = this.batchBatchManagerSubmissionCall || null
          this.checkingManagerJobs(rows, checkNode, callBack, null, this.allowPartialCheckPass)
        } else {
          this.$confirm(this.$t('Message.MakeSureToSubmitAListOftheNFinancialAuditPlease1') + jobKeys.length + this.$t('SeaExport.VotesManagerSubmission'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning',
            closeOnClickModal: false
          }).then(() => {
            batchManagerCommit({ jobKeys: jobKeys, officeId: this.$store.getters.currentOfficeId, location: this.location }).then(res => this.handlerBatchManagerSubmissionResult(res))
          }).catch(() => {
          })
        }
      }
    },
    batchBatchManagerSubmissionCall() {
      let jobKeys = []
      if (!this.allowPartialCheckPass) {
        const jobs = this.batchCheckingWindow.jobs
        jobKeys = jobs && jobs.length > 0 ? Array.from(jobs, p => p.uuid) : []
      } else {
        jobKeys = this.$refs.batchCheckingWindow.checkPassKeys
      }
      if (jobKeys && jobKeys.length > 0) {
        batchManagerCommit({ jobKeys: jobKeys, officeId: this.$store.getters.currentOfficeId, location: this.location }).then(res => this.handlerBatchManagerSubmissionResult(res))
      }
    },
    // 批量主管提交处理结果
    handlerBatchManagerSubmissionResult(res) {
      const len = res.data ? res.data.length : 0
      this.$message.success(this.$t('SeaExport.BatchManagerSubmissionSuccessfully') + len)
      this.toQuery()
    },
    // 导出导入订单模板
    exportOrderHandle() {
      switch (this.exportOrderCommand) {
        case this.$t('SeaExport.Add'):
          this.toAdd()
          break
        case this.$t('SeaExport.import'):
          this.$refs.uploadOrder.submit()
          break
        case this.$t('FbaJob.batchImportOrder'):
          this.$refs.uploadBatchOrder.submit()
          break
        case this.$t('FbaJob.importSingleOrder'):
          this.$refs.uploadSingleOrder.submit()
          break
        case this.$t('CargoMsg.Cargo_DownImportTemplate'):
          this.downloadTemplate()
          break
        case this.$t('FbaJob.downloadBatchImportTemplate'):
          this.downloadBatchImportTemplate()
          break
        case this.$t('FbaJob.downloadSingleImportTemplate'):
          this.downloadSingleImportTemplate()
          break
      }
    },
    beforeOrderUpload(file) {
      this.loading = getLoading()
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.loading.close()
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    // 上传成功
    uploadOrderSuccess(res, file, fileList) {
      this.loading.close()
      if (res.ok) {
        const h = this.$createElement
        this.$msgbox({
          title: this.$t('common.tips.prompt'),
          message: h('p', null, [
            h('p', { style: 'fontSize: 20px;paddingBottom:5px' }, this.$t('CargoMsg.Cargo_ImportingData')),
            h('p', { style: 'color: red' }, this.$t('CargoMsg.Cargo_ImportingDataSuccess'))
          ]),
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'success'
        })
      } else {
        this.$confirm(res.message, this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          canCloseModule: true,
          type: 'warning'
        })
      }
    },
    handleError(error) {
      const errorData = JSON.parse(error.message)
      this.$message.error({ 'message': errorData.message, 'duration': 15000 })
      this.loading.close()
    },
    // 单个导入上传成功
    uploadSingleOrderSuccess(res, file, fileList) {
      console.log('uploadOrderSuccess', res)
      const { data } = res
      this.loading.close()
      this.$confirm(data.message, this.$t('queryJob.uploadSucceeded'), {
        cancelButtonText: this.$t('Partners.downloadImportResults'),
        confirmButtonText: this.$t('Message.Confirm'),
        distinguishCancelAndClose: true,
        beforeClose: async(action, instance, done) => {
          if (action === 'cancel') {
            await cache.load(cacheName.USER, cacheName.CONFIG)
            const storageUrl = cache.config.get('StorageURL')
            const url = `${URL.common.findByFileId}/${data.data}?sessionId=${this.$store.getters.token}`
            const el = document.createElement('a')
            document.body.appendChild(el)
            el.href = url
            el.target = '_blank'
            el.click()
            document.body.removeChild(el)
          } else {
            done()
          }
        }
      })
    },
    // Lts同步
    batchLtsSyncHandle(val) {
      const rows = this.readSelectedRows(true)
      if (!rows || rows.length <= 0) return
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(rows)
      }
      this.$refs.ltsBatchSyncCharge.onShow({ rows: rows, anyBool: val })
      this.ltsWindow.visible = true
    },
    // 下载导出订单模板
    downloadTemplate() {
      // ExportUtils.downloadOrderTemplateFile(this.$store.getters.currentOfficeId, 'AE')
      // CARGO-39209 各个业务类型批量导入模板中，各模板加入样例文件
      this.downloadImportTemplateDialog.visible = true
    },
    // 下载空运头程批量导入模板
    downloadBatchImportTemplate() {
      // ExportUtils.downloadTemplateFile('ImportBatchAirFbaOrders.xlsx', 'fba')
      ExportUtils.downloadOrderTemplateFile(this.$store.getters.currentOfficeId, 'FBA_AE')
    },
    // 下载空运头程单个导入模板
    downloadSingleImportTemplate() {
      ExportUtils.downloadTemplateFile('ImportOneAirFbaOrder.xlsx', 'fba')
    },
    // 批量修改目的港信息
    toBatchModifyPodInfo() {
      const rows = this.readSelectedRows()
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
      }
      for (const key in this.podInfo) {
        if (key === 'visible') continue
        this.podInfo[key] = ''
      }
      this.podInfo.keys = Array.from(rows, p => p.uuid)
      this.podInfo.visible = true
    },
    // 确认批量修改目的港信息
    confirmBatchModifyPodInfo() {
      const param = {}
      for (const key in this.podInfo) {
        if (key === 'visible') continue
        if (this.podInfo[key]) { // 有值处理，无值不处理
          param[key] = this.podInfo[key]
        }
      }
      if (Object.keys(param).length <= 1) {
        return
      }
      param.lob = this.lob
      this.loading = getLoading4Cxt()
      batchModifyPodInfo(param).then(res => {
        if (res.data && res.data > 0) {
          this.$message.success(this.$t('Message.OperationSuccessfully'))
          this.podInfo.visible = false
          return
        }
        this.$message.error(this.$t('CargoMsg.Cargo_OperationFailed'))
      }).finally(() => {
        this.loading.close()
      })
    },
    // 组装查询条件
    async getCustomSearchItems() {
      const defaultSearchFields = []
      let searchField = new AdvancedSearchField()
      if (this.useOrderCenterMode && this.orderCenterBranch) {
        // 协作分公司
        const officeAll = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
        const offices = officeAll.filter(p => p.code !== 'HQ' && p.code !== this.$store.getters.currentOffice.code).sort((office1, office2) => office1.officeId > office2.officeId ? 1 : -1) // 其他分公司
        offices.forEach(row => { row.code = row.officeId }) // ID
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BRANCH_ID'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBranchId'
        searchField.itemValue = []
        searchField.tagValue = 'officeId'
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = offices
        defaultSearchFields.push(searchField.formatObj2Json())
        // 协作业务类型
        const cooperationTypes = getCacheListByKey(basicCacheKeys.basic_data_CooperationType)
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BUSINESS_TYPE'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBusinessType'
        searchField.itemValue = []
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = cooperationTypes
        defaultSearchFields.push(searchField.formatObj2Json())
        // 协作任务创建时间
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'date'
        searchField.fieldType = 'FIELD_DATE_RANGE'
        searchField.itemCondition = []
        searchField.subType = 'range'
        searchField.defaultConditionVal = ''
        searchField.itemName = 'cooperate.DATE_CREATED'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateCreatedDate'
        searchField.itemValue = []
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = []
        defaultSearchFields.push(searchField.formatObj2Json())
      }

      // 实际送货时间
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'date'
      searchField.fieldType = 'FIELD_DATE_RANGE'
      searchField.itemCondition = []
      searchField.subType = 'range'
      searchField.defaultConditionVal = ''
      searchField.itemName = 'airExportJob.ACTUAL_SHIPPING_TIME'
      searchField.itemLabel = 'CargoMsg.Cargo_actGoodsDeliveryTime'
      searchField.itemValue = []
      searchField.selected = 0
      searchField.valueExpression = ''
      searchField.lock = false
      searchField.defaultValue = []
      defaultSearchFields.push(searchField.formatObj2Json())

      if (!this.bookingAgentVisible) {
        // 移除订舱代理
        searchField = new AdvancedSearchField()
        searchField.itemType = 'company'
        searchField.subType = {
          'type': 'bookingAgent',
          'tagValue': 'cmpIdx'
        }
        searchField.fieldType = 'FIELD_BOOKING_AGENT'
        searchField.itemName = 'job.BOOKING_AGENT'
        searchField.itemLabel = 'SeaExport.BookingAgent'
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        defaultSearchFields.push(searchField.formatObj2Json())
      } else {
        defaultSearchFields.push({
          'action': AdvancedSearchField.UPDATE_ACTION,
          'itemType': 'company',
          'subType': {
            'type': 'bookingAgent',
            'tagValue': 'cmpIdx',
            'includeAllOffice': this.conditonDisplayAllBranchData
          },
          'fieldType': 'FIELD_BOOKING_AGENT',
          'itemCondition': [],
          'defaultConditionVal': '',
          'itemName': 'job.BOOKING_AGENT',
          'itemLabel': 'SeaExport.BookingAgent',
          'itemValue': '',
          'defaultSelected': 0,
          'selected': 0,
          'valueExpression': '',
          'lock': false,
          'defaultValue': ''
        })
      }
      // 委托单位
      searchField = new AdvancedSearchField()
      searchField.itemType = 'company'
      searchField.subType = {
        'type': 'customer',
        'tagValue': 'cmpIdx',
        'useSales': true,
        'includeAllOffice': this.conditonDisplayAllBranchData
      }
      searchField.fieldType = 'FIELD_CUSTOMER'
      searchField.itemName = 'job.CUSTOMER_ID'
      searchField.itemLabel = 'CargoMsg.Cargo_AuthorizedClient'
      searchField.defaultSelected = 1
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      defaultSearchFields.push(searchField.formatObj2Json())

      if (this.isBpmEnabled) {
        // CARGO-39771 BPM各审批流增加快捷入口（增加审批流水号）
        searchField = new AdvancedSearchField()
        searchField.itemType = 'input'
        searchField.operationType = 'text6'
        searchField.fieldType = 'FIELD_TEXT'
        searchField.itemName = 'approvalForm.DOCUMENT_PROCESS_NO'
        searchField.itemLabel = 'CargoMsg.Cargo_ApprovalSerialNumber'
        searchField.itemValue = ''
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.lock = false
        searchField.defaultValue = ''
        searchField.action = AdvancedSearchField.ADD_ACTION
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      for (const item of this.defaultSearchItems) {
        if (item.itemName === 'job.BOOKING_AGENT' && item.fieldType === 'FIELD_BOOKING_AGENT') {
          continue
        }
        if (item.itemName === 'job.CUSTOMER_ID' && item.fieldType === 'FIELD_CUSTOMER') {
          continue
        }
        if (item.itemType === 'userSea' || item.itemType === 'user' || item.itemType === 'user2') {
          const newItem = lodash.cloneDeep(item)
          newItem.newItem = AdvancedSearchField.UPDATE_ACTION
          if (this.conditonDisplayAllBranchData) {
            newItem.subType = newItem.subType || {}
            newItem.subType.officeId = ''
          }
          defaultSearchFields.push(newItem)
        } else if (item.itemType === 'company' || item.itemType === 'office' || item.itemType === 'department5') {
          const newItem = lodash.cloneDeep(item)
          newItem.newItem = AdvancedSearchField.UPDATE_ACTION
          if (this.conditonDisplayAllBranchData) {
            newItem.subType = newItem.subType || {}
            newItem.subType.includeAllOffice = true
          }
          defaultSearchFields.push(newItem)
        }
      }
      // 中邮-可售卖产品和国内国外
      if (this.isZY) {
        let saleProductList
        if (!this.isFba) {
          saleProductList = getFilterCacheList(TYPE_NAMES.basic_data_AllowSaleProduct, (mapping) => {
            return mapping.statusEnabled === true && mapping.airExportEnabled === true
          })
        } else {
          saleProductList = getFilterCacheList(TYPE_NAMES.basic_data_AllowSaleProduct, (mapping) => {
            return mapping.statusEnabled === true && mapping.fbaAir === true
          })
        }
        // 可售卖产品
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'advanceSelect2'
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL, AdvancedSearchConsts.OPERATOR_UNEQUAL, AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST_NOT_CONVERT'
        searchField.itemName = 'job.SALE_PRODUCT_CODE'
        searchField.itemLabel = 'CargoMsg.AllowSaleProduct'
        searchField.tagValue = 'productCode'
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.defaultValue = ''
        searchField.dataProvider = saleProductList
        defaultSearchFields.push(searchField.formatObj2Json())

        // 全程/国内
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'advanceSelect2'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL, AdvancedSearchConsts.OPERATOR_UNEQUAL, AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'job.FULL_OR_INSIDE'
        searchField.itemLabel = 'CargoMsg.FullOrInside'
        searchField.tagValue = 'code'
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.defaultValue = ''
        searchField.dataProvider = Array.from(SystemConstants.FULL_OR_INSIDE)
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      if (this.hierarchyViewList) {
        JobUtils.configSearchItemsChildOffice(this.defaultSearchItems, defaultSearchFields)
      }
      if (this.$store.state.uiCustom.enable && !this.isFba) {
        UICustomUtil.handleSearchItems(UICustomConstants.AIR_BOOKING_MODULE, this.defaultSearchItems, defaultSearchFields)
      }
      return defaultSearchFields
    },
    // 是否协作业务
    isCooperate(cooperateStatus) {
      console.log('isCooperate', cooperateStatus)
      if (cooperateStatus !== -1 && this.useOrderCenterMode) {
        return true
      }
      return false
    },
    // 批量修改业务
    toBatchModifyBusiness() {
      const rows = this.readSelectedRows()
      if (rows.length <= 0) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      if (rows.length > 200) {
        this.$message.warning(this.$t('SeaExport.maxSelectBusiness', ['200']))
        return
      }
      this.batchModifyBusinessDialog.lob = this.lob
      this.batchModifyBusinessDialog.jobList = rows
      this.batchModifyBusinessDialog.jobKeys = Array.from(rows, p => p.uuid)
      this.batchModifyBusinessDialog.visible = true
    },
    // 批量修改业务成功后，弹窗回调
    batchModifyBusinessCallback() {
      this.toQuery()
    },
    // 批量更换SOP模板
    toBatchUpdateSopTemplate() {
      const rows = this.readSelectedRows()
      JobUtils.batchUpdateSopTemplate(this, rows)
    },
    // 批量发起协作
    toBatchCooperation() {
      this.batchCooperationDialog.jobList = this.readSelectedRows()
      this.batchCooperationDialog.visible = true
    },
    // 批量推送费用(交叉委托)
    toBatchSyncChargeConfirm() {
      const rows = this.readSelectedRows()
      const jobKeys = []
      for (const j of rows) {
        jobKeys.push(j.uuid)
      }
      this.loading = getLoading()
      syncChargeConfirmBatch(jobKeys).then(res => {
        this.$message.success(this.$t('queryJob.GenerateXChargeSyncRecords', { num: res.data }))
      }).finally(() => {
        this.loading.close()
      })
    },
    reload() {
      this.toQuery()
    },
    // 刷新表格
    refreshAgGrid() {
      this.gridApi.refreshCells({ force: true })
      this.gridApi.redrawRows()
    },
    // 批量修改自定义业务类型
    toBatchUpdateCustomType() {
      const rows = this.readSelectedRows()
      const jobKeys = []
      const jobList = []
      for (const j of rows) {
        if (this.isCooperate(j.cooperateStatus)) {
          this.$message.warning('[' + j.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (j.jobState !== SystemConstants.STATE_OPERATING.code) {
          this.$message.warning(this.$t(j.jobNo + this.$t('SeaExport.RecordNotPositiveOperationStatus')))
          return
        }
        jobKeys.push(j.uuid)
        jobList.push(j)
      }
      this.customJobTypeDialog.jobKeys = jobKeys
      this.customJobTypeDialog.jobList = jobList
      this.customJobTypeDialog.visible = true
    },
    customJobTypeClickHandler() {
      const jobs = this.customJobTypeDialog.jobList
      if (jobs != null && jobs.length > 0) {
        const obj = {}
        obj.jobUuids = this.customJobTypeDialog.jobKeys
        obj.customJobType = this.customJobTypeDialog.customJobType
        this.loading = getLoading()
        updateJobCustomJobType(obj).then(res => this.updateJobCustomJobTypeResult(res)).finally(() => {
          this.loading.close()
        })
      }
    },
    // 批量修改自定义业务类型 处理结果
    updateJobCustomJobTypeResult(res) {
      this.loading.close()
      if (res.data) {
        this.$message.success(this.$t('SeaExport.CustomJobTypeBatchModifySuccess') + res.data)
        for (const seaJob of this.customJobTypeDialog.jobList) {
          seaJob.customJobType = this.customJobTypeDialog.customJobType
        }
        this.refreshAgGrid()
      }
      this.customJobTypeDialog.visible = false
      this.customJobTypeDialog.customJobType = ''
      this.customJobTypeDialog.jobKeys = []
      this.customJobTypeDialog.jobList = []
    },
    // 批量解锁应收/应付费用
    async toBatchModifyChargeLockStatus(receivable) {
      const rows = this.readSelectedRows()
      const jobKeys = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (!await SecurityUtil.canEdit(new AirExportJob(item))) {
          this.$message.warning(this.$t('Message.NoPermissionToEditTheJob'))
          return
        }
        if (receivable) {
          if (item.receivableChargeLockedStatus !== 1) {
            this.$message.warning(this.$t('Message.BatchUnlockLockedBillsOfAccountsReceivable'))
            return
          }
        } else {
          if (item.payableChargeLockedStatus !== 1) {
            this.$message.warning(this.$t('Message.BatchUnlockLockedBillsOfAccountsPayable'))
            return
          }
        }
        jobKeys.push(item.uuid)
      }
      if (jobKeys.length > 0) {
        const t = receivable ? this.$t('Message.Receivable') : this.$t('Message.Payable')
        this.$confirm(this.$t('Message.UnlockChargeStatus', [t]), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.loading = getLoading()
          batchModifyChargeLockStatus({ uuids: jobKeys, receivable: receivable, lockStatus: 0, location: this.location }).then(res => {
            this.loading.close()
            if (res.data) {
              this.$message.success(this.$t('Message.SuccessfullyUnlockedFeesInBatch', [t, res.data]))
              this.toQuery()
            }
          }).finally(() => {
            this.loading.close()
          })
        })
      }
    },
    onGridSelectionChanged(event) {
      const allRow = event.api.getSelectedRows()
      this.selectedRows = []
      for (const row of allRow) {
        if (Number(row.dataType) === 1 || Number(row.dataType) === 2) {
          this.selectedRows.push(row)
        }
      }
      this.selectedRowCount = this.selectedRows.length
    },
    mactchCooperateBranch(cooperateBranch, office) {
      if (cooperateBranch && office) {
        const list = cooperateBranch.split(' | ')
        if (list && list.length > 0) {
          for (const officeName of list) {
            if (officeName === office.chineseName) {
              return true
            }
          }
        }
      }
      return false
    },
    // 批量更换分公司
    toBatchModifyBranch() {
      const rows = this.readSelectedRows()
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      this.modifyBranchDialog.jobKeys = Array.from(rows, p => p.uuid)
      this.modifyBranchDialog.visible = true
    },
    // 批量锁定买价/卖价
    async toBatchPurchasePriceLock(type) {
      const rows = this.readSelectedRows()
      const jobKeys = []
      for (const item of rows) {
        if (type) {
          if (item.purchasePriceLock) {
            this.$message.warning(this.$t('Message.BatchPurchasePriceLock'))
            return
          }
        } else {
          if (item.sellingPriceLock) {
            this.$message.warning(this.$t('Message.BatchSellingPriceLock'))
            return
          }
        }
        jobKeys.push(item.uuid)
      }
      if (jobKeys.length > 0) {
        this.$confirm(type ? this.$t('CargoMsg.Cargo_ConfirmLockLabelBuyingPrice') : this.$t('CargoMsg.Cargo_ConfirmLockLabelSellingPrice'), this.$t('Message.Confirm'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }).then(() => {
          this.loading = getLoading()
          updateBatchPriceLockFunc({ uuids: jobKeys, type: type, lock: true }).then(res => {
            this.loading.close()
            if (res.data) {
              this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
              this.toQuery()
            }
          }).finally(() => {
            this.loading.close()
          })
        })
      }
    },
    // 批量解锁买价/卖价
    async toBatchPurchasePriceUnlock(type) {
      const rows = this.readSelectedRows()
      const jobKeys = []
      for (const item of rows) {
        if (type) {
          if (!item.purchasePriceLock) {
            this.$message.warning(this.$t('Message.BatchPurchasePriceUnLock'))
            return
          }
        } else {
          if (!item.sellingPriceLock) {
            this.$message.warning(this.$t('Message.BatchSellingPriceUnLock'))
            return
          }
        }
        jobKeys.push(item.uuid)
      }
      if (jobKeys.length > 0) {
        this.$confirm(type ? this.$t('CargoMsg.Cargo_ConfirmUnlockLabelBuyingPrice') : this.$t('CargoMsg.Cargo_ConfirmUnlockLabelSellingPrice'), this.$t('Message.Confirm'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }).then(() => {
          this.loading = getLoading()
          updateBatchPriceLockFunc({ uuids: jobKeys, type: type, lock: false }).then(res => {
            this.loading.close()
            if (res.data) {
              this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
              this.toQuery()
            }
          }).finally(() => {
            this.loading.close()
          })
        })
      }
    },
    toChangeSchema() {
      // 先打开费用方案弹框，选择方案后再带入到新增费用弹框
      this.toImportCharge()
    },
    // 处理费用方案选择
    handleSelectedScheme(selectedScheme) {
      // 关闭费用方案弹框
      this.chargeSchemeBatchDialog.visible = false
      // 打开新增费用弹框，并带入选择的费用方案
      this.addChargeDetailDialog.selectedJobs = this.readSelectedRows()
      this.addChargeDetailDialog.chargeType = this.chargeTypeDialog.type
      this.addChargeDetailDialog.selectedScheme = selectedScheme
      this.addChargeDetailDialog.visible = true
    }
  }
}
</script>

<style lang="scss">
.el-dropdown-spacing {
  padding-left: 5px;
}
</style>
